"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.abi = void 0;
exports.abi = {
    "Multicall2": [
        {
            "inputs": [
                {
                    "components": [
                        {
                            "internalType": "address",
                            "name": "target",
                            "type": "address"
                        },
                        {
                            "internalType": "bytes",
                            "name": "callData",
                            "type": "bytes"
                        }
                    ],
                    "internalType": "struct Multicall2.Call[]",
                    "name": "calls",
                    "type": "tuple[]"
                }
            ],
            "name": "aggregate",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "blockNumber",
                    "type": "uint256"
                },
                {
                    "internalType": "bytes[]",
                    "name": "returnData",
                    "type": "bytes[]"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "components": [
                        {
                            "internalType": "address",
                            "name": "target",
                            "type": "address"
                        },
                        {
                            "internalType": "bytes",
                            "name": "callData",
                            "type": "bytes"
                        }
                    ],
                    "internalType": "struct Multicall2.Call[]",
                    "name": "calls",
                    "type": "tuple[]"
                }
            ],
            "name": "blockAndAggregate",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "blockNumber",
                    "type": "uint256"
                },
                {
                    "internalType": "bytes32",
                    "name": "blockHash",
                    "type": "bytes32"
                },
                {
                    "components": [
                        {
                            "internalType": "bool",
                            "name": "success",
                            "type": "bool"
                        },
                        {
                            "internalType": "bytes",
                            "name": "returnData",
                            "type": "bytes"
                        }
                    ],
                    "internalType": "struct Multicall2.Result[]",
                    "name": "returnData",
                    "type": "tuple[]"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "blockNumber",
                    "type": "uint256"
                }
            ],
            "name": "getBlockHash",
            "outputs": [
                {
                    "internalType": "bytes32",
                    "name": "blockHash",
                    "type": "bytes32"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "getBlockNumber",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "blockNumber",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "getCurrentBlockCoinbase",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "coinbase",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "getCurrentBlockDifficulty",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "difficulty",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "getCurrentBlockGasLimit",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "gaslimit",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "getCurrentBlockTimestamp",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "timestamp",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "addr",
                    "type": "address"
                }
            ],
            "name": "getEthBalance",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "balance",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "getLastBlockHash",
            "outputs": [
                {
                    "internalType": "bytes32",
                    "name": "blockHash",
                    "type": "bytes32"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bool",
                    "name": "requireSuccess",
                    "type": "bool"
                },
                {
                    "components": [
                        {
                            "internalType": "address",
                            "name": "target",
                            "type": "address"
                        },
                        {
                            "internalType": "bytes",
                            "name": "callData",
                            "type": "bytes"
                        }
                    ],
                    "internalType": "struct Multicall2.Call[]",
                    "name": "calls",
                    "type": "tuple[]"
                }
            ],
            "name": "tryAggregate",
            "outputs": [
                {
                    "components": [
                        {
                            "internalType": "bool",
                            "name": "success",
                            "type": "bool"
                        },
                        {
                            "internalType": "bytes",
                            "name": "returnData",
                            "type": "bytes"
                        }
                    ],
                    "internalType": "struct Multicall2.Result[]",
                    "name": "returnData",
                    "type": "tuple[]"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bool",
                    "name": "requireSuccess",
                    "type": "bool"
                },
                {
                    "components": [
                        {
                            "internalType": "address",
                            "name": "target",
                            "type": "address"
                        },
                        {
                            "internalType": "bytes",
                            "name": "callData",
                            "type": "bytes"
                        }
                    ],
                    "internalType": "struct Multicall2.Call[]",
                    "name": "calls",
                    "type": "tuple[]"
                }
            ],
            "name": "tryBlockAndAggregate",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "blockNumber",
                    "type": "uint256"
                },
                {
                    "internalType": "bytes32",
                    "name": "blockHash",
                    "type": "bytes32"
                },
                {
                    "components": [
                        {
                            "internalType": "bool",
                            "name": "success",
                            "type": "bool"
                        },
                        {
                            "internalType": "bytes",
                            "name": "returnData",
                            "type": "bytes"
                        }
                    ],
                    "internalType": "struct Multicall2.Result[]",
                    "name": "returnData",
                    "type": "tuple[]"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        }
    ],
    "SumerErrors": [
        {
            "inputs": [],
            "name": "AddReservesMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "AddReservesOverflow",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "BorrowAndDepositBackFailed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "BorrowCapReached",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "BorrowCashNotAvailable",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "BorrowMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "BorrowPaused",
            "type": "error"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "usdThreshold",
                    "type": "uint256"
                }
            ],
            "name": "BorrowValueMustBeLargerThanThreshold",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "CantEnterPausedMarket",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "CantExitMarketWithNonZeroBorrowBalance",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "CantSweepUnderlying",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ComptrollerMismatch",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "EitherAssetOrDebtMustBeZero",
            "type": "error"
        },
        {
            "inputs": [
                {
                    "internalType": "uint8",
                    "name": "groupId",
                    "type": "uint8"
                },
                {
                    "internalType": "uint256",
                    "name": "cDepositVal",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "suDepositVal",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "cBorrowVal",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "suBorrowVal",
                    "type": "uint256"
                }
            ],
            "name": "EitherAssetOrDebtMustBeZeroInGroup",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ExpiredSignature",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InsufficientCollateral",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InsufficientShortfall",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InterMintNotAllowed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidAddress",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidAmount",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidBlockNumber",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidCToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidCloseFactor",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidComptroller",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidDiscountRate",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidExchangeRate",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidGroupId",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidInput",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidInterestRateModel",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidMinSuBorrowValue",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidRedeem",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidReduceAmount",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidReserveFactor",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidSignatureForRedeemFaceValue",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidSignatureLength",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidSuToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidTimestamp",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateBorrow_LiquidatorIsBorrower",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateBorrow_RepayAmountIsMax",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateBorrow_RepayAmountIsZero",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateBorrow_SeizeTooMuch",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateCollateralMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketAlreadyListed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketAlreadyUnlisted",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketCanOnlyInitializeOnce",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketNotEmpty",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketNotListed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketPaused",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MinDelayNotReached",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MintMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MintPaused",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MintTokensCantBeZero",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NoRedemptionProvider",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotCToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotEnoughForSeize",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotEnoughRedeemAmount",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotEnoughRedeemTokens",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotEnoughUnderlyingAfterRedeem",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotEnoughUnderlyingForMint",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotLiquidatableYet",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotSuToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyAdmin",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyAdminOrPauser",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyCToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyListedCToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyPausedMarketCanBeUnlisted",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyPendingAdmin",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyRedemptionManager",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OverThreshold",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "PriceError",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ProtectedMint_OnlyAllowAssetsInTheSameGroup",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RedeemMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RedeemTransferOutNotPossible",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RedemptionSeizeTooMuch",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RedemptionSignerNotInitialized",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ReduceReservesCashNotAvailable",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ReduceReservesMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "Reentered",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RepayBorrowMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RepayTokenNotListed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SeizePaused",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SeizeTokenNotListed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "Seize_LiquidatorIsBorrower",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SenderMustBeCToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SetInterestRateModelMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SetReservesFactorMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SupplyCapReached",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TokenInOrAmountInMustBeZero",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TokenTransferInFailed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TokenTransferOutFailed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TooMuchRepay",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TotalBorrowsNotZero",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TotalSupplyNotZero",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TransferNotAllowed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TransferPaused",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "UnderlyingBalanceError",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ZeroAddressNotAllowed",
            "type": "error"
        }
    ],
    "SumerTimelockController": [
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "minDelay",
                    "type": "uint256"
                },
                {
                    "internalType": "address[]",
                    "name": "proposers",
                    "type": "address[]"
                },
                {
                    "internalType": "address[]",
                    "name": "executors",
                    "type": "address[]"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "constructor"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "bytes32",
                    "name": "id",
                    "type": "bytes32"
                },
                {
                    "indexed": true,
                    "internalType": "uint256",
                    "name": "index",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "target",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "value",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "bytes",
                    "name": "data",
                    "type": "bytes"
                }
            ],
            "name": "CallExecuted",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "bytes32",
                    "name": "id",
                    "type": "bytes32"
                },
                {
                    "indexed": true,
                    "internalType": "uint256",
                    "name": "index",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "target",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "value",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "bytes",
                    "name": "data",
                    "type": "bytes"
                },
                {
                    "indexed": false,
                    "internalType": "bytes32",
                    "name": "predecessor",
                    "type": "bytes32"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "delay",
                    "type": "uint256"
                }
            ],
            "name": "CallScheduled",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "bytes32",
                    "name": "id",
                    "type": "bytes32"
                }
            ],
            "name": "Cancelled",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "oldDuration",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "newDuration",
                    "type": "uint256"
                }
            ],
            "name": "MinDelayChange",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "indexed": true,
                    "internalType": "bytes32",
                    "name": "previousAdminRole",
                    "type": "bytes32"
                },
                {
                    "indexed": true,
                    "internalType": "bytes32",
                    "name": "newAdminRole",
                    "type": "bytes32"
                }
            ],
            "name": "RoleAdminChanged",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "sender",
                    "type": "address"
                }
            ],
            "name": "RoleGranted",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "sender",
                    "type": "address"
                }
            ],
            "name": "RoleRevoked",
            "type": "event"
        },
        {
            "inputs": [],
            "name": "CANCELLER_ROLE",
            "outputs": [
                {
                    "internalType": "bytes32",
                    "name": "",
                    "type": "bytes32"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "DEFAULT_ADMIN_ROLE",
            "outputs": [
                {
                    "internalType": "bytes32",
                    "name": "",
                    "type": "bytes32"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "EXECUTOR_ROLE",
            "outputs": [
                {
                    "internalType": "bytes32",
                    "name": "",
                    "type": "bytes32"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "PROPOSER_ROLE",
            "outputs": [
                {
                    "internalType": "bytes32",
                    "name": "",
                    "type": "bytes32"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "TIMELOCK_ADMIN_ROLE",
            "outputs": [
                {
                    "internalType": "bytes32",
                    "name": "",
                    "type": "bytes32"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "id",
                    "type": "bytes32"
                }
            ],
            "name": "cancel",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "target",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "value",
                    "type": "uint256"
                },
                {
                    "internalType": "bytes",
                    "name": "payload",
                    "type": "bytes"
                },
                {
                    "internalType": "bytes32",
                    "name": "predecessor",
                    "type": "bytes32"
                },
                {
                    "internalType": "bytes32",
                    "name": "salt",
                    "type": "bytes32"
                }
            ],
            "name": "execute",
            "outputs": [],
            "stateMutability": "payable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address[]",
                    "name": "targets",
                    "type": "address[]"
                },
                {
                    "internalType": "uint256[]",
                    "name": "values",
                    "type": "uint256[]"
                },
                {
                    "internalType": "bytes[]",
                    "name": "payloads",
                    "type": "bytes[]"
                },
                {
                    "internalType": "bytes32",
                    "name": "predecessor",
                    "type": "bytes32"
                },
                {
                    "internalType": "bytes32",
                    "name": "salt",
                    "type": "bytes32"
                }
            ],
            "name": "executeBatch",
            "outputs": [],
            "stateMutability": "payable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "getMinDelay",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "duration",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                }
            ],
            "name": "getRoleAdmin",
            "outputs": [
                {
                    "internalType": "bytes32",
                    "name": "",
                    "type": "bytes32"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "id",
                    "type": "bytes32"
                }
            ],
            "name": "getTimestamp",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "timestamp",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "grantRole",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "hasRole",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "target",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "value",
                    "type": "uint256"
                },
                {
                    "internalType": "bytes",
                    "name": "data",
                    "type": "bytes"
                },
                {
                    "internalType": "bytes32",
                    "name": "predecessor",
                    "type": "bytes32"
                },
                {
                    "internalType": "bytes32",
                    "name": "salt",
                    "type": "bytes32"
                }
            ],
            "name": "hashOperation",
            "outputs": [
                {
                    "internalType": "bytes32",
                    "name": "hash",
                    "type": "bytes32"
                }
            ],
            "stateMutability": "pure",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address[]",
                    "name": "targets",
                    "type": "address[]"
                },
                {
                    "internalType": "uint256[]",
                    "name": "values",
                    "type": "uint256[]"
                },
                {
                    "internalType": "bytes[]",
                    "name": "payloads",
                    "type": "bytes[]"
                },
                {
                    "internalType": "bytes32",
                    "name": "predecessor",
                    "type": "bytes32"
                },
                {
                    "internalType": "bytes32",
                    "name": "salt",
                    "type": "bytes32"
                }
            ],
            "name": "hashOperationBatch",
            "outputs": [
                {
                    "internalType": "bytes32",
                    "name": "hash",
                    "type": "bytes32"
                }
            ],
            "stateMutability": "pure",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "id",
                    "type": "bytes32"
                }
            ],
            "name": "isOperation",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "registered",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "id",
                    "type": "bytes32"
                }
            ],
            "name": "isOperationDone",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "done",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "id",
                    "type": "bytes32"
                }
            ],
            "name": "isOperationPending",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "pending",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "id",
                    "type": "bytes32"
                }
            ],
            "name": "isOperationReady",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "ready",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                },
                {
                    "internalType": "uint256[]",
                    "name": "",
                    "type": "uint256[]"
                },
                {
                    "internalType": "uint256[]",
                    "name": "",
                    "type": "uint256[]"
                },
                {
                    "internalType": "bytes",
                    "name": "",
                    "type": "bytes"
                }
            ],
            "name": "onERC1155BatchReceived",
            "outputs": [
                {
                    "internalType": "bytes4",
                    "name": "",
                    "type": "bytes4"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                },
                {
                    "internalType": "bytes",
                    "name": "",
                    "type": "bytes"
                }
            ],
            "name": "onERC1155Received",
            "outputs": [
                {
                    "internalType": "bytes4",
                    "name": "",
                    "type": "bytes4"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                },
                {
                    "internalType": "bytes",
                    "name": "",
                    "type": "bytes"
                }
            ],
            "name": "onERC721Received",
            "outputs": [
                {
                    "internalType": "bytes4",
                    "name": "",
                    "type": "bytes4"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "renounceRole",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "revokeRole",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "target",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "value",
                    "type": "uint256"
                },
                {
                    "internalType": "bytes",
                    "name": "data",
                    "type": "bytes"
                },
                {
                    "internalType": "bytes32",
                    "name": "predecessor",
                    "type": "bytes32"
                },
                {
                    "internalType": "bytes32",
                    "name": "salt",
                    "type": "bytes32"
                },
                {
                    "internalType": "uint256",
                    "name": "delay",
                    "type": "uint256"
                }
            ],
            "name": "schedule",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address[]",
                    "name": "targets",
                    "type": "address[]"
                },
                {
                    "internalType": "uint256[]",
                    "name": "values",
                    "type": "uint256[]"
                },
                {
                    "internalType": "bytes[]",
                    "name": "payloads",
                    "type": "bytes[]"
                },
                {
                    "internalType": "bytes32",
                    "name": "predecessor",
                    "type": "bytes32"
                },
                {
                    "internalType": "bytes32",
                    "name": "salt",
                    "type": "bytes32"
                },
                {
                    "internalType": "uint256",
                    "name": "delay",
                    "type": "uint256"
                }
            ],
            "name": "scheduleBatch",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes4",
                    "name": "interfaceId",
                    "type": "bytes4"
                }
            ],
            "name": "supportsInterface",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "newDelay",
                    "type": "uint256"
                }
            ],
            "name": "updateDelay",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "stateMutability": "payable",
            "type": "receive"
        }
    ],
    "Test": [
        {
            "inputs": [],
            "name": "getBlockNumber",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "a",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "b",
                    "type": "uint256"
                }
            ],
            "name": "mul",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "a",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "b",
                    "type": "uint256"
                }
            ],
            "name": "mulTruncate",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        }
    ],
    "Timelock": [
        {
            "inputs": [],
            "stateMutability": "nonpayable",
            "type": "constructor"
        },
        {
            "inputs": [],
            "name": "AddReservesMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "AddReservesOverflow",
            "type": "error"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "minWaitInSeconds",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "available",
                    "type": "uint256"
                }
            ],
            "name": "AggregateValueRateLimitReached",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "BorrowAndDepositBackFailed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "BorrowCapReached",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "BorrowCashNotAvailable",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "BorrowMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "BorrowPaused",
            "type": "error"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "usdThreshold",
                    "type": "uint256"
                }
            ],
            "name": "BorrowValueMustBeLargerThanThreshold",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "CantEnterPausedMarket",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "CantExitMarketWithNonZeroBorrowBalance",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "CantSweepUnderlying",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ComptrollerMismatch",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "EitherAssetOrDebtMustBeZero",
            "type": "error"
        },
        {
            "inputs": [
                {
                    "internalType": "uint8",
                    "name": "groupId",
                    "type": "uint8"
                },
                {
                    "internalType": "uint256",
                    "name": "cDepositVal",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "suDepositVal",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "cBorrowVal",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "suBorrowVal",
                    "type": "uint256"
                }
            ],
            "name": "EitherAssetOrDebtMustBeZeroInGroup",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ExpiredSignature",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InsufficientCollateral",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InsufficientShortfall",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InterMintNotAllowed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidAddress",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidAmount",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidBlockNumber",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidCToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidCloseFactor",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidComptroller",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidDiscountRate",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidExchangeRate",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidGroupId",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidInput",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidInterestRateModel",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidMinSuBorrowValue",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidRedeem",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidReduceAmount",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidReserveFactor",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidSignatureForRedeemFaceValue",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidSignatureLength",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidSuToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidTimestamp",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateBorrow_LiquidatorIsBorrower",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateBorrow_RepayAmountIsMax",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateBorrow_RepayAmountIsZero",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateBorrow_SeizeTooMuch",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateCollateralMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketAlreadyListed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketAlreadyUnlisted",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketCanOnlyInitializeOnce",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketNotEmpty",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketNotListed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketPaused",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MinDelayNotReached",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MintMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MintPaused",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MintTokensCantBeZero",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NoRedemptionProvider",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotCToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotEnoughForSeize",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotEnoughRedeemAmount",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotEnoughRedeemTokens",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotEnoughUnderlyingAfterRedeem",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotEnoughUnderlyingForMint",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotLiquidatableYet",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotSuToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyAdmin",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyAdminOrPauser",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyCToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyListedCToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyPausedMarketCanBeUnlisted",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyPendingAdmin",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyRedemptionManager",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OverThreshold",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "PriceError",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ProtectedMint_OnlyAllowAssetsInTheSameGroup",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RedeemMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RedeemTransferOutNotPossible",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RedemptionSeizeTooMuch",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RedemptionSignerNotInitialized",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ReduceReservesCashNotAvailable",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ReduceReservesMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "Reentered",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RepayBorrowMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RepayTokenNotListed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SeizePaused",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SeizeTokenNotListed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "Seize_LiquidatorIsBorrower",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SenderMustBeCToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SetInterestRateModelMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SetReservesFactorMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SupplyCapReached",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TokenInOrAmountInMustBeZero",
            "type": "error"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "minWaitInSeconds",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "available",
                    "type": "uint256"
                },
                {
                    "internalType": "address",
                    "name": "tokenAddress",
                    "type": "address"
                }
            ],
            "name": "TokenRateLimitReached",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TokenTransferInFailed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TokenTransferOutFailed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TooMuchRepay",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TotalBorrowsNotZero",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TotalSupplyNotZero",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TransferNotAllowed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TransferPaused",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "UnderlyingBalanceError",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ZeroAddressNotAllowed",
            "type": "error"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "uint256",
                    "name": "agreementId",
                    "type": "uint256"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "beneficiary",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "asset",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "enum ITimelock.TimeLockActionType",
                    "name": "actionType",
                    "type": "uint8"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                }
            ],
            "name": "AgreementClaimed",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "uint256",
                    "name": "agreementId",
                    "type": "uint256"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "beneficiary",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "asset",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "enum ITimelock.TimeLockActionType",
                    "name": "actionType",
                    "type": "uint8"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "timestamp",
                    "type": "uint256"
                }
            ],
            "name": "AgreementCreated",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "agreementId",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "bool",
                    "name": "value",
                    "type": "bool"
                }
            ],
            "name": "AgreementFrozen",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "components": [
                        {
                            "internalType": "bool",
                            "name": "isEnabled",
                            "type": "bool"
                        },
                        {
                            "internalType": "uint256",
                            "name": "capacity",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "rate",
                            "type": "uint256"
                        }
                    ],
                    "indexed": false,
                    "internalType": "struct RateLimiter.Config",
                    "name": "config",
                    "type": "tuple"
                }
            ],
            "name": "ConfigChanged",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "uint8",
                    "name": "version",
                    "type": "uint8"
                }
            ],
            "name": "Initialized",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "oldRate",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "newRate",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "oldCapacity",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "newCapacity",
                    "type": "uint256"
                }
            ],
            "name": "NewLimiter",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "uint48",
                    "name": "oldValue",
                    "type": "uint48"
                },
                {
                    "indexed": false,
                    "internalType": "uint48",
                    "name": "newValue",
                    "type": "uint48"
                }
            ],
            "name": "NewMaxDelay",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "uint48",
                    "name": "oldValue",
                    "type": "uint48"
                },
                {
                    "indexed": false,
                    "internalType": "uint48",
                    "name": "newValue",
                    "type": "uint48"
                }
            ],
            "name": "NewMinDelay",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "oldValue",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "newValue",
                    "type": "uint256"
                }
            ],
            "name": "NewThreshold",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "agreementId",
                    "type": "uint256"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "underlyToken",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "to",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "underlyAmount",
                    "type": "uint256"
                }
            ],
            "name": "RescueAgreement",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "indexed": true,
                    "internalType": "bytes32",
                    "name": "previousAdminRole",
                    "type": "bytes32"
                },
                {
                    "indexed": true,
                    "internalType": "bytes32",
                    "name": "newAdminRole",
                    "type": "bytes32"
                }
            ],
            "name": "RoleAdminChanged",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "sender",
                    "type": "address"
                }
            ],
            "name": "RoleGranted",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "sender",
                    "type": "address"
                }
            ],
            "name": "RoleRevoked",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "bool",
                    "name": "value",
                    "type": "bool"
                }
            ],
            "name": "TimeLockFrozen",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "tokens",
                    "type": "uint256"
                }
            ],
            "name": "TokensConsumed",
            "type": "event"
        },
        {
            "inputs": [],
            "name": "DEFAULT_ADMIN_ROLE",
            "outputs": [
                {
                    "internalType": "bytes32",
                    "name": "",
                    "type": "bytes32"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "EMERGENCY_ADMIN",
            "outputs": [
                {
                    "internalType": "bytes32",
                    "name": "",
                    "type": "bytes32"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "agreementCount",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "name": "agreements",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "isFrozen",
                    "type": "bool"
                },
                {
                    "internalType": "enum ITimelock.TimeLockActionType",
                    "name": "actionType",
                    "type": "uint8"
                },
                {
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "beneficiary",
                    "type": "address"
                },
                {
                    "internalType": "uint48",
                    "name": "timestamp",
                    "type": "uint48"
                },
                {
                    "internalType": "uint256",
                    "name": "agreementId",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "underlyAmount",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "balances",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256[]",
                    "name": "agreementIds",
                    "type": "uint256[]"
                }
            ],
            "name": "claim",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "comptroller",
            "outputs": [
                {
                    "internalType": "contract IComptroller",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "underlyAmount",
                    "type": "uint256"
                }
            ],
            "name": "consumeValue",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "underlyAmount",
                    "type": "uint256"
                },
                {
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                }
            ],
            "name": "consumeValuePreview",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "enum ITimelock.TimeLockActionType",
                    "name": "actionType",
                    "type": "uint8"
                },
                {
                    "internalType": "uint256",
                    "name": "underlyAmount",
                    "type": "uint256"
                },
                {
                    "internalType": "address",
                    "name": "beneficiary",
                    "type": "address"
                }
            ],
            "name": "createAgreement",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "currentState",
            "outputs": [
                {
                    "components": [
                        {
                            "internalType": "uint256",
                            "name": "tokens",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint32",
                            "name": "lastUpdated",
                            "type": "uint32"
                        },
                        {
                            "internalType": "bool",
                            "name": "isEnabled",
                            "type": "bool"
                        },
                        {
                            "internalType": "uint256",
                            "name": "capacity",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "rate",
                            "type": "uint256"
                        }
                    ],
                    "internalType": "struct RateLimiter.TokenBucket",
                    "name": "",
                    "type": "tuple"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "freeze",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "agreementId",
                    "type": "uint256"
                }
            ],
            "name": "freezeAgreement",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "frozen",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "agreementId",
                    "type": "uint256"
                }
            ],
            "name": "getMinWaitInSeconds",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                }
            ],
            "name": "getRoleAdmin",
            "outputs": [
                {
                    "internalType": "bytes32",
                    "name": "",
                    "type": "bytes32"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "internalType": "uint256",
                    "name": "index",
                    "type": "uint256"
                }
            ],
            "name": "getRoleMember",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                }
            ],
            "name": "getRoleMemberCount",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "grantRole",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "hasRole",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_admin",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "rate",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "capacity",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "_threshold",
                    "type": "uint256"
                }
            ],
            "name": "initialize",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "agreementId",
                    "type": "uint256"
                }
            ],
            "name": "isAgreementMature",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "maxDelay",
            "outputs": [
                {
                    "internalType": "uint48",
                    "name": "",
                    "type": "uint48"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "minDelay",
            "outputs": [
                {
                    "internalType": "uint48",
                    "name": "",
                    "type": "uint48"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "renounceRole",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "agreementId",
                    "type": "uint256"
                },
                {
                    "internalType": "address",
                    "name": "to",
                    "type": "address"
                }
            ],
            "name": "rescueAgreement",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "revokeRole",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_comptroller",
                    "type": "address"
                }
            ],
            "name": "setComptroller",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "newRate",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "newCapacity",
                    "type": "uint256"
                }
            ],
            "name": "setLimiter",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint48",
                    "name": "newMaxDelayInSeconds",
                    "type": "uint48"
                }
            ],
            "name": "setMaxDelay",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint48",
                    "name": "newMinDelayInSeconds",
                    "type": "uint48"
                }
            ],
            "name": "setMinDelay",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "components": [
                        {
                            "internalType": "bool",
                            "name": "isEnabled",
                            "type": "bool"
                        },
                        {
                            "internalType": "uint256",
                            "name": "capacity",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "rate",
                            "type": "uint256"
                        }
                    ],
                    "internalType": "struct RateLimiter.Config",
                    "name": "config",
                    "type": "tuple"
                }
            ],
            "name": "setRateLimiterConfig",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "newThreshold",
                    "type": "uint256"
                }
            ],
            "name": "setThreshold",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes4",
                    "name": "interfaceId",
                    "type": "bytes4"
                }
            ],
            "name": "supportsInterface",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "threshold",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "unfreeze",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "agreementId",
                    "type": "uint256"
                }
            ],
            "name": "unfreezeAgreement",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "user",
                    "type": "address"
                }
            ],
            "name": "userAgreements",
            "outputs": [
                {
                    "components": [
                        {
                            "internalType": "bool",
                            "name": "isFrozen",
                            "type": "bool"
                        },
                        {
                            "internalType": "enum ITimelock.TimeLockActionType",
                            "name": "actionType",
                            "type": "uint8"
                        },
                        {
                            "internalType": "address",
                            "name": "cToken",
                            "type": "address"
                        },
                        {
                            "internalType": "address",
                            "name": "beneficiary",
                            "type": "address"
                        },
                        {
                            "internalType": "uint48",
                            "name": "timestamp",
                            "type": "uint48"
                        },
                        {
                            "internalType": "uint256",
                            "name": "agreementId",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "underlyAmount",
                            "type": "uint256"
                        }
                    ],
                    "internalType": "struct ITimelock.Agreement[]",
                    "name": "",
                    "type": "tuple[]"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "stateMutability": "payable",
            "type": "receive"
        }
    ],
    "CErc20": [
        {
            "inputs": [],
            "stateMutability": "nonpayable",
            "type": "constructor"
        },
        {
            "inputs": [],
            "name": "AddReservesMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "AddReservesOverflow",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "BorrowAndDepositBackFailed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "BorrowCapReached",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "BorrowCashNotAvailable",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "BorrowMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "BorrowPaused",
            "type": "error"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "usdThreshold",
                    "type": "uint256"
                }
            ],
            "name": "BorrowValueMustBeLargerThanThreshold",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "CantEnterPausedMarket",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "CantExitMarketWithNonZeroBorrowBalance",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "CantSweepUnderlying",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ComptrollerMismatch",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "EitherAssetOrDebtMustBeZero",
            "type": "error"
        },
        {
            "inputs": [
                {
                    "internalType": "uint8",
                    "name": "groupId",
                    "type": "uint8"
                },
                {
                    "internalType": "uint256",
                    "name": "cDepositVal",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "suDepositVal",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "cBorrowVal",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "suBorrowVal",
                    "type": "uint256"
                }
            ],
            "name": "EitherAssetOrDebtMustBeZeroInGroup",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ExpiredSignature",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InsufficientCollateral",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InsufficientShortfall",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InterMintNotAllowed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidAddress",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidAmount",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidBlockNumber",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidCToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidCloseFactor",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidComptroller",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidDiscountRate",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidExchangeRate",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidGroupId",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidInput",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidInterestRateModel",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidMinSuBorrowValue",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidRedeem",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidReduceAmount",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidReserveFactor",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidSignatureForRedeemFaceValue",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidSignatureLength",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidSuToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidTimestamp",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateBorrow_LiquidatorIsBorrower",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateBorrow_RepayAmountIsMax",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateBorrow_RepayAmountIsZero",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateBorrow_SeizeTooMuch",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateCollateralMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketAlreadyListed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketAlreadyUnlisted",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketCanOnlyInitializeOnce",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketNotEmpty",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketNotListed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketPaused",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MinDelayNotReached",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MintMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MintPaused",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MintTokensCantBeZero",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NoRedemptionProvider",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotCToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotEnoughForSeize",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotEnoughRedeemAmount",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotEnoughRedeemTokens",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotEnoughUnderlyingAfterRedeem",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotEnoughUnderlyingForMint",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotLiquidatableYet",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotSuToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyAdmin",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyAdminOrPauser",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyCToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyListedCToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyPausedMarketCanBeUnlisted",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyPendingAdmin",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyRedemptionManager",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OverThreshold",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "PriceError",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ProtectedMint_OnlyAllowAssetsInTheSameGroup",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RedeemMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RedeemTransferOutNotPossible",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RedemptionSeizeTooMuch",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RedemptionSignerNotInitialized",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ReduceReservesCashNotAvailable",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ReduceReservesMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "Reentered",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RepayBorrowMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RepayTokenNotListed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SeizePaused",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SeizeTokenNotListed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "Seize_LiquidatorIsBorrower",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SenderMustBeCToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SetInterestRateModelMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SetReservesFactorMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SupplyCapReached",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TokenInOrAmountInMustBeZero",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TokenTransferInFailed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TokenTransferOutFailed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TooMuchRepay",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TotalBorrowsNotZero",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TotalSupplyNotZero",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TransferNotAllowed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TransferPaused",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "UnderlyingBalanceError",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ZeroAddressNotAllowed",
            "type": "error"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "cashPrior",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "interestAccumulated",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "borrowIndex",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "totalBorrows",
                    "type": "uint256"
                }
            ],
            "name": "AccrueInterest",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "owner",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "spender",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                }
            ],
            "name": "Approval",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "borrower",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "borrowAmount",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "accountBorrows",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "totalBorrows",
                    "type": "uint256"
                }
            ],
            "name": "Borrow",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "uint8",
                    "name": "version",
                    "type": "uint8"
                }
            ],
            "name": "Initialized",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "liquidator",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "borrower",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "repayAmount",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "cTokenCollateral",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "seizeTokens",
                    "type": "uint256"
                }
            ],
            "name": "LiquidateBorrow",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "minter",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "mintAmount",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "mintTokens",
                    "type": "uint256"
                }
            ],
            "name": "Mint",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "oldAdmin",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "newAdmin",
                    "type": "address"
                }
            ],
            "name": "NewAdmin",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "oldComptroller",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "newComptroller",
                    "type": "address"
                }
            ],
            "name": "NewComptroller",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "oldDiscountRateMantissa",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "newDiscountRateMantissa",
                    "type": "uint256"
                }
            ],
            "name": "NewDiscountRate",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "oldInterestRateModel",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "newInterestRateModel",
                    "type": "address"
                }
            ],
            "name": "NewMarketInterestRateModel",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "oldPendingAdmin",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "newPendingAdmin",
                    "type": "address"
                }
            ],
            "name": "NewPendingAdmin",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "oldReserveFactorMantissa",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "newReserveFactorMantissa",
                    "type": "uint256"
                }
            ],
            "name": "NewReserveFactor",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "redeemer",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "redeemAmount",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "redeemTokens",
                    "type": "uint256"
                }
            ],
            "name": "Redeem",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "redeemer",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "provider",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "repayAmount",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "seizeToken",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "seizeAmount",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "redemptionRateMantissa",
                    "type": "uint256"
                }
            ],
            "name": "RedeemFaceValue",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "payer",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "borrower",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "repayAmount",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "accountBorrows",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "totalBorrows",
                    "type": "uint256"
                }
            ],
            "name": "RepayBorrow",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "benefactor",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "addAmount",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "newTotalReserves",
                    "type": "uint256"
                }
            ],
            "name": "ReservesAdded",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "admin",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "reduceAmount",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "newTotalReserves",
                    "type": "uint256"
                }
            ],
            "name": "ReservesReduced",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "from",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "to",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                }
            ],
            "name": "Transfer",
            "type": "event"
        },
        {
            "inputs": [],
            "name": "_acceptAdmin",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "addAmount",
                    "type": "uint256"
                }
            ],
            "name": "_addReserves",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "reduceAmount",
                    "type": "uint256"
                }
            ],
            "name": "_reduceReserves",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "newComptroller",
                    "type": "address"
                }
            ],
            "name": "_setComptroller",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "discountRateMantissa_",
                    "type": "uint256"
                }
            ],
            "name": "_setDiscountRate",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "newInterestRateModel",
                    "type": "address"
                }
            ],
            "name": "_setInterestRateModel",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address payable",
                    "name": "newPendingAdmin",
                    "type": "address"
                }
            ],
            "name": "_setPendingAdmin",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "newReserveFactorMantissa",
                    "type": "uint256"
                }
            ],
            "name": "_setReserveFactor",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "_syncUnderlyingBalance",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "accrualBlockTimestamp",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "accrueInterest",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "admin",
            "outputs": [
                {
                    "internalType": "address payable",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "owner",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "spender",
                    "type": "address"
                }
            ],
            "name": "allowance",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "spender",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                }
            ],
            "name": "approve",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "owner",
                    "type": "address"
                }
            ],
            "name": "balanceOf",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "owner",
                    "type": "address"
                }
            ],
            "name": "balanceOfUnderlying",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "borrowAmount",
                    "type": "uint256"
                }
            ],
            "name": "borrow",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "borrower",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "borrowAmount",
                    "type": "uint256"
                }
            ],
            "name": "borrowAndDepositBack",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "borrowBalanceCurrent",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "borrowBalanceStored",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "borrowIndex",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "borrowRatePerBlock",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "comptroller",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "decimals",
            "outputs": [
                {
                    "internalType": "uint8",
                    "name": "",
                    "type": "uint8"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "discountRateMantissa",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "exchangeRateCurrent",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "exchangeRateStored",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "getAccountSnapshot",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "getCash",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "underlying_",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "comptroller_",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "interestRateModel_",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "initialExchangeRateMantissa_",
                    "type": "uint256"
                },
                {
                    "internalType": "string",
                    "name": "name_",
                    "type": "string"
                },
                {
                    "internalType": "string",
                    "name": "symbol_",
                    "type": "string"
                },
                {
                    "internalType": "uint8",
                    "name": "decimals_",
                    "type": "uint8"
                },
                {
                    "internalType": "address payable",
                    "name": "admin_",
                    "type": "address"
                }
            ],
            "name": "initialize",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "interestRateModel",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "isCEther",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "pure",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "isCEtherDeprecated",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "isCToken",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "pure",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "isCTokenDeprecated",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "borrower",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "repayAmount",
                    "type": "uint256"
                },
                {
                    "internalType": "address",
                    "name": "cTokenCollateral",
                    "type": "address"
                }
            ],
            "name": "liquidateBorrow",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cTokenCollateral",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "actualRepayAmount",
                    "type": "uint256"
                }
            ],
            "name": "liquidateCalculateSeizeTokens",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "mintAmount",
                    "type": "uint256"
                }
            ],
            "name": "mint",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "mintAmount",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "deadline",
                    "type": "uint256"
                },
                {
                    "internalType": "bytes",
                    "name": "signature",
                    "type": "bytes"
                }
            ],
            "name": "mintWithPermit",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "name",
            "outputs": [
                {
                    "internalType": "string",
                    "name": "",
                    "type": "string"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "pendingAdmin",
            "outputs": [
                {
                    "internalType": "address payable",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "percentScale",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "protocolSeizeShareMantissa",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "redeemTokens",
                    "type": "uint256"
                }
            ],
            "name": "redeem",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "redeemAmount",
                    "type": "uint256"
                }
            ],
            "name": "redeemUnderlying",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "repayAmount",
                    "type": "uint256"
                }
            ],
            "name": "repayBorrow",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "borrower",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "repayAmount",
                    "type": "uint256"
                }
            ],
            "name": "repayBorrowBehalf",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "repayAmount",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "deadline",
                    "type": "uint256"
                },
                {
                    "internalType": "bytes",
                    "name": "signature",
                    "type": "bytes"
                }
            ],
            "name": "repayBorrowWithPermit",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "reserveFactorMantissa",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "liquidator",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "borrower",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "seizeTokens",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "seizeProfitTokens",
                    "type": "uint256"
                },
                {
                    "internalType": "bool",
                    "name": "isRedemption",
                    "type": "bool"
                },
                {
                    "internalType": "uint256",
                    "name": "redemptionRateMantissa",
                    "type": "uint256"
                }
            ],
            "name": "seize",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "supplyRatePerBlock",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "contract ERC20",
                    "name": "token",
                    "type": "address"
                }
            ],
            "name": "sweepToken",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "symbol",
            "outputs": [
                {
                    "internalType": "string",
                    "name": "",
                    "type": "string"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "tokenType",
            "outputs": [
                {
                    "internalType": "enum CToken.CTokenType",
                    "name": "",
                    "type": "uint8"
                }
            ],
            "stateMutability": "pure",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "totalBorrows",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "totalBorrowsCurrent",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "totalReserves",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "totalSupply",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "dst",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                }
            ],
            "name": "transfer",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "src",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "dst",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                }
            ],
            "name": "transferFrom",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "underlying",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "underlyingBalance",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        }
    ],
    "CEther": [
        {
            "inputs": [],
            "stateMutability": "nonpayable",
            "type": "constructor"
        },
        {
            "inputs": [],
            "name": "AddReservesMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "AddReservesOverflow",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "BorrowAndDepositBackFailed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "BorrowCapReached",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "BorrowCashNotAvailable",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "BorrowMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "BorrowPaused",
            "type": "error"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "usdThreshold",
                    "type": "uint256"
                }
            ],
            "name": "BorrowValueMustBeLargerThanThreshold",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "CantEnterPausedMarket",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "CantExitMarketWithNonZeroBorrowBalance",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "CantSweepUnderlying",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ComptrollerMismatch",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "EitherAssetOrDebtMustBeZero",
            "type": "error"
        },
        {
            "inputs": [
                {
                    "internalType": "uint8",
                    "name": "groupId",
                    "type": "uint8"
                },
                {
                    "internalType": "uint256",
                    "name": "cDepositVal",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "suDepositVal",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "cBorrowVal",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "suBorrowVal",
                    "type": "uint256"
                }
            ],
            "name": "EitherAssetOrDebtMustBeZeroInGroup",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ExpiredSignature",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InsufficientCollateral",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InsufficientShortfall",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InterMintNotAllowed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidAddress",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidAmount",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidBlockNumber",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidCToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidCloseFactor",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidComptroller",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidDiscountRate",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidExchangeRate",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidGroupId",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidInput",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidInterestRateModel",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidMinSuBorrowValue",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidRedeem",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidReduceAmount",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidReserveFactor",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidSignatureForRedeemFaceValue",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidSignatureLength",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidSuToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidTimestamp",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateBorrow_LiquidatorIsBorrower",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateBorrow_RepayAmountIsMax",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateBorrow_RepayAmountIsZero",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateBorrow_SeizeTooMuch",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateCollateralMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketAlreadyListed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketAlreadyUnlisted",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketCanOnlyInitializeOnce",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketNotEmpty",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketNotListed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketPaused",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MinDelayNotReached",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MintMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MintPaused",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MintTokensCantBeZero",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NoRedemptionProvider",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotCToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotEnoughForSeize",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotEnoughRedeemAmount",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotEnoughRedeemTokens",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotEnoughUnderlyingAfterRedeem",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotEnoughUnderlyingForMint",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotLiquidatableYet",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotSuToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyAdmin",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyAdminOrPauser",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyCToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyListedCToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyPausedMarketCanBeUnlisted",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyPendingAdmin",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyRedemptionManager",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OverThreshold",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "PriceError",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ProtectedMint_OnlyAllowAssetsInTheSameGroup",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RedeemMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RedeemTransferOutNotPossible",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RedemptionSeizeTooMuch",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RedemptionSignerNotInitialized",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ReduceReservesCashNotAvailable",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ReduceReservesMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "Reentered",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RepayBorrowMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RepayTokenNotListed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SeizePaused",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SeizeTokenNotListed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "Seize_LiquidatorIsBorrower",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SenderMustBeCToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SetInterestRateModelMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SetReservesFactorMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SupplyCapReached",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TokenInOrAmountInMustBeZero",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TokenTransferInFailed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TokenTransferOutFailed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TooMuchRepay",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TotalBorrowsNotZero",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TotalSupplyNotZero",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TransferNotAllowed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TransferPaused",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "UnderlyingBalanceError",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ZeroAddressNotAllowed",
            "type": "error"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "cashPrior",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "interestAccumulated",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "borrowIndex",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "totalBorrows",
                    "type": "uint256"
                }
            ],
            "name": "AccrueInterest",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "owner",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "spender",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                }
            ],
            "name": "Approval",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "borrower",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "borrowAmount",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "accountBorrows",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "totalBorrows",
                    "type": "uint256"
                }
            ],
            "name": "Borrow",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "uint8",
                    "name": "version",
                    "type": "uint8"
                }
            ],
            "name": "Initialized",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "liquidator",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "borrower",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "repayAmount",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "cTokenCollateral",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "seizeTokens",
                    "type": "uint256"
                }
            ],
            "name": "LiquidateBorrow",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "minter",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "mintAmount",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "mintTokens",
                    "type": "uint256"
                }
            ],
            "name": "Mint",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "oldAdmin",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "newAdmin",
                    "type": "address"
                }
            ],
            "name": "NewAdmin",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "oldComptroller",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "newComptroller",
                    "type": "address"
                }
            ],
            "name": "NewComptroller",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "oldDiscountRateMantissa",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "newDiscountRateMantissa",
                    "type": "uint256"
                }
            ],
            "name": "NewDiscountRate",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "oldInterestRateModel",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "newInterestRateModel",
                    "type": "address"
                }
            ],
            "name": "NewMarketInterestRateModel",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "oldPendingAdmin",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "newPendingAdmin",
                    "type": "address"
                }
            ],
            "name": "NewPendingAdmin",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "oldReserveFactorMantissa",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "newReserveFactorMantissa",
                    "type": "uint256"
                }
            ],
            "name": "NewReserveFactor",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "redeemer",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "redeemAmount",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "redeemTokens",
                    "type": "uint256"
                }
            ],
            "name": "Redeem",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "redeemer",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "provider",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "repayAmount",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "seizeToken",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "seizeAmount",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "redemptionRateMantissa",
                    "type": "uint256"
                }
            ],
            "name": "RedeemFaceValue",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "payer",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "borrower",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "repayAmount",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "accountBorrows",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "totalBorrows",
                    "type": "uint256"
                }
            ],
            "name": "RepayBorrow",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "benefactor",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "addAmount",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "newTotalReserves",
                    "type": "uint256"
                }
            ],
            "name": "ReservesAdded",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "admin",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "reduceAmount",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "newTotalReserves",
                    "type": "uint256"
                }
            ],
            "name": "ReservesReduced",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "from",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "to",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                }
            ],
            "name": "Transfer",
            "type": "event"
        },
        {
            "inputs": [],
            "name": "_acceptAdmin",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "_addReserves",
            "outputs": [],
            "stateMutability": "payable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "reduceAmount",
                    "type": "uint256"
                }
            ],
            "name": "_reduceReserves",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "newComptroller",
                    "type": "address"
                }
            ],
            "name": "_setComptroller",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "discountRateMantissa_",
                    "type": "uint256"
                }
            ],
            "name": "_setDiscountRate",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "newInterestRateModel",
                    "type": "address"
                }
            ],
            "name": "_setInterestRateModel",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address payable",
                    "name": "newPendingAdmin",
                    "type": "address"
                }
            ],
            "name": "_setPendingAdmin",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "newReserveFactorMantissa",
                    "type": "uint256"
                }
            ],
            "name": "_setReserveFactor",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "_syncUnderlyingBalance",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "accrualBlockTimestamp",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "accrueInterest",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "admin",
            "outputs": [
                {
                    "internalType": "address payable",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "owner",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "spender",
                    "type": "address"
                }
            ],
            "name": "allowance",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "spender",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                }
            ],
            "name": "approve",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "owner",
                    "type": "address"
                }
            ],
            "name": "balanceOf",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "owner",
                    "type": "address"
                }
            ],
            "name": "balanceOfUnderlying",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "borrowAmount",
                    "type": "uint256"
                }
            ],
            "name": "borrow",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "borrower",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "borrowAmount",
                    "type": "uint256"
                }
            ],
            "name": "borrowAndDepositBack",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "borrowBalanceCurrent",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "borrowBalanceStored",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "borrowIndex",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "borrowRatePerBlock",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "comptroller",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "decimals",
            "outputs": [
                {
                    "internalType": "uint8",
                    "name": "",
                    "type": "uint8"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "discountRateMantissa",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "exchangeRateCurrent",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "exchangeRateStored",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "getAccountSnapshot",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "getCash",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "comptroller_",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "interestRateModel_",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "initialExchangeRateMantissa_",
                    "type": "uint256"
                },
                {
                    "internalType": "string",
                    "name": "name_",
                    "type": "string"
                },
                {
                    "internalType": "string",
                    "name": "symbol_",
                    "type": "string"
                },
                {
                    "internalType": "uint8",
                    "name": "decimals_",
                    "type": "uint8"
                },
                {
                    "internalType": "address payable",
                    "name": "admin_",
                    "type": "address"
                }
            ],
            "name": "initialize",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "initializeVersion2",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "interestRateModel",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "isCEther",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "pure",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "isCEtherDeprecated",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "isCToken",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "pure",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "isCTokenDeprecated",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "borrower",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "cTokenCollateral",
                    "type": "address"
                }
            ],
            "name": "liquidateBorrow",
            "outputs": [],
            "stateMutability": "payable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cTokenCollateral",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "actualRepayAmount",
                    "type": "uint256"
                }
            ],
            "name": "liquidateCalculateSeizeTokens",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "mint",
            "outputs": [],
            "stateMutability": "payable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "name",
            "outputs": [
                {
                    "internalType": "string",
                    "name": "",
                    "type": "string"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "pendingAdmin",
            "outputs": [
                {
                    "internalType": "address payable",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "percentScale",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "protocolSeizeShareMantissa",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "redeemTokens",
                    "type": "uint256"
                }
            ],
            "name": "redeem",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "redeemAmount",
                    "type": "uint256"
                }
            ],
            "name": "redeemUnderlying",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "repayBorrow",
            "outputs": [],
            "stateMutability": "payable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "borrower",
                    "type": "address"
                }
            ],
            "name": "repayBorrowBehalf",
            "outputs": [],
            "stateMutability": "payable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "reserveFactorMantissa",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "liquidator",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "borrower",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "seizeTokens",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "seizeProfitTokens",
                    "type": "uint256"
                },
                {
                    "internalType": "bool",
                    "name": "isRedemption",
                    "type": "bool"
                },
                {
                    "internalType": "uint256",
                    "name": "redemptionRateMantissa",
                    "type": "uint256"
                }
            ],
            "name": "seize",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "supplyRatePerBlock",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "symbol",
            "outputs": [
                {
                    "internalType": "string",
                    "name": "",
                    "type": "string"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "tokenType",
            "outputs": [
                {
                    "internalType": "enum CToken.CTokenType",
                    "name": "",
                    "type": "uint8"
                }
            ],
            "stateMutability": "pure",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "totalBorrows",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "totalBorrowsCurrent",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "totalReserves",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "totalSupply",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "dst",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                }
            ],
            "name": "transfer",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "src",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "dst",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                }
            ],
            "name": "transferFrom",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "underlying",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "underlyingBalance",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "stateMutability": "payable",
            "type": "receive"
        }
    ],
    "CToken": [
        {
            "inputs": [],
            "name": "AddReservesMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "AddReservesOverflow",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "BorrowAndDepositBackFailed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "BorrowCapReached",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "BorrowCashNotAvailable",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "BorrowMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "BorrowPaused",
            "type": "error"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "usdThreshold",
                    "type": "uint256"
                }
            ],
            "name": "BorrowValueMustBeLargerThanThreshold",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "CantEnterPausedMarket",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "CantExitMarketWithNonZeroBorrowBalance",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "CantSweepUnderlying",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ComptrollerMismatch",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "EitherAssetOrDebtMustBeZero",
            "type": "error"
        },
        {
            "inputs": [
                {
                    "internalType": "uint8",
                    "name": "groupId",
                    "type": "uint8"
                },
                {
                    "internalType": "uint256",
                    "name": "cDepositVal",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "suDepositVal",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "cBorrowVal",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "suBorrowVal",
                    "type": "uint256"
                }
            ],
            "name": "EitherAssetOrDebtMustBeZeroInGroup",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ExpiredSignature",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InsufficientCollateral",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InsufficientShortfall",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InterMintNotAllowed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidAddress",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidAmount",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidBlockNumber",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidCToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidCloseFactor",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidComptroller",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidDiscountRate",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidExchangeRate",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidGroupId",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidInput",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidInterestRateModel",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidMinSuBorrowValue",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidRedeem",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidReduceAmount",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidReserveFactor",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidSignatureForRedeemFaceValue",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidSignatureLength",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidSuToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidTimestamp",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateBorrow_LiquidatorIsBorrower",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateBorrow_RepayAmountIsMax",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateBorrow_RepayAmountIsZero",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateBorrow_SeizeTooMuch",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateCollateralMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketAlreadyListed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketAlreadyUnlisted",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketCanOnlyInitializeOnce",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketNotEmpty",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketNotListed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketPaused",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MinDelayNotReached",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MintMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MintPaused",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MintTokensCantBeZero",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NoRedemptionProvider",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotCToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotEnoughForSeize",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotEnoughRedeemAmount",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotEnoughRedeemTokens",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotEnoughUnderlyingAfterRedeem",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotEnoughUnderlyingForMint",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotLiquidatableYet",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotSuToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyAdmin",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyAdminOrPauser",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyCToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyListedCToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyPausedMarketCanBeUnlisted",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyPendingAdmin",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyRedemptionManager",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OverThreshold",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "PriceError",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ProtectedMint_OnlyAllowAssetsInTheSameGroup",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RedeemMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RedeemTransferOutNotPossible",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RedemptionSeizeTooMuch",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RedemptionSignerNotInitialized",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ReduceReservesCashNotAvailable",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ReduceReservesMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "Reentered",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RepayBorrowMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RepayTokenNotListed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SeizePaused",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SeizeTokenNotListed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "Seize_LiquidatorIsBorrower",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SenderMustBeCToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SetInterestRateModelMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SetReservesFactorMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SupplyCapReached",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TokenInOrAmountInMustBeZero",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TokenTransferInFailed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TokenTransferOutFailed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TooMuchRepay",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TotalBorrowsNotZero",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TotalSupplyNotZero",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TransferNotAllowed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TransferPaused",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "UnderlyingBalanceError",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ZeroAddressNotAllowed",
            "type": "error"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "cashPrior",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "interestAccumulated",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "borrowIndex",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "totalBorrows",
                    "type": "uint256"
                }
            ],
            "name": "AccrueInterest",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "owner",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "spender",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                }
            ],
            "name": "Approval",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "borrower",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "borrowAmount",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "accountBorrows",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "totalBorrows",
                    "type": "uint256"
                }
            ],
            "name": "Borrow",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "liquidator",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "borrower",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "repayAmount",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "cTokenCollateral",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "seizeTokens",
                    "type": "uint256"
                }
            ],
            "name": "LiquidateBorrow",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "minter",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "mintAmount",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "mintTokens",
                    "type": "uint256"
                }
            ],
            "name": "Mint",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "oldAdmin",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "newAdmin",
                    "type": "address"
                }
            ],
            "name": "NewAdmin",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "oldComptroller",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "newComptroller",
                    "type": "address"
                }
            ],
            "name": "NewComptroller",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "oldDiscountRateMantissa",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "newDiscountRateMantissa",
                    "type": "uint256"
                }
            ],
            "name": "NewDiscountRate",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "oldInterestRateModel",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "newInterestRateModel",
                    "type": "address"
                }
            ],
            "name": "NewMarketInterestRateModel",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "oldPendingAdmin",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "newPendingAdmin",
                    "type": "address"
                }
            ],
            "name": "NewPendingAdmin",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "oldReserveFactorMantissa",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "newReserveFactorMantissa",
                    "type": "uint256"
                }
            ],
            "name": "NewReserveFactor",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "redeemer",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "redeemAmount",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "redeemTokens",
                    "type": "uint256"
                }
            ],
            "name": "Redeem",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "redeemer",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "provider",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "repayAmount",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "seizeToken",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "seizeAmount",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "redemptionRateMantissa",
                    "type": "uint256"
                }
            ],
            "name": "RedeemFaceValue",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "payer",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "borrower",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "repayAmount",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "accountBorrows",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "totalBorrows",
                    "type": "uint256"
                }
            ],
            "name": "RepayBorrow",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "benefactor",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "addAmount",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "newTotalReserves",
                    "type": "uint256"
                }
            ],
            "name": "ReservesAdded",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "admin",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "reduceAmount",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "newTotalReserves",
                    "type": "uint256"
                }
            ],
            "name": "ReservesReduced",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "from",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "to",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                }
            ],
            "name": "Transfer",
            "type": "event"
        },
        {
            "inputs": [],
            "name": "_acceptAdmin",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "reduceAmount",
                    "type": "uint256"
                }
            ],
            "name": "_reduceReserves",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "newComptroller",
                    "type": "address"
                }
            ],
            "name": "_setComptroller",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "discountRateMantissa_",
                    "type": "uint256"
                }
            ],
            "name": "_setDiscountRate",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "newInterestRateModel",
                    "type": "address"
                }
            ],
            "name": "_setInterestRateModel",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address payable",
                    "name": "newPendingAdmin",
                    "type": "address"
                }
            ],
            "name": "_setPendingAdmin",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "newReserveFactorMantissa",
                    "type": "uint256"
                }
            ],
            "name": "_setReserveFactor",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "_syncUnderlyingBalance",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "accrualBlockTimestamp",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "accrueInterest",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "admin",
            "outputs": [
                {
                    "internalType": "address payable",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "owner",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "spender",
                    "type": "address"
                }
            ],
            "name": "allowance",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "spender",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                }
            ],
            "name": "approve",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "owner",
                    "type": "address"
                }
            ],
            "name": "balanceOf",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "owner",
                    "type": "address"
                }
            ],
            "name": "balanceOfUnderlying",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "borrower",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "borrowAmount",
                    "type": "uint256"
                }
            ],
            "name": "borrowAndDepositBack",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "borrowBalanceCurrent",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "borrowBalanceStored",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "borrowIndex",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "borrowRatePerBlock",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "comptroller",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "decimals",
            "outputs": [
                {
                    "internalType": "uint8",
                    "name": "",
                    "type": "uint8"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "discountRateMantissa",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "exchangeRateCurrent",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "exchangeRateStored",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "getAccountSnapshot",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "getCash",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "interestRateModel",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "isCEther",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "pure",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "isCEtherDeprecated",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "isCToken",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "pure",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "isCTokenDeprecated",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cTokenCollateral",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "actualRepayAmount",
                    "type": "uint256"
                }
            ],
            "name": "liquidateCalculateSeizeTokens",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "name",
            "outputs": [
                {
                    "internalType": "string",
                    "name": "",
                    "type": "string"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "pendingAdmin",
            "outputs": [
                {
                    "internalType": "address payable",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "percentScale",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "protocolSeizeShareMantissa",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "reserveFactorMantissa",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "liquidator",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "borrower",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "seizeTokens",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "seizeProfitTokens",
                    "type": "uint256"
                },
                {
                    "internalType": "bool",
                    "name": "isRedemption",
                    "type": "bool"
                },
                {
                    "internalType": "uint256",
                    "name": "redemptionRateMantissa",
                    "type": "uint256"
                }
            ],
            "name": "seize",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "supplyRatePerBlock",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "symbol",
            "outputs": [
                {
                    "internalType": "string",
                    "name": "",
                    "type": "string"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "totalBorrows",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "totalBorrowsCurrent",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "totalReserves",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "totalSupply",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "dst",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                }
            ],
            "name": "transfer",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "src",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "dst",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                }
            ],
            "name": "transferFrom",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "underlying",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "underlyingBalance",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        }
    ],
    "CTokenStorage": [
        {
            "inputs": [],
            "name": "_acceptAdmin",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "reduceAmount",
                    "type": "uint256"
                }
            ],
            "name": "_reduceReserves",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "newComptroller",
                    "type": "address"
                }
            ],
            "name": "_setComptroller",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "discountRateMantissa",
                    "type": "uint256"
                }
            ],
            "name": "_setDiscountRate",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "newInterestRateModel",
                    "type": "address"
                }
            ],
            "name": "_setInterestRateModel",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address payable",
                    "name": "newPendingAdmin",
                    "type": "address"
                }
            ],
            "name": "_setPendingAdmin",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "newReserveFactorMantissa",
                    "type": "uint256"
                }
            ],
            "name": "_setReserveFactor",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "accrualBlockTimestamp",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "accrueInterest",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "admin",
            "outputs": [
                {
                    "internalType": "address payable",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "owner",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "spender",
                    "type": "address"
                }
            ],
            "name": "allowance",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "spender",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                }
            ],
            "name": "approve",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "owner",
                    "type": "address"
                }
            ],
            "name": "balanceOf",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "owner",
                    "type": "address"
                }
            ],
            "name": "balanceOfUnderlying",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "borrowBalanceCurrent",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "borrowBalanceStored",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "borrowIndex",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "borrowRatePerBlock",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "comptroller",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "decimals",
            "outputs": [
                {
                    "internalType": "uint8",
                    "name": "",
                    "type": "uint8"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "discountRateMantissa",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "exchangeRateCurrent",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "exchangeRateStored",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "getAccountSnapshot",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "getCash",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "interestRateModel",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "isCEtherDeprecated",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "isCTokenDeprecated",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "name",
            "outputs": [
                {
                    "internalType": "string",
                    "name": "",
                    "type": "string"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "pendingAdmin",
            "outputs": [
                {
                    "internalType": "address payable",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "percentScale",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "protocolSeizeShareMantissa",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "reserveFactorMantissa",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "liquidator",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "borrower",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "seizeTokens",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "seizeProfitTokens",
                    "type": "uint256"
                },
                {
                    "internalType": "bool",
                    "name": "isRedemption",
                    "type": "bool"
                },
                {
                    "internalType": "uint256",
                    "name": "redemptionRateMantissa",
                    "type": "uint256"
                }
            ],
            "name": "seize",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "supplyRatePerBlock",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "symbol",
            "outputs": [
                {
                    "internalType": "string",
                    "name": "",
                    "type": "string"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "totalBorrows",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "totalBorrowsCurrent",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "totalReserves",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "totalSupply",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "dst",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                }
            ],
            "name": "transfer",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "src",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "dst",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                }
            ],
            "name": "transferFrom",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "underlying",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "underlyingBalance",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        }
    ],
    "suErc20": [
        {
            "inputs": [],
            "name": "AddReservesMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "AddReservesOverflow",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "BorrowAndDepositBackFailed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "BorrowCapReached",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "BorrowCashNotAvailable",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "BorrowMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "BorrowPaused",
            "type": "error"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "usdThreshold",
                    "type": "uint256"
                }
            ],
            "name": "BorrowValueMustBeLargerThanThreshold",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "CantEnterPausedMarket",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "CantExitMarketWithNonZeroBorrowBalance",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "CantSweepUnderlying",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ComptrollerMismatch",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "EitherAssetOrDebtMustBeZero",
            "type": "error"
        },
        {
            "inputs": [
                {
                    "internalType": "uint8",
                    "name": "groupId",
                    "type": "uint8"
                },
                {
                    "internalType": "uint256",
                    "name": "cDepositVal",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "suDepositVal",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "cBorrowVal",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "suBorrowVal",
                    "type": "uint256"
                }
            ],
            "name": "EitherAssetOrDebtMustBeZeroInGroup",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ExpiredSignature",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InsufficientCollateral",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InsufficientShortfall",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InterMintNotAllowed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidAddress",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidAmount",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidBlockNumber",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidCToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidCloseFactor",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidComptroller",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidDiscountRate",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidExchangeRate",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidGroupId",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidInput",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidInterestRateModel",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidMinSuBorrowValue",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidRedeem",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidReduceAmount",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidReserveFactor",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidSignatureForRedeemFaceValue",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidSignatureLength",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidSuToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidTimestamp",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateBorrow_LiquidatorIsBorrower",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateBorrow_RepayAmountIsMax",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateBorrow_RepayAmountIsZero",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateBorrow_SeizeTooMuch",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateCollateralMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketAlreadyListed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketAlreadyUnlisted",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketCanOnlyInitializeOnce",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketNotEmpty",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketNotListed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketPaused",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MinDelayNotReached",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MintMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MintPaused",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MintTokensCantBeZero",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NoRedemptionProvider",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotCToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotEnoughForSeize",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotEnoughRedeemAmount",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotEnoughRedeemTokens",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotEnoughUnderlyingAfterRedeem",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotEnoughUnderlyingForMint",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotLiquidatableYet",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotSuToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyAdmin",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyAdminOrPauser",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyCToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyListedCToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyPausedMarketCanBeUnlisted",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyPendingAdmin",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyRedemptionManager",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OverThreshold",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "PriceError",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ProtectedMint_OnlyAllowAssetsInTheSameGroup",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RedeemMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RedeemTransferOutNotPossible",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RedemptionSeizeTooMuch",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RedemptionSignerNotInitialized",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ReduceReservesCashNotAvailable",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ReduceReservesMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "Reentered",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RepayBorrowMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RepayTokenNotListed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SeizePaused",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SeizeTokenNotListed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "Seize_LiquidatorIsBorrower",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SenderMustBeCToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SetInterestRateModelMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SetReservesFactorMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SupplyCapReached",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TokenInOrAmountInMustBeZero",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TokenTransferInFailed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TokenTransferOutFailed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TooMuchRepay",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TotalBorrowsNotZero",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TotalSupplyNotZero",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TransferNotAllowed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TransferPaused",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "UnderlyingBalanceError",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ZeroAddressNotAllowed",
            "type": "error"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "cashPrior",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "interestAccumulated",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "borrowIndex",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "totalBorrows",
                    "type": "uint256"
                }
            ],
            "name": "AccrueInterest",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "owner",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "spender",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                }
            ],
            "name": "Approval",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "borrower",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "borrowAmount",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "accountBorrows",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "totalBorrows",
                    "type": "uint256"
                }
            ],
            "name": "Borrow",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "uint8",
                    "name": "version",
                    "type": "uint8"
                }
            ],
            "name": "Initialized",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "liquidator",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "borrower",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "repayAmount",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "cTokenCollateral",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "seizeTokens",
                    "type": "uint256"
                }
            ],
            "name": "LiquidateBorrow",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "minter",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "mintAmount",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "mintTokens",
                    "type": "uint256"
                }
            ],
            "name": "Mint",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "oldAdmin",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "newAdmin",
                    "type": "address"
                }
            ],
            "name": "NewAdmin",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "oldComptroller",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "newComptroller",
                    "type": "address"
                }
            ],
            "name": "NewComptroller",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "oldDiscountRateMantissa",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "newDiscountRateMantissa",
                    "type": "uint256"
                }
            ],
            "name": "NewDiscountRate",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "oldInterestRateModel",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "newInterestRateModel",
                    "type": "address"
                }
            ],
            "name": "NewMarketInterestRateModel",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "oldPendingAdmin",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "newPendingAdmin",
                    "type": "address"
                }
            ],
            "name": "NewPendingAdmin",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "oldReserveFactorMantissa",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "newReserveFactorMantissa",
                    "type": "uint256"
                }
            ],
            "name": "NewReserveFactor",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "redeemer",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "redeemAmount",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "redeemTokens",
                    "type": "uint256"
                }
            ],
            "name": "Redeem",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "redeemer",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "provider",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "repayAmount",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "seizeToken",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "seizeAmount",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "redemptionRateMantissa",
                    "type": "uint256"
                }
            ],
            "name": "RedeemFaceValue",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "payer",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "borrower",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "repayAmount",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "accountBorrows",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "totalBorrows",
                    "type": "uint256"
                }
            ],
            "name": "RepayBorrow",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "benefactor",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "addAmount",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "newTotalReserves",
                    "type": "uint256"
                }
            ],
            "name": "ReservesAdded",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "admin",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "reduceAmount",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "newTotalReserves",
                    "type": "uint256"
                }
            ],
            "name": "ReservesReduced",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "from",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "to",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                }
            ],
            "name": "Transfer",
            "type": "event"
        },
        {
            "inputs": [],
            "name": "_acceptAdmin",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "addAmount",
                    "type": "uint256"
                }
            ],
            "name": "_addReserves",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "reduceAmount",
                    "type": "uint256"
                }
            ],
            "name": "_reduceReserves",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "newComptroller",
                    "type": "address"
                }
            ],
            "name": "_setComptroller",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "discountRateMantissa_",
                    "type": "uint256"
                }
            ],
            "name": "_setDiscountRate",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "newInterestRateModel",
                    "type": "address"
                }
            ],
            "name": "_setInterestRateModel",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address payable",
                    "name": "newPendingAdmin",
                    "type": "address"
                }
            ],
            "name": "_setPendingAdmin",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "newReserveFactorMantissa",
                    "type": "uint256"
                }
            ],
            "name": "_setReserveFactor",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "_syncUnderlyingBalance",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "accrualBlockTimestamp",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "accrueInterest",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "admin",
            "outputs": [
                {
                    "internalType": "address payable",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "owner",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "spender",
                    "type": "address"
                }
            ],
            "name": "allowance",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "spender",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                }
            ],
            "name": "approve",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "owner",
                    "type": "address"
                }
            ],
            "name": "balanceOf",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "owner",
                    "type": "address"
                }
            ],
            "name": "balanceOfUnderlying",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "borrowAmount",
                    "type": "uint256"
                }
            ],
            "name": "borrow",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "borrower",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "borrowAmount",
                    "type": "uint256"
                }
            ],
            "name": "borrowAndDepositBack",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "borrowBalanceCurrent",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "borrowBalanceStored",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "borrowIndex",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "borrowRatePerBlock",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "comptroller",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "decimals",
            "outputs": [
                {
                    "internalType": "uint8",
                    "name": "",
                    "type": "uint8"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "discountRateMantissa",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "exchangeRateCurrent",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "exchangeRateStored",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "redeemer",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "provider",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "repayAmount",
                    "type": "uint256"
                },
                {
                    "internalType": "address",
                    "name": "cTokenCollateral",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "seizeAmount",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "redemptionRateMantissa",
                    "type": "uint256"
                }
            ],
            "name": "executeRedemption",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "getAccountSnapshot",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "getCash",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "underlying_",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "comptroller_",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "interestRateModel_",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "initialExchangeRateMantissa_",
                    "type": "uint256"
                },
                {
                    "internalType": "string",
                    "name": "name_",
                    "type": "string"
                },
                {
                    "internalType": "string",
                    "name": "symbol_",
                    "type": "string"
                },
                {
                    "internalType": "uint8",
                    "name": "decimals_",
                    "type": "uint8"
                },
                {
                    "internalType": "address payable",
                    "name": "admin_",
                    "type": "address"
                }
            ],
            "name": "initialize",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "interestRateModel",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "isCEther",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "pure",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "isCEtherDeprecated",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "isCToken",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "pure",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "isCTokenDeprecated",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "borrower",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "repayAmount",
                    "type": "uint256"
                },
                {
                    "internalType": "address",
                    "name": "cTokenCollateral",
                    "type": "address"
                }
            ],
            "name": "liquidateBorrow",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cTokenCollateral",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "actualRepayAmount",
                    "type": "uint256"
                }
            ],
            "name": "liquidateCalculateSeizeTokens",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "mintAmount",
                    "type": "uint256"
                }
            ],
            "name": "mint",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "mintAmount",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "deadline",
                    "type": "uint256"
                },
                {
                    "internalType": "bytes",
                    "name": "signature",
                    "type": "bytes"
                }
            ],
            "name": "mintWithPermit",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "name",
            "outputs": [
                {
                    "internalType": "string",
                    "name": "",
                    "type": "string"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "pendingAdmin",
            "outputs": [
                {
                    "internalType": "address payable",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "percentScale",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cTokenCollateral",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "cBorrowAmount",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "suBorrowAmount",
                    "type": "uint256"
                }
            ],
            "name": "protectedMint",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "protocolSeizeShareMantissa",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "redeemTokens",
                    "type": "uint256"
                }
            ],
            "name": "redeem",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "redeemAmount",
                    "type": "uint256"
                }
            ],
            "name": "redeemUnderlying",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "repayAmount",
                    "type": "uint256"
                }
            ],
            "name": "repayBorrow",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "borrower",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "repayAmount",
                    "type": "uint256"
                }
            ],
            "name": "repayBorrowBehalf",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "repayAmount",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "deadline",
                    "type": "uint256"
                },
                {
                    "internalType": "bytes",
                    "name": "signature",
                    "type": "bytes"
                }
            ],
            "name": "repayBorrowWithPermit",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "reserveFactorMantissa",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "liquidator",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "borrower",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "seizeTokens",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "seizeProfitTokens",
                    "type": "uint256"
                },
                {
                    "internalType": "bool",
                    "name": "isRedemption",
                    "type": "bool"
                },
                {
                    "internalType": "uint256",
                    "name": "redemptionRateMantissa",
                    "type": "uint256"
                }
            ],
            "name": "seize",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "supplyRatePerBlock",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "contract ERC20",
                    "name": "token",
                    "type": "address"
                }
            ],
            "name": "sweepToken",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "symbol",
            "outputs": [
                {
                    "internalType": "string",
                    "name": "",
                    "type": "string"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "tokenType",
            "outputs": [
                {
                    "internalType": "enum CToken.CTokenType",
                    "name": "",
                    "type": "uint8"
                }
            ],
            "stateMutability": "pure",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "totalBorrows",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "totalBorrowsCurrent",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "totalReserves",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "totalSupply",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "dst",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                }
            ],
            "name": "transfer",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "src",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "dst",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                }
            ],
            "name": "transferFrom",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "underlying",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "underlyingBalance",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        }
    ],
    "CompLogic": [
        {
            "inputs": [],
            "stateMutability": "nonpayable",
            "type": "constructor"
        },
        {
            "inputs": [],
            "name": "AddReservesMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "AddReservesOverflow",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "BorrowAndDepositBackFailed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "BorrowCapReached",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "BorrowCashNotAvailable",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "BorrowMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "BorrowPaused",
            "type": "error"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "usdThreshold",
                    "type": "uint256"
                }
            ],
            "name": "BorrowValueMustBeLargerThanThreshold",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "CantEnterPausedMarket",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "CantExitMarketWithNonZeroBorrowBalance",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "CantSweepUnderlying",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ComptrollerMismatch",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "EitherAssetOrDebtMustBeZero",
            "type": "error"
        },
        {
            "inputs": [
                {
                    "internalType": "uint8",
                    "name": "groupId",
                    "type": "uint8"
                },
                {
                    "internalType": "uint256",
                    "name": "cDepositVal",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "suDepositVal",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "cBorrowVal",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "suBorrowVal",
                    "type": "uint256"
                }
            ],
            "name": "EitherAssetOrDebtMustBeZeroInGroup",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ExpiredSignature",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InsufficientCollateral",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InsufficientShortfall",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InterMintNotAllowed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidAddress",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidAmount",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidBlockNumber",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidCToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidCloseFactor",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidComptroller",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidDiscountRate",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidExchangeRate",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidGroupId",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidInput",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidInterestRateModel",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidMinSuBorrowValue",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidRedeem",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidReduceAmount",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidReserveFactor",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidSignatureForRedeemFaceValue",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidSignatureLength",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidSuToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidTimestamp",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateBorrow_LiquidatorIsBorrower",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateBorrow_RepayAmountIsMax",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateBorrow_RepayAmountIsZero",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateBorrow_SeizeTooMuch",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateCollateralMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketAlreadyListed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketAlreadyUnlisted",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketCanOnlyInitializeOnce",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketNotEmpty",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketNotListed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketPaused",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MinDelayNotReached",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MintMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MintPaused",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MintTokensCantBeZero",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NoRedemptionProvider",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotCToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotEnoughForSeize",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotEnoughRedeemAmount",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotEnoughRedeemTokens",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotEnoughUnderlyingAfterRedeem",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotEnoughUnderlyingForMint",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotLiquidatableYet",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotSuToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyAdmin",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyAdminOrPauser",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyCToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyListedCToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyPausedMarketCanBeUnlisted",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyPendingAdmin",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyRedemptionManager",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OverThreshold",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "PriceError",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ProtectedMint_OnlyAllowAssetsInTheSameGroup",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RedeemMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RedeemTransferOutNotPossible",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RedemptionSeizeTooMuch",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RedemptionSignerNotInitialized",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ReduceReservesCashNotAvailable",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ReduceReservesMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "Reentered",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RepayBorrowMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RepayTokenNotListed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SeizePaused",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SeizeTokenNotListed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "Seize_LiquidatorIsBorrower",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SenderMustBeCToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SetInterestRateModelMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SetReservesFactorMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SupplyCapReached",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TokenInOrAmountInMustBeZero",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TokenTransferInFailed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TokenTransferOutFailed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TooMuchRepay",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TotalBorrowsNotZero",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TotalSupplyNotZero",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TransferNotAllowed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TransferPaused",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "UnderlyingBalanceError",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ZeroAddressNotAllowed",
            "type": "error"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "newSpeed",
                    "type": "uint256"
                }
            ],
            "name": "CompBorrowSpeedUpdated",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "recipient",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                }
            ],
            "name": "CompGranted",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "newSpeed",
                    "type": "uint256"
                }
            ],
            "name": "CompSupplySpeedUpdated",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "contributor",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "newSpeed",
                    "type": "uint256"
                }
            ],
            "name": "ContributorCompSpeedUpdated",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "borrower",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "compDelta",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "compBorrowIndex",
                    "type": "uint256"
                }
            ],
            "name": "DistributedBorrowerComp",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "supplier",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "compDelta",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "compSupplyIndex",
                    "type": "uint256"
                }
            ],
            "name": "DistributedSupplierComp",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "uint8",
                    "name": "version",
                    "type": "uint8"
                }
            ],
            "name": "Initialized",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "indexed": true,
                    "internalType": "bytes32",
                    "name": "previousAdminRole",
                    "type": "bytes32"
                },
                {
                    "indexed": true,
                    "internalType": "bytes32",
                    "name": "newAdminRole",
                    "type": "bytes32"
                }
            ],
            "name": "RoleAdminChanged",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "sender",
                    "type": "address"
                }
            ],
            "name": "RoleGranted",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "sender",
                    "type": "address"
                }
            ],
            "name": "RoleRevoked",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "comptroller",
                    "type": "address"
                }
            ],
            "name": "SetComptroller",
            "type": "event"
        },
        {
            "inputs": [],
            "name": "DEFAULT_ADMIN_ROLE",
            "outputs": [
                {
                    "internalType": "bytes32",
                    "name": "",
                    "type": "bytes32"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "recipient",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                }
            ],
            "name": "_grantComp",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address[]",
                    "name": "cTokens",
                    "type": "address[]"
                },
                {
                    "internalType": "uint256[]",
                    "name": "supplySpeeds",
                    "type": "uint256[]"
                },
                {
                    "internalType": "uint256[]",
                    "name": "borrowSpeeds",
                    "type": "uint256[]"
                }
            ],
            "name": "_setCompSpeeds",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "contributor",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "compSpeed",
                    "type": "uint256"
                }
            ],
            "name": "_setContributorCompSpeed",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "holder",
                    "type": "address"
                }
            ],
            "name": "calculateComp",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address[]",
                    "name": "holders",
                    "type": "address[]"
                },
                {
                    "internalType": "address[]",
                    "name": "cTokens",
                    "type": "address[]"
                },
                {
                    "internalType": "bool",
                    "name": "borrowers",
                    "type": "bool"
                },
                {
                    "internalType": "bool",
                    "name": "suppliers",
                    "type": "bool"
                }
            ],
            "name": "claimSumer",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "holder",
                    "type": "address"
                }
            ],
            "name": "claimSumer",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "holder",
                    "type": "address"
                },
                {
                    "internalType": "address[]",
                    "name": "cTokens",
                    "type": "address[]"
                }
            ],
            "name": "claimSumer",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "comp",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "compAccrued",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "compBorrowSpeeds",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "compBorrowState",
            "outputs": [
                {
                    "internalType": "uint224",
                    "name": "index",
                    "type": "uint224"
                },
                {
                    "internalType": "uint32",
                    "name": "block",
                    "type": "uint32"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "compBorrowerIndex",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "compContributorSpeeds",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "compInitialIndex",
            "outputs": [
                {
                    "internalType": "uint224",
                    "name": "",
                    "type": "uint224"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "compSupplierIndex",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "compSupplySpeeds",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "compSupplyState",
            "outputs": [
                {
                    "internalType": "uint224",
                    "name": "index",
                    "type": "uint224"
                },
                {
                    "internalType": "uint32",
                    "name": "block",
                    "type": "uint32"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "comptroller",
            "outputs": [
                {
                    "internalType": "contract IComptroller",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "borrower",
                    "type": "address"
                },
                {
                    "components": [
                        {
                            "internalType": "uint256",
                            "name": "mantissa",
                            "type": "uint256"
                        }
                    ],
                    "internalType": "struct ExponentialNoErrorNew.Exp",
                    "name": "marketBorrowIndex",
                    "type": "tuple"
                }
            ],
            "name": "distributeBorrowerComp",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "supplier",
                    "type": "address"
                }
            ],
            "name": "distributeSupplierComp",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "cTokenModify",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "intraSafeLimitMantissa",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "interSafeLimitMantissa",
                    "type": "uint256"
                }
            ],
            "name": "getHypotheticalSafeLimit",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                }
            ],
            "name": "getRoleAdmin",
            "outputs": [
                {
                    "internalType": "bytes32",
                    "name": "",
                    "type": "bytes32"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "internalType": "uint256",
                    "name": "index",
                    "type": "uint256"
                }
            ],
            "name": "getRoleMember",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                }
            ],
            "name": "getRoleMemberCount",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "grantRole",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "hasRole",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_admin",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "_comp",
                    "type": "address"
                }
            ],
            "name": "initialize",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                },
                {
                    "internalType": "uint32",
                    "name": "blockNumber",
                    "type": "uint32"
                }
            ],
            "name": "initializeMarket",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "lastContributorBlock",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "percentScale",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "renounceRole",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "revokeRole",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "supplySpeed",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "borrowSpeed",
                    "type": "uint256"
                }
            ],
            "name": "setCompSpeed",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "contract IComptroller",
                    "name": "_comptroller",
                    "type": "address"
                }
            ],
            "name": "setComptroller",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes4",
                    "name": "interfaceId",
                    "type": "bytes4"
                }
            ],
            "name": "supportsInterface",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                }
            ],
            "name": "uninitializeMarket",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                },
                {
                    "components": [
                        {
                            "internalType": "uint256",
                            "name": "mantissa",
                            "type": "uint256"
                        }
                    ],
                    "internalType": "struct ExponentialNoErrorNew.Exp",
                    "name": "marketBorrowIndex",
                    "type": "tuple"
                }
            ],
            "name": "updateCompBorrowIndex",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                }
            ],
            "name": "updateCompSupplyIndex",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "contributor",
                    "type": "address"
                }
            ],
            "name": "updateContributorRewards",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        }
    ],
    "CompoundLens": [
        {
            "inputs": [],
            "name": "AddReservesMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "AddReservesOverflow",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "BorrowAndDepositBackFailed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "BorrowCapReached",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "BorrowCashNotAvailable",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "BorrowMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "BorrowPaused",
            "type": "error"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "usdThreshold",
                    "type": "uint256"
                }
            ],
            "name": "BorrowValueMustBeLargerThanThreshold",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "CantEnterPausedMarket",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "CantExitMarketWithNonZeroBorrowBalance",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "CantSweepUnderlying",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ComptrollerMismatch",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "EitherAssetOrDebtMustBeZero",
            "type": "error"
        },
        {
            "inputs": [
                {
                    "internalType": "uint8",
                    "name": "groupId",
                    "type": "uint8"
                },
                {
                    "internalType": "uint256",
                    "name": "cDepositVal",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "suDepositVal",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "cBorrowVal",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "suBorrowVal",
                    "type": "uint256"
                }
            ],
            "name": "EitherAssetOrDebtMustBeZeroInGroup",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ExpiredSignature",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InsufficientCollateral",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InsufficientShortfall",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InterMintNotAllowed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidAddress",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidAmount",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidBlockNumber",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidCToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidCloseFactor",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidComptroller",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidDiscountRate",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidExchangeRate",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidGroupId",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidInput",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidInterestRateModel",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidMinSuBorrowValue",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidRedeem",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidReduceAmount",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidReserveFactor",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidSignatureForRedeemFaceValue",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidSignatureLength",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidSuToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidTimestamp",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateBorrow_LiquidatorIsBorrower",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateBorrow_RepayAmountIsMax",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateBorrow_RepayAmountIsZero",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateBorrow_SeizeTooMuch",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateCollateralMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketAlreadyListed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketAlreadyUnlisted",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketCanOnlyInitializeOnce",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketNotEmpty",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketNotListed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketPaused",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MinDelayNotReached",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MintMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MintPaused",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MintTokensCantBeZero",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NoRedemptionProvider",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotCToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotEnoughForSeize",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotEnoughRedeemAmount",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotEnoughRedeemTokens",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotEnoughUnderlyingAfterRedeem",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotEnoughUnderlyingForMint",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotLiquidatableYet",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotSuToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyAdmin",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyAdminOrPauser",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyCToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyListedCToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyPausedMarketCanBeUnlisted",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyPendingAdmin",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyRedemptionManager",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OverThreshold",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "PriceError",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ProtectedMint_OnlyAllowAssetsInTheSameGroup",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RedeemMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RedeemTransferOutNotPossible",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RedemptionSeizeTooMuch",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RedemptionSignerNotInitialized",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ReduceReservesCashNotAvailable",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ReduceReservesMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "Reentered",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RepayBorrowMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RepayTokenNotListed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SeizePaused",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SeizeTokenNotListed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "Seize_LiquidatorIsBorrower",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SenderMustBeCToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SetInterestRateModelMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SetReservesFactorMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SupplyCapReached",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TokenInOrAmountInMustBeZero",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TokenTransferInFailed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TokenTransferOutFailed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TooMuchRepay",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TotalBorrowsNotZero",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TotalSupplyNotZero",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TransferNotAllowed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TransferPaused",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "UnderlyingBalanceError",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ZeroAddressNotAllowed",
            "type": "error"
        },
        {
            "inputs": [
                {
                    "internalType": "contract ICToken",
                    "name": "cToken",
                    "type": "address"
                },
                {
                    "internalType": "address payable",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "cTokenBalances",
            "outputs": [
                {
                    "components": [
                        {
                            "internalType": "address",
                            "name": "cToken",
                            "type": "address"
                        },
                        {
                            "internalType": "bool",
                            "name": "isCToken",
                            "type": "bool"
                        },
                        {
                            "internalType": "bool",
                            "name": "isCEther",
                            "type": "bool"
                        },
                        {
                            "internalType": "uint256",
                            "name": "balanceOf",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "borrowBalanceCurrent",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "balanceOfUnderlying",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "tokenBalance",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "tokenAllowance",
                            "type": "uint256"
                        }
                    ],
                    "internalType": "struct CompoundLens.CTokenBalances",
                    "name": "",
                    "type": "tuple"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "contract ICToken[]",
                    "name": "cTokens",
                    "type": "address[]"
                },
                {
                    "internalType": "address payable",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "cTokenBalancesAll",
            "outputs": [
                {
                    "components": [
                        {
                            "internalType": "address",
                            "name": "cToken",
                            "type": "address"
                        },
                        {
                            "internalType": "bool",
                            "name": "isCToken",
                            "type": "bool"
                        },
                        {
                            "internalType": "bool",
                            "name": "isCEther",
                            "type": "bool"
                        },
                        {
                            "internalType": "uint256",
                            "name": "balanceOf",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "borrowBalanceCurrent",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "balanceOfUnderlying",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "tokenBalance",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "tokenAllowance",
                            "type": "uint256"
                        }
                    ],
                    "internalType": "struct CompoundLens.CTokenBalances[]",
                    "name": "",
                    "type": "tuple[]"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "contract ICToken",
                    "name": "cToken",
                    "type": "address"
                }
            ],
            "name": "cTokenMetadata",
            "outputs": [
                {
                    "components": [
                        {
                            "internalType": "address",
                            "name": "cToken",
                            "type": "address"
                        },
                        {
                            "internalType": "uint256",
                            "name": "exchangeRateCurrent",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "supplyRatePerBlock",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "borrowRatePerBlock",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "reserveFactorMantissa",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "totalBorrows",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "totalReserves",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "totalSupply",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "totalCash",
                            "type": "uint256"
                        },
                        {
                            "internalType": "bool",
                            "name": "isListed",
                            "type": "bool"
                        },
                        {
                            "internalType": "address",
                            "name": "underlyingAssetAddress",
                            "type": "address"
                        },
                        {
                            "internalType": "uint256",
                            "name": "cTokenDecimals",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "underlyingDecimals",
                            "type": "uint256"
                        },
                        {
                            "internalType": "bool",
                            "name": "isCToken",
                            "type": "bool"
                        },
                        {
                            "internalType": "bool",
                            "name": "isCEther",
                            "type": "bool"
                        },
                        {
                            "internalType": "uint256",
                            "name": "borrowCap",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "depositCap",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "heteroLiquidationIncentive",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "homoLiquidationIncentive",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "sutokenLiquidationIncentive",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint8",
                            "name": "groupId",
                            "type": "uint8"
                        },
                        {
                            "internalType": "uint256",
                            "name": "intraRate",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "mintRate",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "interRate",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "discountRate",
                            "type": "uint256"
                        },
                        {
                            "internalType": "bool",
                            "name": "interMintAllowed",
                            "type": "bool"
                        }
                    ],
                    "internalType": "struct CompoundLens.CTokenMetadata",
                    "name": "",
                    "type": "tuple"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "contract ICToken[]",
                    "name": "cTokens",
                    "type": "address[]"
                }
            ],
            "name": "cTokenMetadataAll",
            "outputs": [
                {
                    "components": [
                        {
                            "internalType": "address",
                            "name": "cToken",
                            "type": "address"
                        },
                        {
                            "internalType": "uint256",
                            "name": "exchangeRateCurrent",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "supplyRatePerBlock",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "borrowRatePerBlock",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "reserveFactorMantissa",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "totalBorrows",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "totalReserves",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "totalSupply",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "totalCash",
                            "type": "uint256"
                        },
                        {
                            "internalType": "bool",
                            "name": "isListed",
                            "type": "bool"
                        },
                        {
                            "internalType": "address",
                            "name": "underlyingAssetAddress",
                            "type": "address"
                        },
                        {
                            "internalType": "uint256",
                            "name": "cTokenDecimals",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "underlyingDecimals",
                            "type": "uint256"
                        },
                        {
                            "internalType": "bool",
                            "name": "isCToken",
                            "type": "bool"
                        },
                        {
                            "internalType": "bool",
                            "name": "isCEther",
                            "type": "bool"
                        },
                        {
                            "internalType": "uint256",
                            "name": "borrowCap",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "depositCap",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "heteroLiquidationIncentive",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "homoLiquidationIncentive",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "sutokenLiquidationIncentive",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint8",
                            "name": "groupId",
                            "type": "uint8"
                        },
                        {
                            "internalType": "uint256",
                            "name": "intraRate",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "mintRate",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "interRate",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "discountRate",
                            "type": "uint256"
                        },
                        {
                            "internalType": "bool",
                            "name": "interMintAllowed",
                            "type": "bool"
                        }
                    ],
                    "internalType": "struct CompoundLens.CTokenMetadata[]",
                    "name": "",
                    "type": "tuple[]"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "contract ICToken",
                    "name": "cToken",
                    "type": "address"
                }
            ],
            "name": "cTokenUnderlyingPrice",
            "outputs": [
                {
                    "components": [
                        {
                            "internalType": "address",
                            "name": "cToken",
                            "type": "address"
                        },
                        {
                            "internalType": "uint256",
                            "name": "underlyingPrice",
                            "type": "uint256"
                        }
                    ],
                    "internalType": "struct CompoundLens.CTokenUnderlyingPrice",
                    "name": "",
                    "type": "tuple"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "contract ICToken[]",
                    "name": "cTokens",
                    "type": "address[]"
                }
            ],
            "name": "cTokenUnderlyingPriceAll",
            "outputs": [
                {
                    "components": [
                        {
                            "internalType": "address",
                            "name": "cToken",
                            "type": "address"
                        },
                        {
                            "internalType": "uint256",
                            "name": "underlyingPrice",
                            "type": "uint256"
                        }
                    ],
                    "internalType": "struct CompoundLens.CTokenUnderlyingPrice[]",
                    "name": "",
                    "type": "tuple[]"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "cTokenCollateral",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "suToken",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "suBorrowAmount",
                    "type": "uint256"
                }
            ],
            "name": "calcBorrowAmountForProtectedMint",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "contract IComptroller",
                    "name": "comptroller",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "getAccountLimits",
            "outputs": [
                {
                    "components": [
                        {
                            "internalType": "address[]",
                            "name": "markets",
                            "type": "address[]"
                        },
                        {
                            "internalType": "uint256",
                            "name": "liquidity",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "shortfall",
                            "type": "uint256"
                        }
                    ],
                    "internalType": "struct CompoundLens.AccountLimits",
                    "name": "",
                    "type": "tuple"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "contract IComptroller",
                    "name": "comptroller",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "collateralToken",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "liabilityToken",
                    "type": "address"
                }
            ],
            "name": "getCollateralRate",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "contract ICToken",
                    "name": "comp",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "getCompBalanceMetadata",
            "outputs": [
                {
                    "components": [
                        {
                            "internalType": "uint256",
                            "name": "balance",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "votes",
                            "type": "uint256"
                        },
                        {
                            "internalType": "address",
                            "name": "delegate",
                            "type": "address"
                        }
                    ],
                    "internalType": "struct CompoundLens.CompBalanceMetadata",
                    "name": "",
                    "type": "tuple"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "contract ICToken",
                    "name": "comp",
                    "type": "address"
                },
                {
                    "internalType": "contract IComptroller",
                    "name": "comptroller",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "getCompBalanceMetadataExt",
            "outputs": [
                {
                    "components": [
                        {
                            "internalType": "uint256",
                            "name": "balance",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "votes",
                            "type": "uint256"
                        },
                        {
                            "internalType": "address",
                            "name": "delegate",
                            "type": "address"
                        },
                        {
                            "internalType": "uint256",
                            "name": "allocated",
                            "type": "uint256"
                        }
                    ],
                    "internalType": "struct CompoundLens.CompBalanceMetadataExt",
                    "name": "",
                    "type": "tuple"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "contract ICToken",
                    "name": "comp",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                },
                {
                    "internalType": "uint32[]",
                    "name": "blockNumbers",
                    "type": "uint32[]"
                }
            ],
            "name": "getCompVotes",
            "outputs": [
                {
                    "components": [
                        {
                            "internalType": "uint256",
                            "name": "blockNumber",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "votes",
                            "type": "uint256"
                        }
                    ],
                    "internalType": "struct CompoundLens.CompVotes[]",
                    "name": "",
                    "type": "tuple[]"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "contract IGovernorBravo",
                    "name": "governor",
                    "type": "address"
                },
                {
                    "internalType": "uint256[]",
                    "name": "proposalIds",
                    "type": "uint256[]"
                }
            ],
            "name": "getGovBravoProposals",
            "outputs": [
                {
                    "components": [
                        {
                            "internalType": "uint256",
                            "name": "proposalId",
                            "type": "uint256"
                        },
                        {
                            "internalType": "address",
                            "name": "proposer",
                            "type": "address"
                        },
                        {
                            "internalType": "uint256",
                            "name": "eta",
                            "type": "uint256"
                        },
                        {
                            "internalType": "address[]",
                            "name": "targets",
                            "type": "address[]"
                        },
                        {
                            "internalType": "uint256[]",
                            "name": "values",
                            "type": "uint256[]"
                        },
                        {
                            "internalType": "string[]",
                            "name": "signatures",
                            "type": "string[]"
                        },
                        {
                            "internalType": "bytes[]",
                            "name": "calldatas",
                            "type": "bytes[]"
                        },
                        {
                            "internalType": "uint256",
                            "name": "startBlock",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "endBlock",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "forVotes",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "againstVotes",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "abstainVotes",
                            "type": "uint256"
                        },
                        {
                            "internalType": "bool",
                            "name": "canceled",
                            "type": "bool"
                        },
                        {
                            "internalType": "bool",
                            "name": "executed",
                            "type": "bool"
                        }
                    ],
                    "internalType": "struct CompoundLens.GovBravoProposal[]",
                    "name": "",
                    "type": "tuple[]"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "contract IGovernorBravo",
                    "name": "governor",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "voter",
                    "type": "address"
                },
                {
                    "internalType": "uint256[]",
                    "name": "proposalIds",
                    "type": "uint256[]"
                }
            ],
            "name": "getGovBravoReceipts",
            "outputs": [
                {
                    "components": [
                        {
                            "internalType": "uint256",
                            "name": "proposalId",
                            "type": "uint256"
                        },
                        {
                            "internalType": "bool",
                            "name": "hasVoted",
                            "type": "bool"
                        },
                        {
                            "internalType": "uint8",
                            "name": "support",
                            "type": "uint8"
                        },
                        {
                            "internalType": "uint96",
                            "name": "votes",
                            "type": "uint96"
                        }
                    ],
                    "internalType": "struct CompoundLens.GovBravoReceipt[]",
                    "name": "",
                    "type": "tuple[]"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "contract IGovernorAlpha",
                    "name": "governor",
                    "type": "address"
                },
                {
                    "internalType": "uint256[]",
                    "name": "proposalIds",
                    "type": "uint256[]"
                }
            ],
            "name": "getGovProposals",
            "outputs": [
                {
                    "components": [
                        {
                            "internalType": "uint256",
                            "name": "proposalId",
                            "type": "uint256"
                        },
                        {
                            "internalType": "address",
                            "name": "proposer",
                            "type": "address"
                        },
                        {
                            "internalType": "uint256",
                            "name": "eta",
                            "type": "uint256"
                        },
                        {
                            "internalType": "address[]",
                            "name": "targets",
                            "type": "address[]"
                        },
                        {
                            "internalType": "uint256[]",
                            "name": "values",
                            "type": "uint256[]"
                        },
                        {
                            "internalType": "string[]",
                            "name": "signatures",
                            "type": "string[]"
                        },
                        {
                            "internalType": "bytes[]",
                            "name": "calldatas",
                            "type": "bytes[]"
                        },
                        {
                            "internalType": "uint256",
                            "name": "startBlock",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "endBlock",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "forVotes",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "againstVotes",
                            "type": "uint256"
                        },
                        {
                            "internalType": "bool",
                            "name": "canceled",
                            "type": "bool"
                        },
                        {
                            "internalType": "bool",
                            "name": "executed",
                            "type": "bool"
                        }
                    ],
                    "internalType": "struct CompoundLens.GovProposal[]",
                    "name": "",
                    "type": "tuple[]"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "contract IGovernorAlpha",
                    "name": "governor",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "voter",
                    "type": "address"
                },
                {
                    "internalType": "uint256[]",
                    "name": "proposalIds",
                    "type": "uint256[]"
                }
            ],
            "name": "getGovReceipts",
            "outputs": [
                {
                    "components": [
                        {
                            "internalType": "uint256",
                            "name": "proposalId",
                            "type": "uint256"
                        },
                        {
                            "internalType": "bool",
                            "name": "hasVoted",
                            "type": "bool"
                        },
                        {
                            "internalType": "bool",
                            "name": "support",
                            "type": "bool"
                        },
                        {
                            "internalType": "uint96",
                            "name": "votes",
                            "type": "uint96"
                        }
                    ],
                    "internalType": "struct CompoundLens.GovReceipt[]",
                    "name": "",
                    "type": "tuple[]"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "percentScale",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "version",
            "outputs": [
                {
                    "internalType": "enum Version",
                    "name": "",
                    "type": "uint8"
                }
            ],
            "stateMutability": "pure",
            "type": "function"
        }
    ],
    "Comptroller": [
        {
            "inputs": [],
            "stateMutability": "nonpayable",
            "type": "constructor"
        },
        {
            "inputs": [],
            "name": "AddReservesMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "AddReservesOverflow",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "BorrowAndDepositBackFailed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "BorrowCapReached",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "BorrowCashNotAvailable",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "BorrowMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "BorrowPaused",
            "type": "error"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "usdThreshold",
                    "type": "uint256"
                }
            ],
            "name": "BorrowValueMustBeLargerThanThreshold",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "CantEnterPausedMarket",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "CantExitMarketWithNonZeroBorrowBalance",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "CantSweepUnderlying",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ComptrollerMismatch",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "EitherAssetOrDebtMustBeZero",
            "type": "error"
        },
        {
            "inputs": [
                {
                    "internalType": "uint8",
                    "name": "groupId",
                    "type": "uint8"
                },
                {
                    "internalType": "uint256",
                    "name": "cDepositVal",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "suDepositVal",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "cBorrowVal",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "suBorrowVal",
                    "type": "uint256"
                }
            ],
            "name": "EitherAssetOrDebtMustBeZeroInGroup",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ExpiredSignature",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InsufficientCollateral",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InsufficientShortfall",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InterMintNotAllowed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidAddress",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidAmount",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidBlockNumber",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidCToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidCloseFactor",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidComptroller",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidDiscountRate",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidExchangeRate",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidGroupId",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidInput",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidInterestRateModel",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidMinSuBorrowValue",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidRedeem",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidReduceAmount",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidReserveFactor",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidSignatureForRedeemFaceValue",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidSignatureLength",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidSuToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidTimestamp",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateBorrow_LiquidatorIsBorrower",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateBorrow_RepayAmountIsMax",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateBorrow_RepayAmountIsZero",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateBorrow_SeizeTooMuch",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateCollateralMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketAlreadyListed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketAlreadyUnlisted",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketCanOnlyInitializeOnce",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketNotEmpty",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketNotListed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketPaused",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MinDelayNotReached",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MintMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MintPaused",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MintTokensCantBeZero",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NoRedemptionProvider",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotCToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotEnoughForSeize",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotEnoughRedeemAmount",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotEnoughRedeemTokens",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotEnoughUnderlyingAfterRedeem",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotEnoughUnderlyingForMint",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotLiquidatableYet",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotSuToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyAdmin",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyAdminOrPauser",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyCToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyListedCToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyPausedMarketCanBeUnlisted",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyPendingAdmin",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyRedemptionManager",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OverThreshold",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "PriceError",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ProtectedMint_OnlyAllowAssetsInTheSameGroup",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RedeemMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RedeemTransferOutNotPossible",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RedemptionSeizeTooMuch",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RedemptionSignerNotInitialized",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ReduceReservesCashNotAvailable",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ReduceReservesMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "Reentered",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RepayBorrowMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RepayTokenNotListed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SeizePaused",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SeizeTokenNotListed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "Seize_LiquidatorIsBorrower",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SenderMustBeCToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SetInterestRateModelMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SetReservesFactorMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SupplyCapReached",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TokenInOrAmountInMustBeZero",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TokenTransferInFailed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TokenTransferOutFailed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TooMuchRepay",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TotalBorrowsNotZero",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TotalSupplyNotZero",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TransferNotAllowed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TransferPaused",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "UnderlyingBalanceError",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ZeroAddressNotAllowed",
            "type": "error"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "uint8",
                    "name": "version",
                    "type": "uint8"
                }
            ],
            "name": "Initialized",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "MarketEntered",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "MarketExited",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                }
            ],
            "name": "MarketListed",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                }
            ],
            "name": "MarketUnlisted",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint120",
                    "name": "borrowCap",
                    "type": "uint120"
                },
                {
                    "indexed": false,
                    "internalType": "uint120",
                    "name": "supplyCap",
                    "type": "uint120"
                }
            ],
            "name": "NewCap",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "compLogic",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "redemptionManager",
                    "type": "address"
                }
            ],
            "name": "NewDependencies",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "uint16",
                    "name": "closeFactorPercent",
                    "type": "uint16"
                },
                {
                    "indexed": false,
                    "internalType": "uint32",
                    "name": "minCloseValue",
                    "type": "uint32"
                },
                {
                    "indexed": false,
                    "internalType": "uint32",
                    "name": "minSuBorrowValue",
                    "type": "uint32"
                },
                {
                    "indexed": false,
                    "internalType": "uint32",
                    "name": "minWaitBeforeLiquidatable",
                    "type": "uint32"
                },
                {
                    "indexed": false,
                    "internalType": "uint8",
                    "name": "largestGroupId",
                    "type": "uint8"
                }
            ],
            "name": "NewGlobalConfig",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "uint16",
                    "name": "heteroPercent",
                    "type": "uint16"
                },
                {
                    "indexed": false,
                    "internalType": "uint64",
                    "name": "homoPercent",
                    "type": "uint64"
                },
                {
                    "indexed": false,
                    "internalType": "uint64",
                    "name": "sutokenPercent",
                    "type": "uint64"
                }
            ],
            "name": "NewLiquidationIncentive",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "ctoken",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "bool",
                    "name": "mintPaused",
                    "type": "bool"
                },
                {
                    "indexed": false,
                    "internalType": "bool",
                    "name": "borrowPaused",
                    "type": "bool"
                },
                {
                    "indexed": false,
                    "internalType": "bool",
                    "name": "transferPaused",
                    "type": "bool"
                },
                {
                    "indexed": false,
                    "internalType": "bool",
                    "name": "seizePaused",
                    "type": "bool"
                }
            ],
            "name": "NewPause",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "oldPauseGuardian",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "newPauseGuardian",
                    "type": "address"
                }
            ],
            "name": "NewPauseGuardian",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "priceOracle",
                    "type": "address"
                }
            ],
            "name": "NewPriceOracle",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "timelock",
                    "type": "address"
                }
            ],
            "name": "NewTimelock",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "uint8",
                    "name": "groupId",
                    "type": "uint8"
                }
            ],
            "name": "RemoveAssetGroup",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "indexed": true,
                    "internalType": "bytes32",
                    "name": "previousAdminRole",
                    "type": "bytes32"
                },
                {
                    "indexed": true,
                    "internalType": "bytes32",
                    "name": "newAdminRole",
                    "type": "bytes32"
                }
            ],
            "name": "RoleAdminChanged",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "sender",
                    "type": "address"
                }
            ],
            "name": "RoleGranted",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "sender",
                    "type": "address"
                }
            ],
            "name": "RoleRevoked",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "uint8",
                    "name": "groupId",
                    "type": "uint8"
                },
                {
                    "indexed": false,
                    "internalType": "uint16",
                    "name": "intraCRatePercent",
                    "type": "uint16"
                },
                {
                    "indexed": false,
                    "internalType": "uint16",
                    "name": "intraMintRatePercent",
                    "type": "uint16"
                },
                {
                    "indexed": false,
                    "internalType": "uint16",
                    "name": "intraSuRatePercent",
                    "type": "uint16"
                },
                {
                    "indexed": false,
                    "internalType": "uint16",
                    "name": "interCRatePercent",
                    "type": "uint16"
                },
                {
                    "indexed": false,
                    "internalType": "uint16",
                    "name": "interSuRatePercent",
                    "type": "uint16"
                },
                {
                    "indexed": false,
                    "internalType": "bool",
                    "name": "isNewGroup",
                    "type": "bool"
                }
            ],
            "name": "UpdateAssetGroup",
            "type": "event"
        },
        {
            "inputs": [],
            "name": "DEFAULT_ADMIN_ROLE",
            "outputs": [
                {
                    "internalType": "bytes32",
                    "name": "",
                    "type": "bytes32"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "PAUSER_ROLE",
            "outputs": [
                {
                    "internalType": "bytes32",
                    "name": "",
                    "type": "bytes32"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                },
                {
                    "internalType": "uint8",
                    "name": "newGroupId",
                    "type": "uint8"
                }
            ],
            "name": "_changeGroupIdForAsset",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                },
                {
                    "internalType": "bool",
                    "name": "mintPaused",
                    "type": "bool"
                },
                {
                    "internalType": "bool",
                    "name": "borrowPaused",
                    "type": "bool"
                },
                {
                    "internalType": "bool",
                    "name": "transferPaused",
                    "type": "bool"
                },
                {
                    "internalType": "bool",
                    "name": "seizePaused",
                    "type": "bool"
                }
            ],
            "name": "_pause",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address[]",
                    "name": "cTokens",
                    "type": "address[]"
                },
                {
                    "internalType": "uint120[]",
                    "name": "borrowCaps",
                    "type": "uint120[]"
                },
                {
                    "internalType": "uint120[]",
                    "name": "supplyCaps",
                    "type": "uint120[]"
                }
            ],
            "name": "_setCaps",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "components": [
                        {
                            "internalType": "uint16",
                            "name": "closeFactorPercent",
                            "type": "uint16"
                        },
                        {
                            "internalType": "uint32",
                            "name": "minCloseValue",
                            "type": "uint32"
                        },
                        {
                            "internalType": "uint32",
                            "name": "minSuBorrowValue",
                            "type": "uint32"
                        },
                        {
                            "internalType": "uint32",
                            "name": "minWaitBeforeLiquidatable",
                            "type": "uint32"
                        },
                        {
                            "internalType": "uint8",
                            "name": "largestGroupId",
                            "type": "uint8"
                        }
                    ],
                    "internalType": "struct GlobalConfig",
                    "name": "globalConfig_",
                    "type": "tuple"
                }
            ],
            "name": "_setGlobalConfig",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_governanceToken",
                    "type": "address"
                }
            ],
            "name": "_setGovTokenAddress",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bool",
                    "name": "allowed",
                    "type": "bool"
                }
            ],
            "name": "_setInterMintAllowed",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint8",
                    "name": "largestGroupId",
                    "type": "uint8"
                }
            ],
            "name": "_setLargestGroupId",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "components": [
                        {
                            "internalType": "uint16",
                            "name": "heteroPercent",
                            "type": "uint16"
                        },
                        {
                            "internalType": "uint16",
                            "name": "homoPercent",
                            "type": "uint16"
                        },
                        {
                            "internalType": "uint16",
                            "name": "sutokenPercent",
                            "type": "uint16"
                        }
                    ],
                    "internalType": "struct LiquidationIncentive",
                    "name": "liquidationIncentive_",
                    "type": "tuple"
                }
            ],
            "name": "_setLiquidationIncentive",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "newPauseGuardian",
                    "type": "address"
                }
            ],
            "name": "_setPauseGuardian",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_oracle",
                    "type": "address"
                }
            ],
            "name": "_setPriceOracle",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_timelock",
                    "type": "address"
                }
            ],
            "name": "_setTimelock",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                },
                {
                    "internalType": "uint8",
                    "name": "groupId",
                    "type": "uint8"
                },
                {
                    "internalType": "uint120",
                    "name": "borrowCap",
                    "type": "uint120"
                },
                {
                    "internalType": "uint120",
                    "name": "supplyCap",
                    "type": "uint120"
                }
            ],
            "name": "_supportMarket",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                }
            ],
            "name": "_unlistMarket",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "name": "accountAssets",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "name": "allMarkets",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint8",
                    "name": "",
                    "type": "uint8"
                }
            ],
            "name": "assetGroup",
            "outputs": [
                {
                    "internalType": "uint8",
                    "name": "groupId",
                    "type": "uint8"
                },
                {
                    "internalType": "uint16",
                    "name": "intraCRatePercent",
                    "type": "uint16"
                },
                {
                    "internalType": "uint16",
                    "name": "intraMintRatePercent",
                    "type": "uint16"
                },
                {
                    "internalType": "uint16",
                    "name": "intraSuRatePercent",
                    "type": "uint16"
                },
                {
                    "internalType": "uint16",
                    "name": "interCRatePercent",
                    "type": "uint16"
                },
                {
                    "internalType": "uint16",
                    "name": "interSuRatePercent",
                    "type": "uint16"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "borrower",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "borrowAmount",
                    "type": "uint256"
                }
            ],
            "name": "borrowAllowed",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "borrower",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "borrowAmount",
                    "type": "uint256"
                }
            ],
            "name": "borrowVerify",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "compLogic",
            "outputs": [
                {
                    "internalType": "contract ICompLogic",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address[]",
                    "name": "cTokens",
                    "type": "address[]"
                }
            ],
            "name": "enterMarkets",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cTokenAddress",
                    "type": "address"
                }
            ],
            "name": "exitMarket",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "getAllMarkets",
            "outputs": [
                {
                    "internalType": "address[]",
                    "name": "",
                    "type": "address[]"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "getAssetsIn",
            "outputs": [
                {
                    "internalType": "address[]",
                    "name": "",
                    "type": "address[]"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "cTokenModify",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "redeemTokens",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "borrowAmount",
                    "type": "uint256"
                }
            ],
            "name": "getHypotheticalAccountLiquidity",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                }
            ],
            "name": "getRoleAdmin",
            "outputs": [
                {
                    "internalType": "bytes32",
                    "name": "",
                    "type": "bytes32"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                }
            ],
            "name": "getUnderlyingPriceNormalized",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "globalConfig",
            "outputs": [
                {
                    "internalType": "uint16",
                    "name": "closeFactorPercent",
                    "type": "uint16"
                },
                {
                    "internalType": "uint32",
                    "name": "minCloseValue",
                    "type": "uint32"
                },
                {
                    "internalType": "uint32",
                    "name": "minSuBorrowValue",
                    "type": "uint32"
                },
                {
                    "internalType": "uint32",
                    "name": "minWaitBeforeLiquidatable",
                    "type": "uint32"
                },
                {
                    "internalType": "uint8",
                    "name": "largestGroupId",
                    "type": "uint8"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "governanceToken",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "grantRole",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "hasRole",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_admin",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "_gov",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "_compLogic",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "_redemptionManager",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "_timelock",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "_oracle",
                    "type": "address"
                }
            ],
            "name": "initialize",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "interMintAllowed",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "isComptroller",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "asset",
                    "type": "address"
                }
            ],
            "name": "isListed",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "lastBorrowedAt",
            "outputs": [
                {
                    "internalType": "uint48",
                    "name": "",
                    "type": "uint48"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cTokenBorrowed",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "cTokenCollateral",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "liquidator",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "borrower",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "repayAmount",
                    "type": "uint256"
                }
            ],
            "name": "liquidateBorrowAllowed",
            "outputs": [],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cTokenBorrowed",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "cTokenCollateral",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "liquidator",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "borrower",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "actualRepayAmount",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "seizeTokens",
                    "type": "uint256"
                }
            ],
            "name": "liquidateBorrowVerify",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "liquidationIncentive",
            "outputs": [
                {
                    "internalType": "uint16",
                    "name": "heteroPercent",
                    "type": "uint16"
                },
                {
                    "internalType": "uint16",
                    "name": "homoPercent",
                    "type": "uint16"
                },
                {
                    "internalType": "uint16",
                    "name": "sutokenPercent",
                    "type": "uint16"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "marketConfig",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "mintPaused",
                    "type": "bool"
                },
                {
                    "internalType": "bool",
                    "name": "borrowPaused",
                    "type": "bool"
                },
                {
                    "internalType": "bool",
                    "name": "transferPaused",
                    "type": "bool"
                },
                {
                    "internalType": "bool",
                    "name": "seizePaused",
                    "type": "bool"
                },
                {
                    "internalType": "uint120",
                    "name": "borrowCap",
                    "type": "uint120"
                },
                {
                    "internalType": "uint120",
                    "name": "supplyCap",
                    "type": "uint120"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "markets",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "isListed",
                    "type": "bool"
                },
                {
                    "internalType": "uint8",
                    "name": "assetGroupId",
                    "type": "uint8"
                },
                {
                    "internalType": "bool",
                    "name": "isComped",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "minter",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "mintAmount",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "exchangeRate",
                    "type": "uint256"
                }
            ],
            "name": "mintAllowed",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "oracle",
            "outputs": [
                {
                    "internalType": "contract IPriceOracle",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "pauseGuardian",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "redeemer",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "redeemTokens",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "exchangeRate",
                    "type": "uint256"
                }
            ],
            "name": "redeemAllowed",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "redeemer",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "redeemAmount",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "redeemTokens",
                    "type": "uint256"
                }
            ],
            "name": "redeemVerify",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "redemptionManager",
            "outputs": [
                {
                    "internalType": "contract IRedemptionManager",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint8",
                    "name": "groupId",
                    "type": "uint8"
                }
            ],
            "name": "removeAssetGroup",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "renounceRole",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "payer",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "borrower",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "repayAmount",
                    "type": "uint256"
                }
            ],
            "name": "repayBorrowAllowed",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "payer",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "borrower",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "actualRepayAmount",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "borrowIndex",
                    "type": "uint256"
                }
            ],
            "name": "repayBorrowVerify",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "revokeRole",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cTokenCollateral",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "cTokenBorrowed",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "liquidator",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "borrower",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "seizeTokens",
                    "type": "uint256"
                }
            ],
            "name": "seizeAllowed",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint8",
                    "name": "groupId",
                    "type": "uint8"
                },
                {
                    "internalType": "uint16",
                    "name": "intraCRatePercent",
                    "type": "uint16"
                },
                {
                    "internalType": "uint16",
                    "name": "intraMintRatePercent",
                    "type": "uint16"
                },
                {
                    "internalType": "uint16",
                    "name": "intraSuRatePercent",
                    "type": "uint16"
                },
                {
                    "internalType": "uint16",
                    "name": "interCRatePercent",
                    "type": "uint16"
                },
                {
                    "internalType": "uint16",
                    "name": "interSuRatePercent",
                    "type": "uint16"
                }
            ],
            "name": "setAssetGroup",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes4",
                    "name": "interfaceId",
                    "type": "bytes4"
                }
            ],
            "name": "supportsInterface",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "timelock",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "src",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "dst",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "transferTokens",
                    "type": "uint256"
                }
            ],
            "name": "transferAllowed",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "version",
            "outputs": [
                {
                    "internalType": "enum Version",
                    "name": "",
                    "type": "uint8"
                }
            ],
            "stateMutability": "pure",
            "type": "function"
        }
    ],
    "ComptrollerStorage": [
        {
            "inputs": [],
            "name": "PAUSER_ROLE",
            "outputs": [
                {
                    "internalType": "bytes32",
                    "name": "",
                    "type": "bytes32"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "name": "accountAssets",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "name": "allMarkets",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint8",
                    "name": "",
                    "type": "uint8"
                }
            ],
            "name": "assetGroup",
            "outputs": [
                {
                    "internalType": "uint8",
                    "name": "groupId",
                    "type": "uint8"
                },
                {
                    "internalType": "uint16",
                    "name": "intraCRatePercent",
                    "type": "uint16"
                },
                {
                    "internalType": "uint16",
                    "name": "intraMintRatePercent",
                    "type": "uint16"
                },
                {
                    "internalType": "uint16",
                    "name": "intraSuRatePercent",
                    "type": "uint16"
                },
                {
                    "internalType": "uint16",
                    "name": "interCRatePercent",
                    "type": "uint16"
                },
                {
                    "internalType": "uint16",
                    "name": "interSuRatePercent",
                    "type": "uint16"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "compLogic",
            "outputs": [
                {
                    "internalType": "contract ICompLogic",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "globalConfig",
            "outputs": [
                {
                    "internalType": "uint16",
                    "name": "closeFactorPercent",
                    "type": "uint16"
                },
                {
                    "internalType": "uint32",
                    "name": "minCloseValue",
                    "type": "uint32"
                },
                {
                    "internalType": "uint32",
                    "name": "minSuBorrowValue",
                    "type": "uint32"
                },
                {
                    "internalType": "uint32",
                    "name": "minWaitBeforeLiquidatable",
                    "type": "uint32"
                },
                {
                    "internalType": "uint8",
                    "name": "largestGroupId",
                    "type": "uint8"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "governanceToken",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "interMintAllowed",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "isComptroller",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "lastBorrowedAt",
            "outputs": [
                {
                    "internalType": "uint48",
                    "name": "",
                    "type": "uint48"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "liquidationIncentive",
            "outputs": [
                {
                    "internalType": "uint16",
                    "name": "heteroPercent",
                    "type": "uint16"
                },
                {
                    "internalType": "uint16",
                    "name": "homoPercent",
                    "type": "uint16"
                },
                {
                    "internalType": "uint16",
                    "name": "sutokenPercent",
                    "type": "uint16"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "marketConfig",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "mintPaused",
                    "type": "bool"
                },
                {
                    "internalType": "bool",
                    "name": "borrowPaused",
                    "type": "bool"
                },
                {
                    "internalType": "bool",
                    "name": "transferPaused",
                    "type": "bool"
                },
                {
                    "internalType": "bool",
                    "name": "seizePaused",
                    "type": "bool"
                },
                {
                    "internalType": "uint120",
                    "name": "borrowCap",
                    "type": "uint120"
                },
                {
                    "internalType": "uint120",
                    "name": "supplyCap",
                    "type": "uint120"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "markets",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "isListed",
                    "type": "bool"
                },
                {
                    "internalType": "uint8",
                    "name": "assetGroupId",
                    "type": "uint8"
                },
                {
                    "internalType": "bool",
                    "name": "isComped",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "oracle",
            "outputs": [
                {
                    "internalType": "contract IPriceOracle",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "pauseGuardian",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "redemptionManager",
            "outputs": [
                {
                    "internalType": "contract IRedemptionManager",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "timelock",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        }
    ],
    "LiquityMath": [],
    "MockComptroller": [
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_admin",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "_oracle",
                    "type": "address"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "constructor"
        },
        {
            "inputs": [],
            "name": "AddReservesMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "AddReservesOverflow",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "BorrowAndDepositBackFailed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "BorrowCapReached",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "BorrowCashNotAvailable",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "BorrowMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "BorrowPaused",
            "type": "error"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "usdThreshold",
                    "type": "uint256"
                }
            ],
            "name": "BorrowValueMustBeLargerThanThreshold",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "CantEnterPausedMarket",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "CantExitMarketWithNonZeroBorrowBalance",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "CantSweepUnderlying",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ComptrollerMismatch",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "EitherAssetOrDebtMustBeZero",
            "type": "error"
        },
        {
            "inputs": [
                {
                    "internalType": "uint8",
                    "name": "groupId",
                    "type": "uint8"
                },
                {
                    "internalType": "uint256",
                    "name": "cDepositVal",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "suDepositVal",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "cBorrowVal",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "suBorrowVal",
                    "type": "uint256"
                }
            ],
            "name": "EitherAssetOrDebtMustBeZeroInGroup",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ExpiredSignature",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InsufficientCollateral",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InsufficientShortfall",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InterMintNotAllowed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidAddress",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidAmount",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidBlockNumber",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidCToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidCloseFactor",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidComptroller",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidDiscountRate",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidExchangeRate",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidGroupId",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidInput",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidInterestRateModel",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidMinSuBorrowValue",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidRedeem",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidReduceAmount",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidReserveFactor",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidSignatureForRedeemFaceValue",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidSignatureLength",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidSuToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidTimestamp",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateBorrow_LiquidatorIsBorrower",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateBorrow_RepayAmountIsMax",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateBorrow_RepayAmountIsZero",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateBorrow_SeizeTooMuch",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateCollateralMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketAlreadyListed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketAlreadyUnlisted",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketCanOnlyInitializeOnce",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketNotEmpty",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketNotListed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketPaused",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MinDelayNotReached",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MintMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MintPaused",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MintTokensCantBeZero",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NoRedemptionProvider",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotCToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotEnoughForSeize",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotEnoughRedeemAmount",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotEnoughRedeemTokens",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotEnoughUnderlyingAfterRedeem",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotEnoughUnderlyingForMint",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotLiquidatableYet",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotSuToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyAdmin",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyAdminOrPauser",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyCToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyListedCToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyPausedMarketCanBeUnlisted",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyPendingAdmin",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyRedemptionManager",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OverThreshold",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "PriceError",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ProtectedMint_OnlyAllowAssetsInTheSameGroup",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RedeemMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RedeemTransferOutNotPossible",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RedemptionSeizeTooMuch",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RedemptionSignerNotInitialized",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ReduceReservesCashNotAvailable",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ReduceReservesMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "Reentered",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RepayBorrowMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RepayTokenNotListed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SeizePaused",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SeizeTokenNotListed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "Seize_LiquidatorIsBorrower",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SenderMustBeCToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SetInterestRateModelMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SetReservesFactorMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SupplyCapReached",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TokenInOrAmountInMustBeZero",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TokenTransferInFailed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TokenTransferOutFailed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TooMuchRepay",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TotalBorrowsNotZero",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TotalSupplyNotZero",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TransferNotAllowed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TransferPaused",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "UnderlyingBalanceError",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ZeroAddressNotAllowed",
            "type": "error"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "MarketEntered",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "MarketExited",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                }
            ],
            "name": "MarketListed",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                }
            ],
            "name": "MarketUnlisted",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint120",
                    "name": "borrowCap",
                    "type": "uint120"
                },
                {
                    "indexed": false,
                    "internalType": "uint120",
                    "name": "supplyCap",
                    "type": "uint120"
                }
            ],
            "name": "NewCap",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "compLogic",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "redemptionManager",
                    "type": "address"
                }
            ],
            "name": "NewDependencies",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "uint16",
                    "name": "closeFactorPercent",
                    "type": "uint16"
                },
                {
                    "indexed": false,
                    "internalType": "uint32",
                    "name": "minCloseValue",
                    "type": "uint32"
                },
                {
                    "indexed": false,
                    "internalType": "uint32",
                    "name": "minSuBorrowValue",
                    "type": "uint32"
                },
                {
                    "indexed": false,
                    "internalType": "uint32",
                    "name": "minWaitBeforeLiquidatable",
                    "type": "uint32"
                },
                {
                    "indexed": false,
                    "internalType": "uint8",
                    "name": "largestGroupId",
                    "type": "uint8"
                }
            ],
            "name": "NewGlobalConfig",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "uint16",
                    "name": "heteroPercent",
                    "type": "uint16"
                },
                {
                    "indexed": false,
                    "internalType": "uint64",
                    "name": "homoPercent",
                    "type": "uint64"
                },
                {
                    "indexed": false,
                    "internalType": "uint64",
                    "name": "sutokenPercent",
                    "type": "uint64"
                }
            ],
            "name": "NewLiquidationIncentive",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "ctoken",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "bool",
                    "name": "mintPaused",
                    "type": "bool"
                },
                {
                    "indexed": false,
                    "internalType": "bool",
                    "name": "borrowPaused",
                    "type": "bool"
                },
                {
                    "indexed": false,
                    "internalType": "bool",
                    "name": "transferPaused",
                    "type": "bool"
                },
                {
                    "indexed": false,
                    "internalType": "bool",
                    "name": "seizePaused",
                    "type": "bool"
                }
            ],
            "name": "NewPause",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "oldPauseGuardian",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "newPauseGuardian",
                    "type": "address"
                }
            ],
            "name": "NewPauseGuardian",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "priceOracle",
                    "type": "address"
                }
            ],
            "name": "NewPriceOracle",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "timelock",
                    "type": "address"
                }
            ],
            "name": "NewTimelock",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "uint8",
                    "name": "groupId",
                    "type": "uint8"
                }
            ],
            "name": "RemoveAssetGroup",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "indexed": true,
                    "internalType": "bytes32",
                    "name": "previousAdminRole",
                    "type": "bytes32"
                },
                {
                    "indexed": true,
                    "internalType": "bytes32",
                    "name": "newAdminRole",
                    "type": "bytes32"
                }
            ],
            "name": "RoleAdminChanged",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "sender",
                    "type": "address"
                }
            ],
            "name": "RoleGranted",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "sender",
                    "type": "address"
                }
            ],
            "name": "RoleRevoked",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "uint8",
                    "name": "groupId",
                    "type": "uint8"
                },
                {
                    "indexed": false,
                    "internalType": "uint16",
                    "name": "intraCRatePercent",
                    "type": "uint16"
                },
                {
                    "indexed": false,
                    "internalType": "uint16",
                    "name": "intraMintRatePercent",
                    "type": "uint16"
                },
                {
                    "indexed": false,
                    "internalType": "uint16",
                    "name": "intraSuRatePercent",
                    "type": "uint16"
                },
                {
                    "indexed": false,
                    "internalType": "uint16",
                    "name": "interCRatePercent",
                    "type": "uint16"
                },
                {
                    "indexed": false,
                    "internalType": "uint16",
                    "name": "interSuRatePercent",
                    "type": "uint16"
                },
                {
                    "indexed": false,
                    "internalType": "bool",
                    "name": "isNewGroup",
                    "type": "bool"
                }
            ],
            "name": "UpdateAssetGroup",
            "type": "event"
        },
        {
            "inputs": [],
            "name": "DEFAULT_ADMIN_ROLE",
            "outputs": [
                {
                    "internalType": "bytes32",
                    "name": "",
                    "type": "bytes32"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "PAUSER_ROLE",
            "outputs": [
                {
                    "internalType": "bytes32",
                    "name": "",
                    "type": "bytes32"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                },
                {
                    "internalType": "uint8",
                    "name": "newGroupId",
                    "type": "uint8"
                }
            ],
            "name": "_changeGroupIdForAsset",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                },
                {
                    "internalType": "bool",
                    "name": "mintPaused",
                    "type": "bool"
                },
                {
                    "internalType": "bool",
                    "name": "borrowPaused",
                    "type": "bool"
                },
                {
                    "internalType": "bool",
                    "name": "transferPaused",
                    "type": "bool"
                },
                {
                    "internalType": "bool",
                    "name": "seizePaused",
                    "type": "bool"
                }
            ],
            "name": "_pause",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address[]",
                    "name": "cTokens",
                    "type": "address[]"
                },
                {
                    "internalType": "uint120[]",
                    "name": "borrowCaps",
                    "type": "uint120[]"
                },
                {
                    "internalType": "uint120[]",
                    "name": "supplyCaps",
                    "type": "uint120[]"
                }
            ],
            "name": "_setCaps",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "components": [
                        {
                            "internalType": "uint16",
                            "name": "closeFactorPercent",
                            "type": "uint16"
                        },
                        {
                            "internalType": "uint32",
                            "name": "minCloseValue",
                            "type": "uint32"
                        },
                        {
                            "internalType": "uint32",
                            "name": "minSuBorrowValue",
                            "type": "uint32"
                        },
                        {
                            "internalType": "uint32",
                            "name": "minWaitBeforeLiquidatable",
                            "type": "uint32"
                        },
                        {
                            "internalType": "uint8",
                            "name": "largestGroupId",
                            "type": "uint8"
                        }
                    ],
                    "internalType": "struct GlobalConfig",
                    "name": "globalConfig_",
                    "type": "tuple"
                }
            ],
            "name": "_setGlobalConfig",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_governanceToken",
                    "type": "address"
                }
            ],
            "name": "_setGovTokenAddress",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bool",
                    "name": "allowed",
                    "type": "bool"
                }
            ],
            "name": "_setInterMintAllowed",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint8",
                    "name": "largestGroupId",
                    "type": "uint8"
                }
            ],
            "name": "_setLargestGroupId",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "components": [
                        {
                            "internalType": "uint16",
                            "name": "heteroPercent",
                            "type": "uint16"
                        },
                        {
                            "internalType": "uint16",
                            "name": "homoPercent",
                            "type": "uint16"
                        },
                        {
                            "internalType": "uint16",
                            "name": "sutokenPercent",
                            "type": "uint16"
                        }
                    ],
                    "internalType": "struct LiquidationIncentive",
                    "name": "liquidationIncentive_",
                    "type": "tuple"
                }
            ],
            "name": "_setLiquidationIncentive",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "newPauseGuardian",
                    "type": "address"
                }
            ],
            "name": "_setPauseGuardian",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_oracle",
                    "type": "address"
                }
            ],
            "name": "_setPriceOracle",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_timelock",
                    "type": "address"
                }
            ],
            "name": "_setTimelock",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                },
                {
                    "internalType": "uint8",
                    "name": "groupId",
                    "type": "uint8"
                },
                {
                    "internalType": "uint120",
                    "name": "borrowCap",
                    "type": "uint120"
                },
                {
                    "internalType": "uint120",
                    "name": "supplyCap",
                    "type": "uint120"
                }
            ],
            "name": "_supportMarket",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                }
            ],
            "name": "_unlistMarket",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "name": "accountAssets",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "name": "allMarkets",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint8",
                    "name": "",
                    "type": "uint8"
                }
            ],
            "name": "assetGroup",
            "outputs": [
                {
                    "internalType": "uint8",
                    "name": "groupId",
                    "type": "uint8"
                },
                {
                    "internalType": "uint16",
                    "name": "intraCRatePercent",
                    "type": "uint16"
                },
                {
                    "internalType": "uint16",
                    "name": "intraMintRatePercent",
                    "type": "uint16"
                },
                {
                    "internalType": "uint16",
                    "name": "intraSuRatePercent",
                    "type": "uint16"
                },
                {
                    "internalType": "uint16",
                    "name": "interCRatePercent",
                    "type": "uint16"
                },
                {
                    "internalType": "uint16",
                    "name": "interSuRatePercent",
                    "type": "uint16"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "borrower",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "borrowAmount",
                    "type": "uint256"
                }
            ],
            "name": "borrowAllowed",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "borrower",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "borrowAmount",
                    "type": "uint256"
                }
            ],
            "name": "borrowVerify",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "compLogic",
            "outputs": [
                {
                    "internalType": "contract ICompLogic",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "owner",
                    "type": "address"
                },
                {
                    "internalType": "address[]",
                    "name": "cTokens",
                    "type": "address[]"
                }
            ],
            "name": "enterMarketsFor",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "owner",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "cTokenAddress",
                    "type": "address"
                }
            ],
            "name": "exitMarketFor",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "getAllMarkets",
            "outputs": [
                {
                    "internalType": "address[]",
                    "name": "",
                    "type": "address[]"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "getAssetsIn",
            "outputs": [
                {
                    "internalType": "address[]",
                    "name": "",
                    "type": "address[]"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "cTokenModify",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "redeemTokens",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "borrowAmount",
                    "type": "uint256"
                }
            ],
            "name": "getHypoStep1",
            "outputs": [
                {
                    "components": [
                        {
                            "internalType": "uint8",
                            "name": "groupId",
                            "type": "uint8"
                        },
                        {
                            "internalType": "uint256",
                            "name": "cDepositVal",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "cBorrowVal",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "suDepositVal",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "suBorrowVal",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "intraCRate",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "intraMintRate",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "intraSuRate",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "interCRate",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "interSuRate",
                            "type": "uint256"
                        }
                    ],
                    "internalType": "struct GroupVar[]",
                    "name": "",
                    "type": "tuple[]"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "cTokenModify",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "redeemTokens",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "borrowAmount",
                    "type": "uint256"
                }
            ],
            "name": "getHypoStep2",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                },
                {
                    "components": [
                        {
                            "internalType": "uint8",
                            "name": "groupId",
                            "type": "uint8"
                        },
                        {
                            "internalType": "uint256",
                            "name": "cDepositVal",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "cBorrowVal",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "suDepositVal",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "suBorrowVal",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "intraCRate",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "intraMintRate",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "intraSuRate",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "interCRate",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "interSuRate",
                            "type": "uint256"
                        }
                    ],
                    "internalType": "struct GroupVar",
                    "name": "",
                    "type": "tuple"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "cTokenModify",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "redeemTokens",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "borrowAmount",
                    "type": "uint256"
                }
            ],
            "name": "getHypotheticalAccountLiquidity",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                }
            ],
            "name": "getRoleAdmin",
            "outputs": [
                {
                    "internalType": "bytes32",
                    "name": "",
                    "type": "bytes32"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                }
            ],
            "name": "getUnderlyingPriceNormalized",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "globalConfig",
            "outputs": [
                {
                    "internalType": "uint16",
                    "name": "closeFactorPercent",
                    "type": "uint16"
                },
                {
                    "internalType": "uint32",
                    "name": "minCloseValue",
                    "type": "uint32"
                },
                {
                    "internalType": "uint32",
                    "name": "minSuBorrowValue",
                    "type": "uint32"
                },
                {
                    "internalType": "uint32",
                    "name": "minWaitBeforeLiquidatable",
                    "type": "uint32"
                },
                {
                    "internalType": "uint8",
                    "name": "largestGroupId",
                    "type": "uint8"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "governanceToken",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "grantRole",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "hasRole",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "interMintAllowed",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "isComptroller",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "asset",
                    "type": "address"
                }
            ],
            "name": "isListed",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "lastBorrowedAt",
            "outputs": [
                {
                    "internalType": "uint48",
                    "name": "",
                    "type": "uint48"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cTokenBorrowed",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "cTokenCollateral",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "liquidator",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "borrower",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "repayAmount",
                    "type": "uint256"
                }
            ],
            "name": "liquidateBorrowAllowed",
            "outputs": [],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cTokenBorrowed",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "cTokenCollateral",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "liquidator",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "borrower",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "actualRepayAmount",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "seizeTokens",
                    "type": "uint256"
                }
            ],
            "name": "liquidateBorrowVerify",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "liquidationIncentive",
            "outputs": [
                {
                    "internalType": "uint16",
                    "name": "heteroPercent",
                    "type": "uint16"
                },
                {
                    "internalType": "uint16",
                    "name": "homoPercent",
                    "type": "uint16"
                },
                {
                    "internalType": "uint16",
                    "name": "sutokenPercent",
                    "type": "uint16"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "marketConfig",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "mintPaused",
                    "type": "bool"
                },
                {
                    "internalType": "bool",
                    "name": "borrowPaused",
                    "type": "bool"
                },
                {
                    "internalType": "bool",
                    "name": "transferPaused",
                    "type": "bool"
                },
                {
                    "internalType": "bool",
                    "name": "seizePaused",
                    "type": "bool"
                },
                {
                    "internalType": "uint120",
                    "name": "borrowCap",
                    "type": "uint120"
                },
                {
                    "internalType": "uint120",
                    "name": "supplyCap",
                    "type": "uint120"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "markets",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "isListed",
                    "type": "bool"
                },
                {
                    "internalType": "uint8",
                    "name": "assetGroupId",
                    "type": "uint8"
                },
                {
                    "internalType": "bool",
                    "name": "isComped",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "minter",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "mintAmount",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "exchangeRate",
                    "type": "uint256"
                }
            ],
            "name": "mintAllowed",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "oracle",
            "outputs": [
                {
                    "internalType": "contract IPriceOracle",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "pauseGuardian",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "redeemer",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "redeemTokens",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "exchangeRate",
                    "type": "uint256"
                }
            ],
            "name": "redeemAllowed",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "redeemer",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "redeemAmount",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "redeemTokens",
                    "type": "uint256"
                }
            ],
            "name": "redeemVerify",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "redemptionManager",
            "outputs": [
                {
                    "internalType": "contract IRedemptionManager",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint8",
                    "name": "groupId",
                    "type": "uint8"
                }
            ],
            "name": "removeAssetGroup",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "renounceRole",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "payer",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "borrower",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "repayAmount",
                    "type": "uint256"
                }
            ],
            "name": "repayBorrowAllowed",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "payer",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "borrower",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "actualRepayAmount",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "borrowIndex",
                    "type": "uint256"
                }
            ],
            "name": "repayBorrowVerify",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "revokeRole",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cTokenCollateral",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "cTokenBorrowed",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "liquidator",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "borrower",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "seizeTokens",
                    "type": "uint256"
                }
            ],
            "name": "seizeAllowed",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint8",
                    "name": "groupId",
                    "type": "uint8"
                },
                {
                    "internalType": "uint16",
                    "name": "intraCRatePercent",
                    "type": "uint16"
                },
                {
                    "internalType": "uint16",
                    "name": "intraMintRatePercent",
                    "type": "uint16"
                },
                {
                    "internalType": "uint16",
                    "name": "intraSuRatePercent",
                    "type": "uint16"
                },
                {
                    "internalType": "uint16",
                    "name": "interCRatePercent",
                    "type": "uint16"
                },
                {
                    "internalType": "uint16",
                    "name": "interSuRatePercent",
                    "type": "uint16"
                }
            ],
            "name": "setAssetGroup",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes4",
                    "name": "interfaceId",
                    "type": "bytes4"
                }
            ],
            "name": "supportsInterface",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "timelock",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "src",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "dst",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "transferTokens",
                    "type": "uint256"
                }
            ],
            "name": "transferAllowed",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "version",
            "outputs": [
                {
                    "internalType": "enum Version",
                    "name": "",
                    "type": "uint8"
                }
            ],
            "stateMutability": "pure",
            "type": "function"
        }
    ],
    "RedemptionManager": [
        {
            "inputs": [],
            "stateMutability": "nonpayable",
            "type": "constructor"
        },
        {
            "inputs": [],
            "name": "AddReservesMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "AddReservesOverflow",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "BorrowAndDepositBackFailed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "BorrowCapReached",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "BorrowCashNotAvailable",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "BorrowMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "BorrowPaused",
            "type": "error"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "usdThreshold",
                    "type": "uint256"
                }
            ],
            "name": "BorrowValueMustBeLargerThanThreshold",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "CantEnterPausedMarket",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "CantExitMarketWithNonZeroBorrowBalance",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "CantSweepUnderlying",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ComptrollerMismatch",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "EitherAssetOrDebtMustBeZero",
            "type": "error"
        },
        {
            "inputs": [
                {
                    "internalType": "uint8",
                    "name": "groupId",
                    "type": "uint8"
                },
                {
                    "internalType": "uint256",
                    "name": "cDepositVal",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "suDepositVal",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "cBorrowVal",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "suBorrowVal",
                    "type": "uint256"
                }
            ],
            "name": "EitherAssetOrDebtMustBeZeroInGroup",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ExpiredSignature",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InsufficientCollateral",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InsufficientShortfall",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InterMintNotAllowed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidAddress",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidAmount",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidBlockNumber",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidCToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidCloseFactor",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidComptroller",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidDiscountRate",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidExchangeRate",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidGroupId",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidInput",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidInterestRateModel",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidMinSuBorrowValue",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidRedeem",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidReduceAmount",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidReserveFactor",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidSignatureForRedeemFaceValue",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidSignatureLength",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidSuToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidTimestamp",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateBorrow_LiquidatorIsBorrower",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateBorrow_RepayAmountIsMax",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateBorrow_RepayAmountIsZero",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateBorrow_SeizeTooMuch",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateCollateralMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketAlreadyListed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketAlreadyUnlisted",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketCanOnlyInitializeOnce",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketNotEmpty",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketNotListed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketPaused",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MinDelayNotReached",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MintMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MintPaused",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MintTokensCantBeZero",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NoRedemptionProvider",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotCToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotEnoughForSeize",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotEnoughRedeemAmount",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotEnoughRedeemTokens",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotEnoughUnderlyingAfterRedeem",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotEnoughUnderlyingForMint",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotLiquidatableYet",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotSuToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyAdmin",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyAdminOrPauser",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyCToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyListedCToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyPausedMarketCanBeUnlisted",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyPendingAdmin",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyRedemptionManager",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OverThreshold",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "PriceError",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ProtectedMint_OnlyAllowAssetsInTheSameGroup",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RedeemMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RedeemTransferOutNotPossible",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RedemptionSeizeTooMuch",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RedemptionSignerNotInitialized",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ReduceReservesCashNotAvailable",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ReduceReservesMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "Reentered",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RepayBorrowMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RepayTokenNotListed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SeizePaused",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SeizeTokenNotListed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "Seize_LiquidatorIsBorrower",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SenderMustBeCToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SetInterestRateModelMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SetReservesFactorMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SupplyCapReached",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TokenInOrAmountInMustBeZero",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TokenTransferInFailed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TokenTransferOutFailed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TooMuchRepay",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TotalBorrowsNotZero",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TotalSupplyNotZero",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TransferNotAllowed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TransferPaused",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "UnderlyingBalanceError",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ZeroAddressNotAllowed",
            "type": "error"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "asset",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "_baseRate",
                    "type": "uint256"
                }
            ],
            "name": "BaseRateUpdated",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "uint8",
                    "name": "version",
                    "type": "uint8"
                }
            ],
            "name": "Initialized",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "asset",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "timestamp",
                    "type": "uint256"
                }
            ],
            "name": "LastFeeOpTimeUpdated",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "oldComptroller",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "newComptroller",
                    "type": "address"
                }
            ],
            "name": "NewComptroller",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "oldSigner",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "newSigner",
                    "type": "address"
                }
            ],
            "name": "NewRedemptionSigner",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "indexed": true,
                    "internalType": "bytes32",
                    "name": "previousAdminRole",
                    "type": "bytes32"
                },
                {
                    "indexed": true,
                    "internalType": "bytes32",
                    "name": "newAdminRole",
                    "type": "bytes32"
                }
            ],
            "name": "RoleAdminChanged",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "sender",
                    "type": "address"
                }
            ],
            "name": "RoleGranted",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "sender",
                    "type": "address"
                }
            ],
            "name": "RoleRevoked",
            "type": "event"
        },
        {
            "inputs": [],
            "name": "BETA",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "DECIMAL_PRECISION",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "DEFAULT_ADMIN_ROLE",
            "outputs": [
                {
                    "internalType": "bytes32",
                    "name": "",
                    "type": "bytes32"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "MAX_BORROWING_FEE",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "MINUTE_DECAY_FACTOR",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "REDEMPTION_FEE_FLOOR",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "SECONDS_IN_ONE_MINUTE",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "baseRate",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "baseRateMap",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "redeemAmount",
                    "type": "uint256"
                },
                {
                    "internalType": "address",
                    "name": "provider",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "csuToken",
                    "type": "address"
                }
            ],
            "name": "calcActualRepayAndSeize",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "comptroller",
            "outputs": [
                {
                    "internalType": "contract IComptroller",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "asset",
                    "type": "address"
                }
            ],
            "name": "decayBaseRateFromBorrowing",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "asset",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "redeemAmount",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "_totalSupply",
                    "type": "uint256"
                }
            ],
            "name": "getCurrentRedemptionRate",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "asset",
                    "type": "address"
                }
            ],
            "name": "getRedemptionRate",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                }
            ],
            "name": "getRoleAdmin",
            "outputs": [
                {
                    "internalType": "bytes32",
                    "name": "",
                    "type": "bytes32"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "internalType": "uint256",
                    "name": "index",
                    "type": "uint256"
                }
            ],
            "name": "getRoleMember",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                }
            ],
            "name": "getRoleMemberCount",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "grantRole",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "hasRole",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_admin",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "_redemptionSigner",
                    "type": "address"
                }
            ],
            "name": "initialize",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "lastFeeOperationTime",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "lastFeeOperationTimeMap",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "csuToken",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                },
                {
                    "internalType": "address[]",
                    "name": "providers",
                    "type": "address[]"
                },
                {
                    "internalType": "uint256",
                    "name": "deadline",
                    "type": "uint256"
                },
                {
                    "internalType": "bytes",
                    "name": "signature",
                    "type": "bytes"
                }
            ],
            "name": "redeemFaceValue",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "csuToken",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                },
                {
                    "internalType": "address[]",
                    "name": "providers",
                    "type": "address[]"
                },
                {
                    "internalType": "uint256",
                    "name": "providersDeadline",
                    "type": "uint256"
                },
                {
                    "internalType": "bytes",
                    "name": "providersSignature",
                    "type": "bytes"
                },
                {
                    "internalType": "uint256",
                    "name": "permitDeadline",
                    "type": "uint256"
                },
                {
                    "internalType": "bytes",
                    "name": "permitSignature",
                    "type": "bytes"
                }
            ],
            "name": "redeemFaceValueWithPermit",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "redeemer",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "provider",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "csuToken",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "redeemAmount",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "redemptionRateMantissa",
                    "type": "uint256"
                }
            ],
            "name": "redeemFaceValueWithProviderPreview",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "redemptionSigner",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "renounceRole",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "revokeRole",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "contract IComptroller",
                    "name": "_comptroller",
                    "type": "address"
                }
            ],
            "name": "setComptroller",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "signer",
                    "type": "address"
                }
            ],
            "name": "setRedemptionSigner",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes4",
                    "name": "interfaceId",
                    "type": "bytes4"
                }
            ],
            "name": "supportsInterface",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        }
    ],
    "SortedBorrows": [
        {
            "inputs": [],
            "stateMutability": "nonpayable",
            "type": "constructor"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "uint8",
                    "name": "version",
                    "type": "uint8"
                }
            ],
            "name": "Initialized",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "_asset",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "_id",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "_NICR",
                    "type": "uint256"
                }
            ],
            "name": "NodeAdded",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "_asset",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "_id",
                    "type": "address"
                }
            ],
            "name": "NodeRemoved",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "indexed": true,
                    "internalType": "bytes32",
                    "name": "previousAdminRole",
                    "type": "bytes32"
                },
                {
                    "indexed": true,
                    "internalType": "bytes32",
                    "name": "newAdminRole",
                    "type": "bytes32"
                }
            ],
            "name": "RoleAdminChanged",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "sender",
                    "type": "address"
                }
            ],
            "name": "RoleGranted",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "sender",
                    "type": "address"
                }
            ],
            "name": "RoleRevoked",
            "type": "event"
        },
        {
            "inputs": [],
            "name": "DEFAULT_ADMIN_ROLE",
            "outputs": [
                {
                    "internalType": "bytes32",
                    "name": "",
                    "type": "bytes32"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "NAME",
            "outputs": [
                {
                    "internalType": "string",
                    "name": "",
                    "type": "string"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_asset",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "_id",
                    "type": "address"
                }
            ],
            "name": "contains",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "data",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "head",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "tail",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "size",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_asset",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "_NBB",
                    "type": "uint256"
                },
                {
                    "internalType": "address",
                    "name": "_prevId",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "_nextId",
                    "type": "address"
                }
            ],
            "name": "findInsertPosition",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_asset",
                    "type": "address"
                }
            ],
            "name": "getFirst",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_asset",
                    "type": "address"
                }
            ],
            "name": "getLast",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_asset",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "_id",
                    "type": "address"
                }
            ],
            "name": "getNext",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_asset",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "_id",
                    "type": "address"
                }
            ],
            "name": "getPrev",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                }
            ],
            "name": "getRoleAdmin",
            "outputs": [
                {
                    "internalType": "bytes32",
                    "name": "",
                    "type": "bytes32"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "internalType": "uint256",
                    "name": "index",
                    "type": "uint256"
                }
            ],
            "name": "getRoleMember",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                }
            ],
            "name": "getRoleMemberCount",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_asset",
                    "type": "address"
                }
            ],
            "name": "getSize",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "grantRole",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "hasRole",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_admin",
                    "type": "address"
                }
            ],
            "name": "initialize",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_asset",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "_id",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "_NBB",
                    "type": "uint256"
                },
                {
                    "internalType": "address",
                    "name": "_prevId",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "_nextId",
                    "type": "address"
                }
            ],
            "name": "insert",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_asset",
                    "type": "address"
                }
            ],
            "name": "isEmpty",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "isSortedBorrows",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "pure",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_asset",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "_id",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "_newNBB",
                    "type": "uint256"
                },
                {
                    "internalType": "address",
                    "name": "_prevId",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "_nextId",
                    "type": "address"
                }
            ],
            "name": "reInsert",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "redemptionManager",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_asset",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "_id",
                    "type": "address"
                }
            ],
            "name": "remove",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "renounceRole",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "revokeRole",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_redemptionManager",
                    "type": "address"
                }
            ],
            "name": "setRedemptionManager",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes4",
                    "name": "interfaceId",
                    "type": "bytes4"
                }
            ],
            "name": "supportsInterface",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_asset",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "_NBB",
                    "type": "uint256"
                },
                {
                    "internalType": "address",
                    "name": "_prevId",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "_nextId",
                    "type": "address"
                }
            ],
            "name": "validInsertPosition",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        }
    ],
    "ERC20MinterBurnerPauser": [
        {
            "inputs": [
                {
                    "internalType": "string",
                    "name": "_name",
                    "type": "string"
                },
                {
                    "internalType": "string",
                    "name": "_symbol",
                    "type": "string"
                },
                {
                    "internalType": "uint256",
                    "name": "initialSupply",
                    "type": "uint256"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "constructor"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "owner",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "spender",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "value",
                    "type": "uint256"
                }
            ],
            "name": "Approval",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "Paused",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "indexed": true,
                    "internalType": "bytes32",
                    "name": "previousAdminRole",
                    "type": "bytes32"
                },
                {
                    "indexed": true,
                    "internalType": "bytes32",
                    "name": "newAdminRole",
                    "type": "bytes32"
                }
            ],
            "name": "RoleAdminChanged",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "sender",
                    "type": "address"
                }
            ],
            "name": "RoleGranted",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "sender",
                    "type": "address"
                }
            ],
            "name": "RoleRevoked",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "from",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "to",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "value",
                    "type": "uint256"
                }
            ],
            "name": "Transfer",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "Unpaused",
            "type": "event"
        },
        {
            "inputs": [],
            "name": "DEFAULT_ADMIN_ROLE",
            "outputs": [
                {
                    "internalType": "bytes32",
                    "name": "",
                    "type": "bytes32"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "MINTER_ROLE",
            "outputs": [
                {
                    "internalType": "bytes32",
                    "name": "",
                    "type": "bytes32"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "PAUSER_ROLE",
            "outputs": [
                {
                    "internalType": "bytes32",
                    "name": "",
                    "type": "bytes32"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "owner",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "spender",
                    "type": "address"
                }
            ],
            "name": "allowance",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "spender",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                }
            ],
            "name": "approve",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "balanceOf",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                }
            ],
            "name": "burn",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                }
            ],
            "name": "burnFrom",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "decimals",
            "outputs": [
                {
                    "internalType": "uint8",
                    "name": "",
                    "type": "uint8"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "spender",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "subtractedValue",
                    "type": "uint256"
                }
            ],
            "name": "decreaseAllowance",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                }
            ],
            "name": "getRoleAdmin",
            "outputs": [
                {
                    "internalType": "bytes32",
                    "name": "",
                    "type": "bytes32"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "internalType": "uint256",
                    "name": "index",
                    "type": "uint256"
                }
            ],
            "name": "getRoleMember",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                }
            ],
            "name": "getRoleMemberCount",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "grantRole",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "hasRole",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "spender",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "addedValue",
                    "type": "uint256"
                }
            ],
            "name": "increaseAllowance",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "to",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                }
            ],
            "name": "mint",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "name",
            "outputs": [
                {
                    "internalType": "string",
                    "name": "",
                    "type": "string"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "pause",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "paused",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "renounceRole",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "revokeRole",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes4",
                    "name": "interfaceId",
                    "type": "bytes4"
                }
            ],
            "name": "supportsInterface",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "symbol",
            "outputs": [
                {
                    "internalType": "string",
                    "name": "",
                    "type": "string"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "totalSupply",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "to",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                }
            ],
            "name": "transfer",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "from",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "to",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                }
            ],
            "name": "transferFrom",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "unpause",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        }
    ],
    "ERC20MinterBurnerPauserPermit": [
        {
            "inputs": [
                {
                    "internalType": "string",
                    "name": "_name",
                    "type": "string"
                },
                {
                    "internalType": "string",
                    "name": "_symbol",
                    "type": "string"
                },
                {
                    "internalType": "uint8",
                    "name": "decimals_",
                    "type": "uint8"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "constructor"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "owner",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "spender",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "value",
                    "type": "uint256"
                }
            ],
            "name": "Approval",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "Paused",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "indexed": true,
                    "internalType": "bytes32",
                    "name": "previousAdminRole",
                    "type": "bytes32"
                },
                {
                    "indexed": true,
                    "internalType": "bytes32",
                    "name": "newAdminRole",
                    "type": "bytes32"
                }
            ],
            "name": "RoleAdminChanged",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "sender",
                    "type": "address"
                }
            ],
            "name": "RoleGranted",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "sender",
                    "type": "address"
                }
            ],
            "name": "RoleRevoked",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "from",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "to",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "value",
                    "type": "uint256"
                }
            ],
            "name": "Transfer",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "Unpaused",
            "type": "event"
        },
        {
            "inputs": [],
            "name": "DEFAULT_ADMIN_ROLE",
            "outputs": [
                {
                    "internalType": "bytes32",
                    "name": "",
                    "type": "bytes32"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "DOMAIN_SEPARATOR",
            "outputs": [
                {
                    "internalType": "bytes32",
                    "name": "",
                    "type": "bytes32"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "MINTER_ROLE",
            "outputs": [
                {
                    "internalType": "bytes32",
                    "name": "",
                    "type": "bytes32"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "PAUSER_ROLE",
            "outputs": [
                {
                    "internalType": "bytes32",
                    "name": "",
                    "type": "bytes32"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "owner",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "spender",
                    "type": "address"
                }
            ],
            "name": "allowance",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "spender",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                }
            ],
            "name": "approve",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "balanceOf",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                }
            ],
            "name": "burn",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                }
            ],
            "name": "burnFrom",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "decimals",
            "outputs": [
                {
                    "internalType": "uint8",
                    "name": "",
                    "type": "uint8"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "spender",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "subtractedValue",
                    "type": "uint256"
                }
            ],
            "name": "decreaseAllowance",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                }
            ],
            "name": "getRoleAdmin",
            "outputs": [
                {
                    "internalType": "bytes32",
                    "name": "",
                    "type": "bytes32"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "internalType": "uint256",
                    "name": "index",
                    "type": "uint256"
                }
            ],
            "name": "getRoleMember",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                }
            ],
            "name": "getRoleMemberCount",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "grantRole",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "hasRole",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "spender",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "addedValue",
                    "type": "uint256"
                }
            ],
            "name": "increaseAllowance",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "to",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                }
            ],
            "name": "mint",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "name",
            "outputs": [
                {
                    "internalType": "string",
                    "name": "",
                    "type": "string"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "owner",
                    "type": "address"
                }
            ],
            "name": "nonces",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "pause",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "paused",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "owner",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "spender",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "value",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "deadline",
                    "type": "uint256"
                },
                {
                    "internalType": "bytes",
                    "name": "signature",
                    "type": "bytes"
                }
            ],
            "name": "permit",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "owner",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "spender",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "value",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "deadline",
                    "type": "uint256"
                },
                {
                    "internalType": "uint8",
                    "name": "v",
                    "type": "uint8"
                },
                {
                    "internalType": "bytes32",
                    "name": "r",
                    "type": "bytes32"
                },
                {
                    "internalType": "bytes32",
                    "name": "s",
                    "type": "bytes32"
                }
            ],
            "name": "permit",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "renounceRole",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "revokeRole",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes4",
                    "name": "interfaceId",
                    "type": "bytes4"
                }
            ],
            "name": "supportsInterface",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "symbol",
            "outputs": [
                {
                    "internalType": "string",
                    "name": "",
                    "type": "string"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "totalSupply",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "to",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                }
            ],
            "name": "transfer",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "from",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "to",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                }
            ],
            "name": "transferFrom",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "unpause",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        }
    ],
    "ExponentialNoErrorNew": [],
    "CInfraredVault": [
        {
            "inputs": [],
            "name": "AddReservesMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "AddReservesOverflow",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "BorrowAndDepositBackFailed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "BorrowCapReached",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "BorrowCashNotAvailable",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "BorrowMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "BorrowPaused",
            "type": "error"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "usdThreshold",
                    "type": "uint256"
                }
            ],
            "name": "BorrowValueMustBeLargerThanThreshold",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "CantEnterPausedMarket",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "CantExitMarketWithNonZeroBorrowBalance",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "CantSweepRewardToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "CantSweepUnderlying",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ComptrollerMismatch",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "EitherAssetOrDebtMustBeZero",
            "type": "error"
        },
        {
            "inputs": [
                {
                    "internalType": "uint8",
                    "name": "groupId",
                    "type": "uint8"
                },
                {
                    "internalType": "uint256",
                    "name": "cDepositVal",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "suDepositVal",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "cBorrowVal",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "suBorrowVal",
                    "type": "uint256"
                }
            ],
            "name": "EitherAssetOrDebtMustBeZeroInGroup",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ExpiredSignature",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InsufficientCollateral",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InsufficientShortfall",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InterMintNotAllowed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidAddress",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidAmount",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidBlockNumber",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidCToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidCloseFactor",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidComptroller",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidDiscountRate",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidExchangeRate",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidGroupId",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidInput",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidInterestRateModel",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidMinSuBorrowValue",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidRedeem",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidReduceAmount",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidReserveFactor",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidSignatureForRedeemFaceValue",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidSignatureLength",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidSuToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidTimestamp",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateBorrow_LiquidatorIsBorrower",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateBorrow_RepayAmountIsMax",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateBorrow_RepayAmountIsZero",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateBorrow_SeizeTooMuch",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateCollateralMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketAlreadyListed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketAlreadyUnlisted",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketCanOnlyInitializeOnce",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketNotEmpty",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketNotListed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketPaused",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MinDelayNotReached",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MintMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MintPaused",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MintTokensCantBeZero",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NoRedemptionProvider",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotCToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotEnoughForSeize",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotEnoughRedeemAmount",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotEnoughRedeemTokens",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotEnoughUnderlyingAfterRedeem",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotEnoughUnderlyingForMint",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotLiquidatableYet",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotSuToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyAdmin",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyAdminOrPauser",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyCToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyListedCToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyPausedMarketCanBeUnlisted",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyPendingAdmin",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyRedemptionManager",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OverThreshold",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "PriceError",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ProtectedMint_OnlyAllowAssetsInTheSameGroup",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RedeemMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RedeemTransferOutNotPossible",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RedemptionSeizeTooMuch",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RedemptionSignerNotInitialized",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ReduceReservesCashNotAvailable",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ReduceReservesMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "Reentered",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RepayBorrowMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RepayTokenNotListed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SeizePaused",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SeizeTokenNotListed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "Seize_LiquidatorIsBorrower",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SenderMustBeCToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SetInterestRateModelMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SetReservesFactorMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SupplyCapReached",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TokenInOrAmountInMustBeZero",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TokenTransferInFailed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TokenTransferOutFailed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TooMuchRepay",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TotalBorrowsNotZero",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TotalSupplyNotZero",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TransferNotAllowed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TransferPaused",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "UnderlyingBalanceError",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "UnderlyingMismatch",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ZeroAddressNotAllowed",
            "type": "error"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "cashPrior",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "interestAccumulated",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "borrowIndex",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "totalBorrows",
                    "type": "uint256"
                }
            ],
            "name": "AccrueInterest",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "owner",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "spender",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                }
            ],
            "name": "Approval",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "borrower",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "borrowAmount",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "accountBorrows",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "totalBorrows",
                    "type": "uint256"
                }
            ],
            "name": "Borrow",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "uint8",
                    "name": "version",
                    "type": "uint8"
                }
            ],
            "name": "Initialized",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "liquidator",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "borrower",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "repayAmount",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "cTokenCollateral",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "seizeTokens",
                    "type": "uint256"
                }
            ],
            "name": "LiquidateBorrow",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "minter",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "mintAmount",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "mintTokens",
                    "type": "uint256"
                }
            ],
            "name": "Mint",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "oldAdmin",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "newAdmin",
                    "type": "address"
                }
            ],
            "name": "NewAdmin",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "oldComptroller",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "newComptroller",
                    "type": "address"
                }
            ],
            "name": "NewComptroller",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "oldDiscountRateMantissa",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "newDiscountRateMantissa",
                    "type": "uint256"
                }
            ],
            "name": "NewDiscountRate",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "oldInterestRateModel",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "newInterestRateModel",
                    "type": "address"
                }
            ],
            "name": "NewMarketInterestRateModel",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "oldPendingAdmin",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "newPendingAdmin",
                    "type": "address"
                }
            ],
            "name": "NewPendingAdmin",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "oldReserveFactorMantissa",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "newReserveFactorMantissa",
                    "type": "uint256"
                }
            ],
            "name": "NewReserveFactor",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "redeemer",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "redeemAmount",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "redeemTokens",
                    "type": "uint256"
                }
            ],
            "name": "Redeem",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "redeemer",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "provider",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "repayAmount",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "seizeToken",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "seizeAmount",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "redemptionRateMantissa",
                    "type": "uint256"
                }
            ],
            "name": "RedeemFaceValue",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "payer",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "borrower",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "repayAmount",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "accountBorrows",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "totalBorrows",
                    "type": "uint256"
                }
            ],
            "name": "RepayBorrow",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "benefactor",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "addAmount",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "newTotalReserves",
                    "type": "uint256"
                }
            ],
            "name": "ReservesAdded",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "admin",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "reduceAmount",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "newTotalReserves",
                    "type": "uint256"
                }
            ],
            "name": "ReservesReduced",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "from",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "to",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                }
            ],
            "name": "Transfer",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "timestamp",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "totalPoints",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "_userPoints",
                    "type": "uint256"
                }
            ],
            "name": "UpdatePoints",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "user",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "rewardsToken",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "reward",
                    "type": "uint256"
                }
            ],
            "name": "UserRewardPaid",
            "type": "event"
        },
        {
            "inputs": [],
            "name": "_acceptAdmin",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "addAmount",
                    "type": "uint256"
                }
            ],
            "name": "_addReserves",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "reduceAmount",
                    "type": "uint256"
                }
            ],
            "name": "_reduceReserves",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "newComptroller",
                    "type": "address"
                }
            ],
            "name": "_setComptroller",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "discountRateMantissa_",
                    "type": "uint256"
                }
            ],
            "name": "_setDiscountRate",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "newInterestRateModel",
                    "type": "address"
                }
            ],
            "name": "_setInterestRateModel",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address payable",
                    "name": "newPendingAdmin",
                    "type": "address"
                }
            ],
            "name": "_setPendingAdmin",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "newReserveFactorMantissa",
                    "type": "uint256"
                }
            ],
            "name": "_setReserveFactor",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "_syncUnderlyingBalance",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "accrualBlockTimestamp",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "accrueInterest",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "admin",
            "outputs": [
                {
                    "internalType": "address payable",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "owner",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "spender",
                    "type": "address"
                }
            ],
            "name": "allowance",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "spender",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                }
            ],
            "name": "approve",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "owner",
                    "type": "address"
                }
            ],
            "name": "balanceOf",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "owner",
                    "type": "address"
                }
            ],
            "name": "balanceOfUnderlying",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "borrowAmount",
                    "type": "uint256"
                }
            ],
            "name": "borrow",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "borrower",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "borrowAmount",
                    "type": "uint256"
                }
            ],
            "name": "borrowAndDepositBack",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "borrowBalanceCurrent",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "borrowBalanceStored",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "borrowIndex",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "borrowRatePerBlock",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "claimAll",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_to",
                    "type": "address"
                }
            ],
            "name": "claimProtocolRewards",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "comptroller",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "decimals",
            "outputs": [
                {
                    "internalType": "uint8",
                    "name": "",
                    "type": "uint8"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "discountRateMantissa",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "earned",
            "outputs": [
                {
                    "components": [
                        {
                            "internalType": "address",
                            "name": "token",
                            "type": "address"
                        },
                        {
                            "internalType": "uint256",
                            "name": "amount",
                            "type": "uint256"
                        }
                    ],
                    "internalType": "struct IInfraredVault.UserReward[]",
                    "name": "",
                    "type": "tuple[]"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "exchangeRateCurrent",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "exchangeRateStored",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "getAccountSnapshot",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "getCash",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "underlying_",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "comptroller_",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "interestRateModel_",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "initialExchangeRateMantissa_",
                    "type": "uint256"
                },
                {
                    "internalType": "string",
                    "name": "name_",
                    "type": "string"
                },
                {
                    "internalType": "string",
                    "name": "symbol_",
                    "type": "string"
                },
                {
                    "internalType": "uint8",
                    "name": "decimals_",
                    "type": "uint8"
                },
                {
                    "internalType": "address payable",
                    "name": "admin_",
                    "type": "address"
                }
            ],
            "name": "initialize",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "underlying_",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "comptroller_",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "interestRateModel_",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "initialExchangeRateMantissa_",
                    "type": "uint256"
                },
                {
                    "internalType": "string",
                    "name": "name_",
                    "type": "string"
                },
                {
                    "internalType": "string",
                    "name": "symbol_",
                    "type": "string"
                },
                {
                    "internalType": "uint8",
                    "name": "decimals_",
                    "type": "uint8"
                },
                {
                    "internalType": "address payable",
                    "name": "admin_",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "infraredVault_",
                    "type": "address"
                }
            ],
            "name": "initialize",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "interestRateModel",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "isCEther",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "pure",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "isCEtherDeprecated",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "isCToken",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "pure",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "isCTokenDeprecated",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "borrower",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "repayAmount",
                    "type": "uint256"
                },
                {
                    "internalType": "address",
                    "name": "cTokenCollateral",
                    "type": "address"
                }
            ],
            "name": "liquidateBorrow",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cTokenCollateral",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "actualRepayAmount",
                    "type": "uint256"
                }
            ],
            "name": "liquidateCalculateSeizeTokens",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "mintAmount",
                    "type": "uint256"
                }
            ],
            "name": "mint",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "mintAmount",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "deadline",
                    "type": "uint256"
                },
                {
                    "internalType": "bytes",
                    "name": "signature",
                    "type": "bytes"
                }
            ],
            "name": "mintWithPermit",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "name",
            "outputs": [
                {
                    "internalType": "string",
                    "name": "",
                    "type": "string"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "pendingAdmin",
            "outputs": [
                {
                    "internalType": "address payable",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "percentScale",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "points",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "protocolRewards",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "protocolSeizeShareMantissa",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "redeemTokens",
                    "type": "uint256"
                }
            ],
            "name": "redeem",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "redeemAmount",
                    "type": "uint256"
                }
            ],
            "name": "redeemUnderlying",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "repayAmount",
                    "type": "uint256"
                }
            ],
            "name": "repayBorrow",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "borrower",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "repayAmount",
                    "type": "uint256"
                }
            ],
            "name": "repayBorrowBehalf",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "repayAmount",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "deadline",
                    "type": "uint256"
                },
                {
                    "internalType": "bytes",
                    "name": "signature",
                    "type": "bytes"
                }
            ],
            "name": "repayBorrowWithPermit",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "reserveFactorMantissa",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "liquidator",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "borrower",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "seizeTokens",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "seizeProfitTokens",
                    "type": "uint256"
                },
                {
                    "internalType": "bool",
                    "name": "isRedemption",
                    "type": "bool"
                },
                {
                    "internalType": "uint256",
                    "name": "redemptionRateMantissa",
                    "type": "uint256"
                }
            ],
            "name": "seize",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "shareOf",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "_share",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "supplyRatePerBlock",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "contract ERC20",
                    "name": "token",
                    "type": "address"
                }
            ],
            "name": "sweepToken",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "symbol",
            "outputs": [
                {
                    "internalType": "string",
                    "name": "",
                    "type": "string"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "tokenType",
            "outputs": [
                {
                    "internalType": "enum CToken.CTokenType",
                    "name": "",
                    "type": "uint8"
                }
            ],
            "stateMutability": "pure",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "totalBorrows",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "totalBorrowsCurrent",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "totalReserves",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "totalSupply",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "dst",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                }
            ],
            "name": "transfer",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "src",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "dst",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                }
            ],
            "name": "transferFrom",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "underlying",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "underlyingBalance",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        }
    ],
    "IPool": [
        {
            "inputs": [],
            "name": "decimals",
            "outputs": [
                {
                    "internalType": "uint8",
                    "name": "",
                    "type": "uint8"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "getActualSupply",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "getPoolId",
            "outputs": [
                {
                    "internalType": "bytes32",
                    "name": "",
                    "type": "bytes32"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "getVault",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "totalSupply",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        }
    ],
    "IInfraredVault": [
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "rewardToken",
                    "type": "address"
                }
            ],
            "name": "earned",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "getAllRewardTokens",
            "outputs": [
                {
                    "internalType": "address[]",
                    "name": "",
                    "type": "address[]"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_user",
                    "type": "address"
                }
            ],
            "name": "getAllRewardsForUser",
            "outputs": [
                {
                    "components": [
                        {
                            "internalType": "address",
                            "name": "token",
                            "type": "address"
                        },
                        {
                            "internalType": "uint256",
                            "name": "amount",
                            "type": "uint256"
                        }
                    ],
                    "internalType": "struct IInfraredVault.UserReward[]",
                    "name": "",
                    "type": "tuple[]"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_user",
                    "type": "address"
                }
            ],
            "name": "getRewardForUser",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                }
            ],
            "name": "stake",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "stakingToken",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                }
            ],
            "name": "withdraw",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        }
    ],
    "IAsset": [],
    "IVault": [
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "poolId",
                    "type": "bytes32"
                }
            ],
            "name": "getPoolTokens",
            "outputs": [
                {
                    "internalType": "address[]",
                    "name": "tokens",
                    "type": "address[]"
                },
                {
                    "internalType": "uint256[]",
                    "name": "balances",
                    "type": "uint256[]"
                },
                {
                    "internalType": "uint256",
                    "name": "lastChangeBlock",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "components": [
                        {
                            "internalType": "enum IVault.UserBalanceOpKind",
                            "name": "kind",
                            "type": "uint8"
                        },
                        {
                            "internalType": "contract IAsset",
                            "name": "asset",
                            "type": "address"
                        },
                        {
                            "internalType": "uint256",
                            "name": "amount",
                            "type": "uint256"
                        },
                        {
                            "internalType": "address",
                            "name": "sender",
                            "type": "address"
                        },
                        {
                            "internalType": "address payable",
                            "name": "recipient",
                            "type": "address"
                        }
                    ],
                    "internalType": "struct IVault.UserBalanceOp[]",
                    "name": "ops",
                    "type": "tuple[]"
                }
            ],
            "name": "manageUserBalance",
            "outputs": [],
            "stateMutability": "payable",
            "type": "function"
        }
    ],
    "VaultReentrancyLib": [],
    "FixedInterestRateModel": [
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "initBorrowRate",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "initSupplyRate",
                    "type": "uint256"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "constructor"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "previousOwner",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "newOwner",
                    "type": "address"
                }
            ],
            "name": "OwnershipTransferStarted",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "previousOwner",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "newOwner",
                    "type": "address"
                }
            ],
            "name": "OwnershipTransferred",
            "type": "event"
        },
        {
            "inputs": [],
            "name": "acceptOwnership",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "borrowRate",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "cash",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "borrows",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "reserves",
                    "type": "uint256"
                }
            ],
            "name": "getBorrowRate",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "cash",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "borrows",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "reserves",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "reserveFactorMantissa",
                    "type": "uint256"
                }
            ],
            "name": "getSupplyRate",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "isInterestRateModel",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "owner",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "pendingOwner",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "renounceOwnership",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "secondsPerYear",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "rate",
                    "type": "uint256"
                }
            ],
            "name": "setBorrowRate",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "rate",
                    "type": "uint256"
                }
            ],
            "name": "setSupplyRate",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "supplyRate",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "newOwner",
                    "type": "address"
                }
            ],
            "name": "transferOwnership",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        }
    ],
    "InterestRateModel": [
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "previousOwner",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "newOwner",
                    "type": "address"
                }
            ],
            "name": "OwnershipTransferStarted",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "previousOwner",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "newOwner",
                    "type": "address"
                }
            ],
            "name": "OwnershipTransferred",
            "type": "event"
        },
        {
            "inputs": [],
            "name": "acceptOwnership",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "cash",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "borrows",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "reserves",
                    "type": "uint256"
                }
            ],
            "name": "getBorrowRate",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "cash",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "borrows",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "reserves",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "reserveFactorMantissa",
                    "type": "uint256"
                }
            ],
            "name": "getSupplyRate",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "isInterestRateModel",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "owner",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "pendingOwner",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "renounceOwnership",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "secondsPerYear",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "newOwner",
                    "type": "address"
                }
            ],
            "name": "transferOwnership",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        }
    ],
    "JumpRateModelV2": [
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "baseRatePerYear",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "multiplierPerYear",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "jumpMultiplierPerYear",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "kink_",
                    "type": "uint256"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "constructor"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "baseRatePerSecond",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "multiplierPerSecond",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "jumpMultiplierPerSecond",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "kink",
                    "type": "uint256"
                }
            ],
            "name": "NewInterestParams",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "previousOwner",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "newOwner",
                    "type": "address"
                }
            ],
            "name": "OwnershipTransferStarted",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "previousOwner",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "newOwner",
                    "type": "address"
                }
            ],
            "name": "OwnershipTransferred",
            "type": "event"
        },
        {
            "inputs": [],
            "name": "acceptOwnership",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "baseRatePerSecond",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "cash",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "borrows",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "reserves",
                    "type": "uint256"
                }
            ],
            "name": "getBorrowRate",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "cash",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "borrows",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "reserves",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "reserveFactorMantissa",
                    "type": "uint256"
                }
            ],
            "name": "getSupplyRate",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "isInterestRateModel",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "jumpMultiplierPerSecond",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "kink",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "multiplierPerSecond",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "owner",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "pendingOwner",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "renounceOwnership",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "secondsPerYear",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "newOwner",
                    "type": "address"
                }
            ],
            "name": "transferOwnership",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "baseRatePerYear",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "multiplierPerYear",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "jumpMultiplierPerYear",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "kink_",
                    "type": "uint256"
                }
            ],
            "name": "updateJumpRateModel",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "cash",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "borrows",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "reserves",
                    "type": "uint256"
                }
            ],
            "name": "utilizationRate",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "pure",
            "type": "function"
        }
    ],
    "WhitePaperInterestRateModel": [
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "baseRatePerYear",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "multiplierPerYear",
                    "type": "uint256"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "constructor"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "baseRatePerSecond",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "multiplierPerSecond",
                    "type": "uint256"
                }
            ],
            "name": "NewInterestParams",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "previousOwner",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "newOwner",
                    "type": "address"
                }
            ],
            "name": "OwnershipTransferStarted",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "previousOwner",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "newOwner",
                    "type": "address"
                }
            ],
            "name": "OwnershipTransferred",
            "type": "event"
        },
        {
            "inputs": [],
            "name": "acceptOwnership",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "baseRatePerSecond",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "cash",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "borrows",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "reserves",
                    "type": "uint256"
                }
            ],
            "name": "getBorrowRate",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "cash",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "borrows",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "reserves",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "reserveFactorMantissa",
                    "type": "uint256"
                }
            ],
            "name": "getSupplyRate",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "isInterestRateModel",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "multiplierPerSecond",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "owner",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "pendingOwner",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "renounceOwnership",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "secondsPerYear",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "newOwner",
                    "type": "address"
                }
            ],
            "name": "transferOwnership",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "cash",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "borrows",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "reserves",
                    "type": "uint256"
                }
            ],
            "name": "utilizationRate",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "pure",
            "type": "function"
        }
    ],
    "IAccountLiquidity": [
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "cTokenModify",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "redeemTokens",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "borrowAmount",
                    "type": "uint256"
                }
            ],
            "name": "getHypotheticalAccountLiquidity",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "cTokenModify",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "intraSafeLimitMantissa",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "interSafeLimitMantissa",
                    "type": "uint256"
                }
            ],
            "name": "getHypotheticalSafeLimit",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        }
    ],
    "ICErc20": [
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "addAmount",
                    "type": "uint256"
                }
            ],
            "name": "_addReserves",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "borrowAmount",
                    "type": "uint256"
                }
            ],
            "name": "borrow",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "borrower",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "repayAmount",
                    "type": "uint256"
                },
                {
                    "internalType": "address",
                    "name": "cTokenCollateral",
                    "type": "address"
                }
            ],
            "name": "liquidateBorrow",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "mintAmount",
                    "type": "uint256"
                }
            ],
            "name": "mint",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "redeemTokens",
                    "type": "uint256"
                }
            ],
            "name": "redeem",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "redeemAmount",
                    "type": "uint256"
                }
            ],
            "name": "redeemUnderlying",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "repayAmount",
                    "type": "uint256"
                }
            ],
            "name": "repayBorrow",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "borrower",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "repayAmount",
                    "type": "uint256"
                }
            ],
            "name": "repayBorrowBehalf",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "contract ERC20",
                    "name": "token",
                    "type": "address"
                }
            ],
            "name": "sweepToken",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        }
    ],
    "ICToken": [
        {
            "inputs": [],
            "name": "accrueInterest",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "owner",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "spender",
                    "type": "address"
                }
            ],
            "name": "allowance",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "owner",
                    "type": "address"
                }
            ],
            "name": "balanceOf",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "owner",
                    "type": "address"
                }
            ],
            "name": "balanceOfUnderlying",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "borrowBalanceCurrent",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "borrowBalanceStored",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "borrowIndex",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "borrowRatePerBlock",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "comptroller",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "decimals",
            "outputs": [
                {
                    "internalType": "uint8",
                    "name": "",
                    "type": "uint8"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "delegates",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "discountRateMantissa",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "exchangeRateCurrent",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "exchangeRateStored",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "redeemer",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "provider",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "repayAmount",
                    "type": "uint256"
                },
                {
                    "internalType": "address",
                    "name": "cTokenCollateral",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "seizeAmount",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "redemptionRateMantissa",
                    "type": "uint256"
                }
            ],
            "name": "executeRedemption",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "getAccountSnapshot",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "getCash",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "getCurrentVotes",
            "outputs": [
                {
                    "internalType": "uint96",
                    "name": "",
                    "type": "uint96"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "blockNumber",
                    "type": "uint256"
                }
            ],
            "name": "getPriorVotes",
            "outputs": [
                {
                    "internalType": "uint96",
                    "name": "",
                    "type": "uint96"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "isCEther",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "isCToken",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "isDeprecated",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cTokenCollateral",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "actualRepayAmount",
                    "type": "uint256"
                }
            ],
            "name": "liquidateCalculateSeizeTokens",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "reserveFactorMantissa",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "supplyRatePerBlock",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "totalBorrows",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "totalReserves",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "totalSupply",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "underlying",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        }
    ],
    "ICompLogic": [
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "borrower",
                    "type": "address"
                },
                {
                    "components": [
                        {
                            "internalType": "uint256",
                            "name": "mantissa",
                            "type": "uint256"
                        }
                    ],
                    "internalType": "struct ICompLogic.Exp",
                    "name": "marketBorrowIndex",
                    "type": "tuple"
                }
            ],
            "name": "distributeBorrowerComp",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "supplier",
                    "type": "address"
                }
            ],
            "name": "distributeSupplierComp",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "cTokenModify",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "intraSafeLimitMantissa",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "interSafeLimitMantissa",
                    "type": "uint256"
                }
            ],
            "name": "getHypotheticalSafeLimit",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                },
                {
                    "internalType": "uint32",
                    "name": "blockNumber",
                    "type": "uint32"
                }
            ],
            "name": "initializeMarket",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "supplySpeed",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "borrowSpeed",
                    "type": "uint256"
                }
            ],
            "name": "setCompSpeed",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                }
            ],
            "name": "uninitializeMarket",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                },
                {
                    "components": [
                        {
                            "internalType": "uint256",
                            "name": "mantissa",
                            "type": "uint256"
                        }
                    ],
                    "internalType": "struct ICompLogic.Exp",
                    "name": "marketBorrowIndex",
                    "type": "tuple"
                }
            ],
            "name": "updateCompBorrowIndex",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                }
            ],
            "name": "updateCompSupplyIndex",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        }
    ],
    "IComptroller": [
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "string",
                    "name": "action",
                    "type": "string"
                },
                {
                    "indexed": false,
                    "internalType": "bool",
                    "name": "pauseState",
                    "type": "bool"
                }
            ],
            "name": "ActionPaused",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "newBorrowCap",
                    "type": "uint256"
                }
            ],
            "name": "NewBorrowCap",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "oldBorrowCapGuardian",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "newBorrowCapGuardian",
                    "type": "address"
                }
            ],
            "name": "NewBorrowCapGuardian",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "oldPauseGuardian",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "newPauseGuardian",
                    "type": "address"
                }
            ],
            "name": "NewPauseGuardian",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "uint8",
                    "name": "groupId",
                    "type": "uint8"
                },
                {
                    "indexed": false,
                    "internalType": "uint8",
                    "name": "equalAssetsGroupNum",
                    "type": "uint8"
                }
            ],
            "name": "RemoveAssetGroup",
            "type": "event"
        },
        {
            "inputs": [
                {
                    "internalType": "uint8",
                    "name": "groupId",
                    "type": "uint8"
                }
            ],
            "name": "assetGroup",
            "outputs": [
                {
                    "components": [
                        {
                            "internalType": "uint8",
                            "name": "groupId",
                            "type": "uint8"
                        },
                        {
                            "internalType": "uint16",
                            "name": "intraCRatePercent",
                            "type": "uint16"
                        },
                        {
                            "internalType": "uint16",
                            "name": "intraMintRatePercent",
                            "type": "uint16"
                        },
                        {
                            "internalType": "uint16",
                            "name": "intraSuRatePercent",
                            "type": "uint16"
                        },
                        {
                            "internalType": "uint16",
                            "name": "interCRatePercent",
                            "type": "uint16"
                        },
                        {
                            "internalType": "uint16",
                            "name": "interSuRatePercent",
                            "type": "uint16"
                        }
                    ],
                    "internalType": "struct CompactAssetGroup",
                    "name": "",
                    "type": "tuple"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "borrower",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "borrowAmount",
                    "type": "uint256"
                }
            ],
            "name": "borrowAllowed",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "borrower",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "borrowAmount",
                    "type": "uint256"
                }
            ],
            "name": "borrowVerify",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "claimSumer",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "compAccrued",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address[]",
                    "name": "cTokens",
                    "type": "address[]"
                }
            ],
            "name": "enterMarkets",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                }
            ],
            "name": "exitMarket",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "getAllMarkets",
            "outputs": [
                {
                    "internalType": "address[]",
                    "name": "",
                    "type": "address[]"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "getAssetsIn",
            "outputs": [
                {
                    "internalType": "address[]",
                    "name": "",
                    "type": "address[]"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "cTokenModify",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "redeemTokens",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "borrowAmount",
                    "type": "uint256"
                }
            ],
            "name": "getHypotheticalAccountLiquidity",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                }
            ],
            "name": "getUnderlyingPriceNormalized",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "globalConfig",
            "outputs": [
                {
                    "components": [
                        {
                            "internalType": "uint16",
                            "name": "closeFactorPercent",
                            "type": "uint16"
                        },
                        {
                            "internalType": "uint32",
                            "name": "minCloseValue",
                            "type": "uint32"
                        },
                        {
                            "internalType": "uint32",
                            "name": "minSuBorrowValue",
                            "type": "uint32"
                        },
                        {
                            "internalType": "uint32",
                            "name": "minWaitBeforeLiquidatable",
                            "type": "uint32"
                        },
                        {
                            "internalType": "uint8",
                            "name": "largestGroupId",
                            "type": "uint8"
                        }
                    ],
                    "internalType": "struct GlobalConfig",
                    "name": "",
                    "type": "tuple"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "interMintAllowed",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "isComptroller",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "asset",
                    "type": "address"
                }
            ],
            "name": "isListed",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cTokenBorrowed",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "cTokenCollateral",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "liquidator",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "borrower",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "repayAmount",
                    "type": "uint256"
                }
            ],
            "name": "liquidateBorrowAllowed",
            "outputs": [],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cTokenBorrowed",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "cTokenCollateral",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "liquidator",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "borrower",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "repayAmount",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "seizeTokens",
                    "type": "uint256"
                }
            ],
            "name": "liquidateBorrowVerify",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "liquidationIncentive",
            "outputs": [
                {
                    "components": [
                        {
                            "internalType": "uint16",
                            "name": "heteroPercent",
                            "type": "uint16"
                        },
                        {
                            "internalType": "uint16",
                            "name": "homoPercent",
                            "type": "uint16"
                        },
                        {
                            "internalType": "uint16",
                            "name": "sutokenPercent",
                            "type": "uint16"
                        }
                    ],
                    "internalType": "struct LiquidationIncentive",
                    "name": "",
                    "type": "tuple"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                }
            ],
            "name": "marketConfig",
            "outputs": [
                {
                    "components": [
                        {
                            "internalType": "bool",
                            "name": "mintPaused",
                            "type": "bool"
                        },
                        {
                            "internalType": "bool",
                            "name": "borrowPaused",
                            "type": "bool"
                        },
                        {
                            "internalType": "bool",
                            "name": "transferPaused",
                            "type": "bool"
                        },
                        {
                            "internalType": "bool",
                            "name": "seizePaused",
                            "type": "bool"
                        },
                        {
                            "internalType": "uint120",
                            "name": "borrowCap",
                            "type": "uint120"
                        },
                        {
                            "internalType": "uint120",
                            "name": "supplyCap",
                            "type": "uint120"
                        }
                    ],
                    "internalType": "struct MarketConfig",
                    "name": "",
                    "type": "tuple"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "markets",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                },
                {
                    "internalType": "uint8",
                    "name": "",
                    "type": "uint8"
                },
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "minter",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "mintAmount",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "exchangeRate",
                    "type": "uint256"
                }
            ],
            "name": "mintAllowed",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "oracle",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "redeemer",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "redeemTokens",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "exchangeRate",
                    "type": "uint256"
                }
            ],
            "name": "redeemAllowed",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "redeemer",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "redeemAmount",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "redeemTokens",
                    "type": "uint256"
                }
            ],
            "name": "redeemVerify",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "redemptionManager",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "payer",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "borrower",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "repayAmount",
                    "type": "uint256"
                }
            ],
            "name": "repayBorrowAllowed",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "payer",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "borrower",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "actualRepayAmount",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "borrowIndex",
                    "type": "uint256"
                }
            ],
            "name": "repayBorrowVerify",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cTokenCollateral",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "cTokenBorrowed",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "liquidator",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "borrower",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "seizeTokens",
                    "type": "uint256"
                }
            ],
            "name": "seizeAllowed",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cTokenCollateral",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "cTokenBorrowed",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "liquidator",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "borrower",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "seizeTokens",
                    "type": "uint256"
                }
            ],
            "name": "seizeVerify",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "timelock",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "src",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "dst",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "transferTokens",
                    "type": "uint256"
                }
            ],
            "name": "transferAllowed",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        }
    ],
    "IEIP20NonStandard": [
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "owner",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "spender",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                }
            ],
            "name": "Approval",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "from",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "to",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                }
            ],
            "name": "Transfer",
            "type": "event"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "owner",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "spender",
                    "type": "address"
                }
            ],
            "name": "allowance",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "remaining",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "spender",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                }
            ],
            "name": "approve",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "success",
                    "type": "bool"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "owner",
                    "type": "address"
                }
            ],
            "name": "balanceOf",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "balance",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                }
            ],
            "name": "burn",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                }
            ],
            "name": "burnFrom",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "to",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                }
            ],
            "name": "mint",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "totalSupply",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "dst",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                }
            ],
            "name": "transfer",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "src",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "dst",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                }
            ],
            "name": "transferFrom",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        }
    ],
    "IEIP712": [
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "owner",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "spender",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "value",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "deadline",
                    "type": "uint256"
                },
                {
                    "internalType": "bytes",
                    "name": "signature",
                    "type": "bytes"
                }
            ],
            "name": "permit",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        }
    ],
    "IGovernorAlpha": [
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "proposalId",
                    "type": "uint256"
                }
            ],
            "name": "getActions",
            "outputs": [
                {
                    "internalType": "address[]",
                    "name": "targets",
                    "type": "address[]"
                },
                {
                    "internalType": "uint256[]",
                    "name": "values",
                    "type": "uint256[]"
                },
                {
                    "internalType": "string[]",
                    "name": "signatures",
                    "type": "string[]"
                },
                {
                    "internalType": "bytes[]",
                    "name": "calldatas",
                    "type": "bytes[]"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "proposalId",
                    "type": "uint256"
                },
                {
                    "internalType": "address",
                    "name": "voter",
                    "type": "address"
                }
            ],
            "name": "getReceipt",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                },
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                },
                {
                    "internalType": "uint96",
                    "name": "",
                    "type": "uint96"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "name": "proposals",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "id",
                    "type": "uint256"
                },
                {
                    "internalType": "address",
                    "name": "proposer",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "eta",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "startBlock",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "endBlock",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "forVotes",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "againstVotes",
                    "type": "uint256"
                },
                {
                    "internalType": "bool",
                    "name": "canceled",
                    "type": "bool"
                },
                {
                    "internalType": "bool",
                    "name": "executed",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        }
    ],
    "IGovernorBravo": [
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "proposalId",
                    "type": "uint256"
                }
            ],
            "name": "getActions",
            "outputs": [
                {
                    "internalType": "address[]",
                    "name": "targets",
                    "type": "address[]"
                },
                {
                    "internalType": "uint256[]",
                    "name": "values",
                    "type": "uint256[]"
                },
                {
                    "internalType": "string[]",
                    "name": "signatures",
                    "type": "string[]"
                },
                {
                    "internalType": "bytes[]",
                    "name": "calldatas",
                    "type": "bytes[]"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "proposalId",
                    "type": "uint256"
                },
                {
                    "internalType": "address",
                    "name": "voter",
                    "type": "address"
                }
            ],
            "name": "getReceipt",
            "outputs": [
                {
                    "components": [
                        {
                            "internalType": "bool",
                            "name": "hasVoted",
                            "type": "bool"
                        },
                        {
                            "internalType": "uint8",
                            "name": "support",
                            "type": "uint8"
                        },
                        {
                            "internalType": "uint96",
                            "name": "votes",
                            "type": "uint96"
                        }
                    ],
                    "internalType": "struct IGovernorBravo.Receipt",
                    "name": "",
                    "type": "tuple"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "proposalId",
                    "type": "uint256"
                }
            ],
            "name": "proposals",
            "outputs": [
                {
                    "components": [
                        {
                            "internalType": "uint256",
                            "name": "id",
                            "type": "uint256"
                        },
                        {
                            "internalType": "address",
                            "name": "proposer",
                            "type": "address"
                        },
                        {
                            "internalType": "uint256",
                            "name": "eta",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "startBlock",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "endBlock",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "forVotes",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "againstVotes",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "abstainVotes",
                            "type": "uint256"
                        },
                        {
                            "internalType": "bool",
                            "name": "canceled",
                            "type": "bool"
                        },
                        {
                            "internalType": "bool",
                            "name": "executed",
                            "type": "bool"
                        }
                    ],
                    "internalType": "struct IGovernorBravo.Proposal",
                    "name": "",
                    "type": "tuple"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        }
    ],
    "IInterestRateModel": [
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "cash",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "borrows",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "reserves",
                    "type": "uint256"
                }
            ],
            "name": "getBorrowRate",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "cash",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "borrows",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "reserves",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "reserveFactorMantissa",
                    "type": "uint256"
                }
            ],
            "name": "getSupplyRate",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "isInterestRateModel",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "secondsPerYear",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        }
    ],
    "ILayerBank": [
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "token",
                    "type": "address"
                }
            ],
            "name": "priceOf",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        }
    ],
    "IPMarket": [
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "owner",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "spender",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "value",
                    "type": "uint256"
                }
            ],
            "name": "Approval",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "receiverSy",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "receiverPt",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "netLpBurned",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "netSyOut",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "netPtOut",
                    "type": "uint256"
                }
            ],
            "name": "Burn",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "uint16",
                    "name": "observationCardinalityNextOld",
                    "type": "uint16"
                },
                {
                    "indexed": false,
                    "internalType": "uint16",
                    "name": "observationCardinalityNextNew",
                    "type": "uint16"
                }
            ],
            "name": "IncreaseObservationCardinalityNext",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "receiver",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "netLpMinted",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "netSyUsed",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "netPtUsed",
                    "type": "uint256"
                }
            ],
            "name": "Mint",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "caller",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "receiver",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "int256",
                    "name": "netPtOut",
                    "type": "int256"
                },
                {
                    "indexed": false,
                    "internalType": "int256",
                    "name": "netSyOut",
                    "type": "int256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "netSyFee",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "netSyToReserve",
                    "type": "uint256"
                }
            ],
            "name": "Swap",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "from",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "to",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "value",
                    "type": "uint256"
                }
            ],
            "name": "Transfer",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "uint256",
                    "name": "timestamp",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "lnLastImpliedRate",
                    "type": "uint256"
                }
            ],
            "name": "UpdateImpliedRate",
            "type": "event"
        },
        {
            "inputs": [],
            "name": "_storage",
            "outputs": [
                {
                    "internalType": "int128",
                    "name": "totalPt",
                    "type": "int128"
                },
                {
                    "internalType": "int128",
                    "name": "totalSy",
                    "type": "int128"
                },
                {
                    "internalType": "uint96",
                    "name": "lastLnImpliedRate",
                    "type": "uint96"
                },
                {
                    "internalType": "uint16",
                    "name": "observationIndex",
                    "type": "uint16"
                },
                {
                    "internalType": "uint16",
                    "name": "observationCardinality",
                    "type": "uint16"
                },
                {
                    "internalType": "uint16",
                    "name": "observationCardinalityNext",
                    "type": "uint16"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "owner",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "spender",
                    "type": "address"
                }
            ],
            "name": "allowance",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "spender",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                }
            ],
            "name": "approve",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "balanceOf",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "receiverSy",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "receiverPt",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "netLpToBurn",
                    "type": "uint256"
                }
            ],
            "name": "burn",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "netSyOut",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "netPtOut",
                    "type": "uint256"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "decimals",
            "outputs": [
                {
                    "internalType": "uint8",
                    "name": "",
                    "type": "uint8"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "expiry",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "getRewardTokens",
            "outputs": [
                {
                    "internalType": "address[]",
                    "name": "",
                    "type": "address[]"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint16",
                    "name": "cardinalityNext",
                    "type": "uint16"
                }
            ],
            "name": "increaseObservationsCardinalityNext",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "isExpired",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "receiver",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "netSyDesired",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "netPtDesired",
                    "type": "uint256"
                }
            ],
            "name": "mint",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "netLpOut",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "netSyUsed",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "netPtUsed",
                    "type": "uint256"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "name",
            "outputs": [
                {
                    "internalType": "string",
                    "name": "",
                    "type": "string"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "index",
                    "type": "uint256"
                }
            ],
            "name": "observations",
            "outputs": [
                {
                    "internalType": "uint32",
                    "name": "blockTimestamp",
                    "type": "uint32"
                },
                {
                    "internalType": "uint216",
                    "name": "lnImpliedRateCumulative",
                    "type": "uint216"
                },
                {
                    "internalType": "bool",
                    "name": "initialized",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint32[]",
                    "name": "secondsAgos",
                    "type": "uint32[]"
                }
            ],
            "name": "observe",
            "outputs": [
                {
                    "internalType": "uint216[]",
                    "name": "lnImpliedRateCumulative",
                    "type": "uint216[]"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "readTokens",
            "outputs": [
                {
                    "internalType": "contract IStandardizedYield",
                    "name": "_SY",
                    "type": "address"
                },
                {
                    "internalType": "contract IPPrincipalToken",
                    "name": "_PT",
                    "type": "address"
                },
                {
                    "internalType": "contract IPYieldToken",
                    "name": "_YT",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "user",
                    "type": "address"
                }
            ],
            "name": "redeemRewards",
            "outputs": [
                {
                    "internalType": "uint256[]",
                    "name": "",
                    "type": "uint256[]"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "receiver",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "exactPtIn",
                    "type": "uint256"
                },
                {
                    "internalType": "bytes",
                    "name": "data",
                    "type": "bytes"
                }
            ],
            "name": "swapExactPtForSy",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "netSyOut",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "netSyFee",
                    "type": "uint256"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "receiver",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "exactPtOut",
                    "type": "uint256"
                },
                {
                    "internalType": "bytes",
                    "name": "data",
                    "type": "bytes"
                }
            ],
            "name": "swapSyForExactPt",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "netSyIn",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "netSyFee",
                    "type": "uint256"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "symbol",
            "outputs": [
                {
                    "internalType": "string",
                    "name": "",
                    "type": "string"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "totalSupply",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "to",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                }
            ],
            "name": "transfer",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "from",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "to",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                }
            ],
            "name": "transferFrom",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        }
    ],
    "IPPrincipalToken": [
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "owner",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "spender",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "value",
                    "type": "uint256"
                }
            ],
            "name": "Approval",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "from",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "to",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "value",
                    "type": "uint256"
                }
            ],
            "name": "Transfer",
            "type": "event"
        },
        {
            "inputs": [],
            "name": "SY",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "YT",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "owner",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "spender",
                    "type": "address"
                }
            ],
            "name": "allowance",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "spender",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                }
            ],
            "name": "approve",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "balanceOf",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "user",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                }
            ],
            "name": "burnByYT",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "decimals",
            "outputs": [
                {
                    "internalType": "uint8",
                    "name": "",
                    "type": "uint8"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "expiry",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "factory",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_YT",
                    "type": "address"
                }
            ],
            "name": "initialize",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "isExpired",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "user",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                }
            ],
            "name": "mintByYT",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "name",
            "outputs": [
                {
                    "internalType": "string",
                    "name": "",
                    "type": "string"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "symbol",
            "outputs": [
                {
                    "internalType": "string",
                    "name": "",
                    "type": "string"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "totalSupply",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "to",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                }
            ],
            "name": "transfer",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "from",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "to",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                }
            ],
            "name": "transferFrom",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        }
    ],
    "IPYieldToken": [
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "owner",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "spender",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "value",
                    "type": "uint256"
                }
            ],
            "name": "Approval",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "caller",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "receiver",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "amountPYToRedeem",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "amountSyOut",
                    "type": "uint256"
                }
            ],
            "name": "Burn",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "rewardToken",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "amountRewardFee",
                    "type": "uint256"
                }
            ],
            "name": "CollectRewardFee",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "caller",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "receiverPT",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "receiverYT",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "amountSyToMint",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "amountPYOut",
                    "type": "uint256"
                }
            ],
            "name": "Mint",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "uint256",
                    "name": "newIndex",
                    "type": "uint256"
                }
            ],
            "name": "NewInterestIndex",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "user",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "interestOut",
                    "type": "uint256"
                }
            ],
            "name": "RedeemInterest",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "user",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256[]",
                    "name": "amountRewardsOut",
                    "type": "uint256[]"
                }
            ],
            "name": "RedeemRewards",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "from",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "to",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "value",
                    "type": "uint256"
                }
            ],
            "name": "Transfer",
            "type": "event"
        },
        {
            "inputs": [],
            "name": "PT",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "SY",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "owner",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "spender",
                    "type": "address"
                }
            ],
            "name": "allowance",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "spender",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                }
            ],
            "name": "approve",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "balanceOf",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "decimals",
            "outputs": [
                {
                    "internalType": "uint8",
                    "name": "",
                    "type": "uint8"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "doCacheIndexSameBlock",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "expiry",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "factory",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "getRewardTokens",
            "outputs": [
                {
                    "internalType": "address[]",
                    "name": "",
                    "type": "address[]"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "isExpired",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "receiverPT",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "receiverYT",
                    "type": "address"
                }
            ],
            "name": "mintPY",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "amountPYOut",
                    "type": "uint256"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "name",
            "outputs": [
                {
                    "internalType": "string",
                    "name": "",
                    "type": "string"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "pyIndexCurrent",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "pyIndexLastUpdatedBlock",
            "outputs": [
                {
                    "internalType": "uint128",
                    "name": "",
                    "type": "uint128"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "pyIndexStored",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "user",
                    "type": "address"
                },
                {
                    "internalType": "bool",
                    "name": "redeemInterest",
                    "type": "bool"
                },
                {
                    "internalType": "bool",
                    "name": "redeemRewards",
                    "type": "bool"
                }
            ],
            "name": "redeemDueInterestAndRewards",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "interestOut",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256[]",
                    "name": "rewardsOut",
                    "type": "uint256[]"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "receiver",
                    "type": "address"
                }
            ],
            "name": "redeemPY",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "amountSyOut",
                    "type": "uint256"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address[]",
                    "name": "receivers",
                    "type": "address[]"
                },
                {
                    "internalType": "uint256[]",
                    "name": "amountPYToRedeems",
                    "type": "uint256[]"
                }
            ],
            "name": "redeemPYMulti",
            "outputs": [
                {
                    "internalType": "uint256[]",
                    "name": "amountSyOuts",
                    "type": "uint256[]"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "rewardIndexesCurrent",
            "outputs": [
                {
                    "internalType": "uint256[]",
                    "name": "",
                    "type": "uint256[]"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "symbol",
            "outputs": [
                {
                    "internalType": "string",
                    "name": "",
                    "type": "string"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "totalSupply",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "to",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                }
            ],
            "name": "transfer",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "from",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "to",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                }
            ],
            "name": "transferFrom",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        }
    ],
    "IPendlePtOracle": [
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "market",
                    "type": "address"
                },
                {
                    "internalType": "uint32",
                    "name": "duration",
                    "type": "uint32"
                }
            ],
            "name": "getOracleState",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "increaseCardinalityRequired",
                    "type": "bool"
                },
                {
                    "internalType": "uint16",
                    "name": "cardinalityRequired",
                    "type": "uint16"
                },
                {
                    "internalType": "bool",
                    "name": "oldestObservationSatisfied",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "market",
                    "type": "address"
                },
                {
                    "internalType": "uint32",
                    "name": "duration",
                    "type": "uint32"
                }
            ],
            "name": "getPtToSyRate",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        }
    ],
    "IPriceOracle": [
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "token",
                    "type": "address"
                }
            ],
            "name": "getPrice",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        }
    ],
    "IRedemptionManager": [
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "redeemAmount",
                    "type": "uint256"
                },
                {
                    "internalType": "address",
                    "name": "provider",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "csuToken",
                    "type": "address"
                }
            ],
            "name": "calcActualRepayAndSeize",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "asset",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "redeemAmount",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "_totalSupply",
                    "type": "uint256"
                }
            ],
            "name": "getCurrentRedemptionRate",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "asset",
                    "type": "address"
                }
            ],
            "name": "getRedemptionRate",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "csuToken",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                },
                {
                    "internalType": "address[]",
                    "name": "providers",
                    "type": "address[]"
                },
                {
                    "internalType": "uint256",
                    "name": "deadline",
                    "type": "uint256"
                },
                {
                    "internalType": "bytes",
                    "name": "signature",
                    "type": "bytes"
                }
            ],
            "name": "redeemFaceValue",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "redeemer",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "provider",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "csuToken",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "redeemAmount",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "redemptionRateMantissa",
                    "type": "uint256"
                }
            ],
            "name": "redeemFaceValueWithProviderPreview",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        }
    ],
    "ISortedBorrows": [
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "_asset",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "_id",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "_NICR",
                    "type": "uint256"
                }
            ],
            "name": "NodeAdded",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "_asset",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "_id",
                    "type": "address"
                }
            ],
            "name": "NodeRemoved",
            "type": "event"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_asset",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "_id",
                    "type": "address"
                }
            ],
            "name": "contains",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_asset",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "_ICR",
                    "type": "uint256"
                },
                {
                    "internalType": "address",
                    "name": "_prevId",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "_nextId",
                    "type": "address"
                }
            ],
            "name": "findInsertPosition",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_asset",
                    "type": "address"
                }
            ],
            "name": "getFirst",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_asset",
                    "type": "address"
                }
            ],
            "name": "getLast",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_asset",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "_id",
                    "type": "address"
                }
            ],
            "name": "getNext",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_asset",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "_id",
                    "type": "address"
                }
            ],
            "name": "getPrev",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_asset",
                    "type": "address"
                }
            ],
            "name": "getSize",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_asset",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "_id",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "_ICR",
                    "type": "uint256"
                },
                {
                    "internalType": "address",
                    "name": "_prevId",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "_nextId",
                    "type": "address"
                }
            ],
            "name": "insert",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_asset",
                    "type": "address"
                }
            ],
            "name": "isEmpty",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "isSortedBorrows",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_asset",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "_id",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "_newICR",
                    "type": "uint256"
                },
                {
                    "internalType": "address",
                    "name": "_prevId",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "_nextId",
                    "type": "address"
                }
            ],
            "name": "reInsert",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_asset",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "_id",
                    "type": "address"
                }
            ],
            "name": "remove",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_asset",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "_ICR",
                    "type": "uint256"
                },
                {
                    "internalType": "address",
                    "name": "_prevId",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "_nextId",
                    "type": "address"
                }
            ],
            "name": "validInsertPosition",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        }
    ],
    "IStandardizedYield": [
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "owner",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "spender",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "value",
                    "type": "uint256"
                }
            ],
            "name": "Approval",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "user",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "address[]",
                    "name": "rewardTokens",
                    "type": "address[]"
                },
                {
                    "indexed": false,
                    "internalType": "uint256[]",
                    "name": "rewardAmounts",
                    "type": "uint256[]"
                }
            ],
            "name": "ClaimRewards",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "caller",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "receiver",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "tokenIn",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "amountDeposited",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "amountSyOut",
                    "type": "uint256"
                }
            ],
            "name": "Deposit",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "caller",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "receiver",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "tokenOut",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "amountSyToRedeem",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "amountTokenOut",
                    "type": "uint256"
                }
            ],
            "name": "Redeem",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "from",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "to",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "value",
                    "type": "uint256"
                }
            ],
            "name": "Transfer",
            "type": "event"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "user",
                    "type": "address"
                }
            ],
            "name": "accruedRewards",
            "outputs": [
                {
                    "internalType": "uint256[]",
                    "name": "rewardAmounts",
                    "type": "uint256[]"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "owner",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "spender",
                    "type": "address"
                }
            ],
            "name": "allowance",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "spender",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                }
            ],
            "name": "approve",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "assetInfo",
            "outputs": [
                {
                    "internalType": "enum IStandardizedYield.AssetType",
                    "name": "assetType",
                    "type": "uint8"
                },
                {
                    "internalType": "address",
                    "name": "assetAddress",
                    "type": "address"
                },
                {
                    "internalType": "uint8",
                    "name": "assetDecimals",
                    "type": "uint8"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "balanceOf",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "user",
                    "type": "address"
                }
            ],
            "name": "claimRewards",
            "outputs": [
                {
                    "internalType": "uint256[]",
                    "name": "rewardAmounts",
                    "type": "uint256[]"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "decimals",
            "outputs": [
                {
                    "internalType": "uint8",
                    "name": "",
                    "type": "uint8"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "receiver",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "tokenIn",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "amountTokenToDeposit",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "minSharesOut",
                    "type": "uint256"
                }
            ],
            "name": "deposit",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "amountSharesOut",
                    "type": "uint256"
                }
            ],
            "stateMutability": "payable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "exchangeRate",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "res",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "getRewardTokens",
            "outputs": [
                {
                    "internalType": "address[]",
                    "name": "",
                    "type": "address[]"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "getTokensIn",
            "outputs": [
                {
                    "internalType": "address[]",
                    "name": "res",
                    "type": "address[]"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "getTokensOut",
            "outputs": [
                {
                    "internalType": "address[]",
                    "name": "res",
                    "type": "address[]"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "token",
                    "type": "address"
                }
            ],
            "name": "isValidTokenIn",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "token",
                    "type": "address"
                }
            ],
            "name": "isValidTokenOut",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "name",
            "outputs": [
                {
                    "internalType": "string",
                    "name": "",
                    "type": "string"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "tokenIn",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "amountTokenToDeposit",
                    "type": "uint256"
                }
            ],
            "name": "previewDeposit",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "amountSharesOut",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "tokenOut",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "amountSharesToRedeem",
                    "type": "uint256"
                }
            ],
            "name": "previewRedeem",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "amountTokenOut",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "receiver",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "amountSharesToRedeem",
                    "type": "uint256"
                },
                {
                    "internalType": "address",
                    "name": "tokenOut",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "minTokenOut",
                    "type": "uint256"
                },
                {
                    "internalType": "bool",
                    "name": "burnFromInternalBalance",
                    "type": "bool"
                }
            ],
            "name": "redeem",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "amountTokenOut",
                    "type": "uint256"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "rewardIndexesCurrent",
            "outputs": [
                {
                    "internalType": "uint256[]",
                    "name": "indexes",
                    "type": "uint256[]"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "rewardIndexesStored",
            "outputs": [
                {
                    "internalType": "uint256[]",
                    "name": "indexes",
                    "type": "uint256[]"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "symbol",
            "outputs": [
                {
                    "internalType": "string",
                    "name": "",
                    "type": "string"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "totalSupply",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "to",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                }
            ],
            "name": "transfer",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "from",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "to",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                }
            ],
            "name": "transferFrom",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "yieldToken",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        }
    ],
    "IStdReference": [
        {
            "inputs": [
                {
                    "internalType": "string",
                    "name": "_base",
                    "type": "string"
                },
                {
                    "internalType": "string",
                    "name": "_quote",
                    "type": "string"
                }
            ],
            "name": "getReferenceData",
            "outputs": [
                {
                    "components": [
                        {
                            "internalType": "uint256",
                            "name": "rate",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "lastUpdatedBase",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "lastUpdatedQuote",
                            "type": "uint256"
                        }
                    ],
                    "internalType": "struct IStdReference.ReferenceData",
                    "name": "",
                    "type": "tuple"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "string[]",
                    "name": "_bases",
                    "type": "string[]"
                },
                {
                    "internalType": "string[]",
                    "name": "_quotes",
                    "type": "string[]"
                }
            ],
            "name": "getReferenceDataBulk",
            "outputs": [
                {
                    "components": [
                        {
                            "internalType": "uint256",
                            "name": "rate",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "lastUpdatedBase",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "lastUpdatedQuote",
                            "type": "uint256"
                        }
                    ],
                    "internalType": "struct IStdReference.ReferenceData[]",
                    "name": "",
                    "type": "tuple[]"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        }
    ],
    "ITimelock": [
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "uint256",
                    "name": "agreementId",
                    "type": "uint256"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "beneficiary",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "asset",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "enum ITimelock.TimeLockActionType",
                    "name": "actionType",
                    "type": "uint8"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                }
            ],
            "name": "AgreementClaimed",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "uint256",
                    "name": "agreementId",
                    "type": "uint256"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "beneficiary",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "asset",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "enum ITimelock.TimeLockActionType",
                    "name": "actionType",
                    "type": "uint8"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "timestamp",
                    "type": "uint256"
                }
            ],
            "name": "AgreementCreated",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "agreementId",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "bool",
                    "name": "value",
                    "type": "bool"
                }
            ],
            "name": "AgreementFrozen",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "agreementId",
                    "type": "uint256"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "underlyToken",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "to",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "underlyAmount",
                    "type": "uint256"
                }
            ],
            "name": "RescueAgreement",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "bool",
                    "name": "value",
                    "type": "bool"
                }
            ],
            "name": "TimeLockFrozen",
            "type": "event"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "underlyAmount",
                    "type": "uint256"
                }
            ],
            "name": "consumeValue",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "enum ITimelock.TimeLockActionType",
                    "name": "actionType",
                    "type": "uint8"
                },
                {
                    "internalType": "uint256",
                    "name": "underlyAmount",
                    "type": "uint256"
                },
                {
                    "internalType": "address",
                    "name": "beneficiary",
                    "type": "address"
                }
            ],
            "name": "createAgreement",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        }
    ],
    "IUnitroller": [
        {
            "inputs": [],
            "name": "_acceptImplementation",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "admin",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        }
    ],
    "IVoltPair": [
        {
            "inputs": [],
            "name": "metadata",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "dec0",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "dec1",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "r0",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "r1",
                    "type": "uint256"
                },
                {
                    "internalType": "bool",
                    "name": "st",
                    "type": "bool"
                },
                {
                    "internalType": "address",
                    "name": "t0",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "t1",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "token0",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "token1",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        }
    ],
    "IWitnetFeed": [
        {
            "inputs": [],
            "name": "lastPrice",
            "outputs": [
                {
                    "internalType": "int256",
                    "name": "",
                    "type": "int256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        }
    ],
    "IKodiakIsland": [
        {
            "inputs": [],
            "name": "decimals",
            "outputs": [
                {
                    "internalType": "uint8",
                    "name": "",
                    "type": "uint8"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "getUnderlyingBalances",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "amount0Current",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "amount1Current",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "token0",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "token1",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "totalSupply",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        }
    ],
    "IUniswapV2Pair": [
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "owner",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "spender",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "value",
                    "type": "uint256"
                }
            ],
            "name": "Approval",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "sender",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "amount0",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "amount1",
                    "type": "uint256"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "to",
                    "type": "address"
                }
            ],
            "name": "Burn",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "sender",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "amount0",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "amount1",
                    "type": "uint256"
                }
            ],
            "name": "Mint",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "sender",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "amount0In",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "amount1In",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "amount0Out",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "amount1Out",
                    "type": "uint256"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "to",
                    "type": "address"
                }
            ],
            "name": "Swap",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "uint112",
                    "name": "reserve0",
                    "type": "uint112"
                },
                {
                    "indexed": false,
                    "internalType": "uint112",
                    "name": "reserve1",
                    "type": "uint112"
                }
            ],
            "name": "Sync",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "from",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "to",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "value",
                    "type": "uint256"
                }
            ],
            "name": "Transfer",
            "type": "event"
        },
        {
            "inputs": [],
            "name": "DOMAIN_SEPARATOR",
            "outputs": [
                {
                    "internalType": "bytes32",
                    "name": "",
                    "type": "bytes32"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "MINIMUM_LIQUIDITY",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "pure",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "PERMIT_TYPEHASH",
            "outputs": [
                {
                    "internalType": "bytes32",
                    "name": "",
                    "type": "bytes32"
                }
            ],
            "stateMutability": "pure",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "owner",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "spender",
                    "type": "address"
                }
            ],
            "name": "allowance",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "spender",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "value",
                    "type": "uint256"
                }
            ],
            "name": "approve",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "owner",
                    "type": "address"
                }
            ],
            "name": "balanceOf",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "to",
                    "type": "address"
                }
            ],
            "name": "burn",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "amount0",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "amount1",
                    "type": "uint256"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "decimals",
            "outputs": [
                {
                    "internalType": "uint8",
                    "name": "",
                    "type": "uint8"
                }
            ],
            "stateMutability": "pure",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "factory",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "getReserves",
            "outputs": [
                {
                    "internalType": "uint112",
                    "name": "reserve0",
                    "type": "uint112"
                },
                {
                    "internalType": "uint112",
                    "name": "reserve1",
                    "type": "uint112"
                },
                {
                    "internalType": "uint32",
                    "name": "blockTimestampLast",
                    "type": "uint32"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "initialize",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "kLast",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "to",
                    "type": "address"
                }
            ],
            "name": "mint",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "liquidity",
                    "type": "uint256"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "name",
            "outputs": [
                {
                    "internalType": "string",
                    "name": "",
                    "type": "string"
                }
            ],
            "stateMutability": "pure",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "owner",
                    "type": "address"
                }
            ],
            "name": "nonces",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "owner",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "spender",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "value",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "deadline",
                    "type": "uint256"
                },
                {
                    "internalType": "uint8",
                    "name": "v",
                    "type": "uint8"
                },
                {
                    "internalType": "bytes32",
                    "name": "r",
                    "type": "bytes32"
                },
                {
                    "internalType": "bytes32",
                    "name": "s",
                    "type": "bytes32"
                }
            ],
            "name": "permit",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "price0CumulativeLast",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "price1CumulativeLast",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "to",
                    "type": "address"
                }
            ],
            "name": "skim",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "amount0Out",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "amount1Out",
                    "type": "uint256"
                },
                {
                    "internalType": "address",
                    "name": "to",
                    "type": "address"
                },
                {
                    "internalType": "bytes",
                    "name": "data",
                    "type": "bytes"
                }
            ],
            "name": "swap",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "symbol",
            "outputs": [
                {
                    "internalType": "string",
                    "name": "",
                    "type": "string"
                }
            ],
            "stateMutability": "pure",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "sync",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "token0",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "token1",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "totalSupply",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "to",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "value",
                    "type": "uint256"
                }
            ],
            "name": "transfer",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "from",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "to",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "value",
                    "type": "uint256"
                }
            ],
            "name": "transferFrom",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        }
    ],
    "CreateCall": [
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "newContract",
                    "type": "address"
                }
            ],
            "name": "ContractCreation",
            "type": "event"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "value",
                    "type": "uint256"
                },
                {
                    "internalType": "bytes",
                    "name": "deploymentData",
                    "type": "bytes"
                }
            ],
            "name": "performCreate",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "newContract",
                    "type": "address"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "value",
                    "type": "uint256"
                },
                {
                    "internalType": "bytes",
                    "name": "deploymentData",
                    "type": "bytes"
                },
                {
                    "internalType": "bytes32",
                    "name": "salt",
                    "type": "bytes32"
                }
            ],
            "name": "performCreate2",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "newContract",
                    "type": "address"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        }
    ],
    "RateLimiter": [
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "capacity",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "requested",
                    "type": "uint256"
                }
            ],
            "name": "AggregateValueMaxCapacityExceeded",
            "type": "error"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "minWaitInSeconds",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "available",
                    "type": "uint256"
                }
            ],
            "name": "AggregateValueRateLimitReached",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "BucketOverfilled",
            "type": "error"
        },
        {
            "inputs": [
                {
                    "components": [
                        {
                            "internalType": "bool",
                            "name": "isEnabled",
                            "type": "bool"
                        },
                        {
                            "internalType": "uint256",
                            "name": "capacity",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "rate",
                            "type": "uint256"
                        }
                    ],
                    "internalType": "struct RateLimiter.Config",
                    "name": "config",
                    "type": "tuple"
                }
            ],
            "name": "DisabledNonZeroRateLimit",
            "type": "error"
        },
        {
            "inputs": [
                {
                    "components": [
                        {
                            "internalType": "bool",
                            "name": "isEnabled",
                            "type": "bool"
                        },
                        {
                            "internalType": "uint256",
                            "name": "capacity",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "rate",
                            "type": "uint256"
                        }
                    ],
                    "internalType": "struct RateLimiter.Config",
                    "name": "rateLimiterConfig",
                    "type": "tuple"
                }
            ],
            "name": "InvalidRatelimitRate",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyCallableByAdminOrOwner",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RateLimitMustBeDisabled",
            "type": "error"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "capacity",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "requested",
                    "type": "uint256"
                },
                {
                    "internalType": "address",
                    "name": "tokenAddress",
                    "type": "address"
                }
            ],
            "name": "TokenMaxCapacityExceeded",
            "type": "error"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "minWaitInSeconds",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "available",
                    "type": "uint256"
                },
                {
                    "internalType": "address",
                    "name": "tokenAddress",
                    "type": "address"
                }
            ],
            "name": "TokenRateLimitReached",
            "type": "error"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "components": [
                        {
                            "internalType": "bool",
                            "name": "isEnabled",
                            "type": "bool"
                        },
                        {
                            "internalType": "uint256",
                            "name": "capacity",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "rate",
                            "type": "uint256"
                        }
                    ],
                    "indexed": false,
                    "internalType": "struct RateLimiter.Config",
                    "name": "config",
                    "type": "tuple"
                }
            ],
            "name": "ConfigChanged",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "tokens",
                    "type": "uint256"
                }
            ],
            "name": "TokensConsumed",
            "type": "event"
        }
    ],
    "API3Adapter": [
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_correlatedToken",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "_underlyingToken",
                    "type": "address"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "constructor"
        },
        {
            "inputs": [],
            "name": "InvalidPrice",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidProxy",
            "type": "error"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "previousOwner",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "newOwner",
                    "type": "address"
                }
            ],
            "name": "OwnershipTransferStarted",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "previousOwner",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "newOwner",
                    "type": "address"
                }
            ],
            "name": "OwnershipTransferred",
            "type": "event"
        },
        {
            "inputs": [],
            "name": "acceptOwnership",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "exchangeRate",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "owner",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "pendingOwner",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "renounceOwnership",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_proxy",
                    "type": "address"
                }
            ],
            "name": "setAPI3Proxy",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "newOwner",
                    "type": "address"
                }
            ],
            "name": "transferOwnership",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        }
    ],
    "IAPI3Proxy": [
        {
            "inputs": [],
            "name": "api3ServerV1",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "read",
            "outputs": [
                {
                    "internalType": "int224",
                    "name": "value",
                    "type": "int224"
                },
                {
                    "internalType": "uint32",
                    "name": "timestamp",
                    "type": "uint32"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        }
    ],
    "FeedPriceOracle": [
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "admin",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "nativeMarket_",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "nativeAsset_",
                    "type": "address"
                },
                {
                    "internalType": "contract IPyth",
                    "name": "pythOracle_",
                    "type": "address"
                },
                {
                    "internalType": "contract IPendlePtOracle",
                    "name": "pendlePtOracle_",
                    "type": "address"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "constructor"
        },
        {
            "inputs": [],
            "name": "EmptyAdapterAddress",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "EmptyFeedAddress",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "EmptyMaxStalePeriod",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "EmptyPendlePtOracle",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "EmptyPythOracle",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidDecimals",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidFeedDecimals",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidPrice",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "UnknownSource",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "UnsupportedSource",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ZeroAddressNotAllowed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ZeroValueNotAllowed",
            "type": "error"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "asset",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "enum FeedPriceOracle.Source",
                    "name": "source",
                    "type": "uint8"
                },
                {
                    "indexed": false,
                    "internalType": "uint8",
                    "name": "feedDecimals",
                    "type": "uint8"
                },
                {
                    "indexed": false,
                    "internalType": "uint32",
                    "name": "maxStalePeriod",
                    "type": "uint32"
                },
                {
                    "indexed": false,
                    "internalType": "bytes32",
                    "name": "metadata",
                    "type": "bytes32"
                }
            ],
            "name": "NewFeed",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "oldValue",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "newValue",
                    "type": "address"
                }
            ],
            "name": "NewPendlePtOracle",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "oldValue",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "newValue",
                    "type": "address"
                }
            ],
            "name": "NewPythOracle",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "previousOwner",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "newOwner",
                    "type": "address"
                }
            ],
            "name": "OwnershipTransferStarted",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "previousOwner",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "newOwner",
                    "type": "address"
                }
            ],
            "name": "OwnershipTransferred",
            "type": "event"
        },
        {
            "inputs": [],
            "name": "acceptOwnership",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "adapterFeeds",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "adapterAddr",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "denominator",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "chainlinkFeeds",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "feedAddr",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "denominator",
                    "type": "address"
                },
                {
                    "internalType": "uint8",
                    "name": "feedDecimals",
                    "type": "uint8"
                },
                {
                    "internalType": "uint32",
                    "name": "maxStalePeriod",
                    "type": "uint32"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "fixedPrices",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "asset",
                    "type": "address"
                }
            ],
            "name": "getFixedPrice",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "asset",
                    "type": "address"
                }
            ],
            "name": "getPrice",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "ctoken",
                    "type": "address"
                }
            ],
            "name": "getUnderlyingPrice",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address[]",
                    "name": "cTokens",
                    "type": "address[]"
                }
            ],
            "name": "getUnderlyingPrices",
            "outputs": [
                {
                    "internalType": "uint256[]",
                    "name": "",
                    "type": "uint256[]"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "isPriceOracle",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "layerbankFeeds",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "feedAddr",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "feedAssetAddr",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "mainSource",
            "outputs": [
                {
                    "internalType": "enum FeedPriceOracle.Source",
                    "name": "",
                    "type": "uint8"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "nativeAsset",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "nativeMarket",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "owner",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "pendingOwner",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "pendleFeeds",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "market",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "yieldToken",
                    "type": "address"
                },
                {
                    "internalType": "uint32",
                    "name": "twapDuration",
                    "type": "uint32"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "pendlePtOracle",
            "outputs": [
                {
                    "internalType": "contract IPendlePtOracle",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "pythFeeds",
            "outputs": [
                {
                    "internalType": "bytes32",
                    "name": "feedId",
                    "type": "bytes32"
                },
                {
                    "internalType": "uint32",
                    "name": "maxStalePeriod",
                    "type": "uint32"
                },
                {
                    "internalType": "address",
                    "name": "denominator",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "pythOracle",
            "outputs": [
                {
                    "internalType": "contract IPyth",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "redstoneFeeds",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "feedAddr",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "denominator",
                    "type": "address"
                },
                {
                    "internalType": "uint8",
                    "name": "feedDecimals",
                    "type": "uint8"
                },
                {
                    "internalType": "uint32",
                    "name": "maxStalePeriod",
                    "type": "uint32"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "asset",
                    "type": "address"
                }
            ],
            "name": "removeAdapterFeed",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "asset",
                    "type": "address"
                }
            ],
            "name": "removeBalancerFeed",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "asset",
                    "type": "address"
                }
            ],
            "name": "removeChainlinkFeed",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "asset",
                    "type": "address"
                }
            ],
            "name": "removeFixedPrice",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "asset",
                    "type": "address"
                }
            ],
            "name": "removeKodiakIslandFeed",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "asset",
                    "type": "address"
                }
            ],
            "name": "removeLayerbankFeed",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "asset",
                    "type": "address"
                }
            ],
            "name": "removePendleFeed",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "asset",
                    "type": "address"
                }
            ],
            "name": "removePythFeed",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "asset",
                    "type": "address"
                }
            ],
            "name": "removeRedstoneFeed",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "asset",
                    "type": "address"
                }
            ],
            "name": "removeUniswapV2Feed",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "renounceOwnership",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "asset",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "adapterAddr",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "denominator",
                    "type": "address"
                }
            ],
            "name": "setAdapterFeed",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "asset",
                    "type": "address"
                }
            ],
            "name": "setBalancerFeed",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "asset",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "feedAddr",
                    "type": "address"
                },
                {
                    "internalType": "uint32",
                    "name": "maxStalePeriod",
                    "type": "uint32"
                },
                {
                    "internalType": "address",
                    "name": "denominator",
                    "type": "address"
                }
            ],
            "name": "setChainlinkFeed",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "asset",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "price",
                    "type": "uint256"
                }
            ],
            "name": "setFixedPrice",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "asset",
                    "type": "address"
                }
            ],
            "name": "setKodiakIslandFeed",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "asset",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "feedAddr",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "feedAssetAddr",
                    "type": "address"
                }
            ],
            "name": "setLayerbankFeed",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "asset",
                    "type": "address"
                },
                {
                    "internalType": "enum FeedPriceOracle.Source",
                    "name": "source",
                    "type": "uint8"
                }
            ],
            "name": "setMainSource",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "asset",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "market",
                    "type": "address"
                },
                {
                    "internalType": "uint32",
                    "name": "twapDuration",
                    "type": "uint32"
                },
                {
                    "internalType": "address",
                    "name": "yieldToken",
                    "type": "address"
                }
            ],
            "name": "setPendleFeed",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "contract IPendlePtOracle",
                    "name": "pendlePtOracle_",
                    "type": "address"
                }
            ],
            "name": "setPendlePtOracle",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "asset",
                    "type": "address"
                },
                {
                    "internalType": "uint32",
                    "name": "maxStalePeriod",
                    "type": "uint32"
                },
                {
                    "internalType": "bytes32",
                    "name": "feedId",
                    "type": "bytes32"
                },
                {
                    "internalType": "address",
                    "name": "denominator",
                    "type": "address"
                }
            ],
            "name": "setPythFeed",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "contract IPyth",
                    "name": "pythOracle_",
                    "type": "address"
                }
            ],
            "name": "setPythOracle",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "asset",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "feedAddr",
                    "type": "address"
                },
                {
                    "internalType": "uint32",
                    "name": "maxStalePeriod",
                    "type": "uint32"
                },
                {
                    "internalType": "address",
                    "name": "denominator",
                    "type": "address"
                }
            ],
            "name": "setRedStoneFeed",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "asset",
                    "type": "address"
                }
            ],
            "name": "setUniswapV2Feed",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "newOwner",
                    "type": "address"
                }
            ],
            "name": "transferOwnership",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        }
    ],
    "LayerBankAdapter": [
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_correlatedToken",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "_underlyingToken",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "_feedAddr",
                    "type": "address"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "constructor"
        },
        {
            "inputs": [],
            "name": "exchangeRate",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "feedAddr",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        }
    ],
    "PriceAdapter": [
        {
            "inputs": [],
            "name": "exchangeRate",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        }
    ],
    "PriceOracle": [
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "asset",
                    "type": "address"
                }
            ],
            "name": "getPrice",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                }
            ],
            "name": "getUnderlyingPrice",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "isPriceOracle",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        }
    ],
    "IStToken": [
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "shares",
                    "type": "uint256"
                }
            ],
            "name": "previewRedeem",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        }
    ],
    "StakedAngleAdapter": [
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_correlatedToken",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "_underlyingToken",
                    "type": "address"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "constructor"
        },
        {
            "inputs": [],
            "name": "exchangeRate",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        }
    ],
    "IStETH": [
        {
            "inputs": [],
            "name": "decimals",
            "outputs": [
                {
                    "internalType": "uint8",
                    "name": "",
                    "type": "uint8"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "_sharesAmount",
                    "type": "uint256"
                }
            ],
            "name": "getPooledEthByShares",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        }
    ],
    "WstETHAdapter": [
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_wstETH",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "_stETH",
                    "type": "address"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "constructor"
        },
        {
            "inputs": [],
            "name": "exchangeRate",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        }
    ],
    "IWstMTRG": [
        {
            "inputs": [],
            "name": "stMTRGPerToken",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        }
    ],
    "WstMTRGAdapter": [
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_wstMTRG",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "_stMTRG",
                    "type": "address"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "constructor"
        },
        {
            "inputs": [],
            "name": "exchangeRate",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        }
    ],
    "IDualCore": [
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "name": "exchangeCore",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        }
    ],
    "dualCoreAdapter": [
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_correlatedToken",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "_underlyingToken",
                    "type": "address"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "constructor"
        },
        {
            "inputs": [],
            "name": "exchangeRate",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        }
    ],
    "IEarn": [
        {
            "inputs": [],
            "name": "getCurrentExchangeRate",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        }
    ],
    "IStCore": [
        {
            "inputs": [],
            "name": "earn",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        }
    ],
    "stCoreAdapter": [
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_correlatedToken",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "_underlyingToken",
                    "type": "address"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "constructor"
        },
        {
            "inputs": [],
            "name": "exchangeRate",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        }
    ],
    "IStEUR": [
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "shares",
                    "type": "uint256"
                }
            ],
            "name": "previewRedeem",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        }
    ],
    "stEURAdapter": [
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_correlatedToken",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "_underlyingToken",
                    "type": "address"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "constructor"
        },
        {
            "inputs": [],
            "name": "exchangeRate",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        }
    ],
    "IStUSD": [
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "shares",
                    "type": "uint256"
                }
            ],
            "name": "previewRedeem",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        }
    ],
    "stUSDAdapter": [
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_correlatedToken",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "_underlyingToken",
                    "type": "address"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "constructor"
        },
        {
            "inputs": [],
            "name": "exchangeRate",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        }
    ],
    "wstMTRGOracle": [
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_wstMTRG",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "_mtrgFeed",
                    "type": "address"
                },
                {
                    "internalType": "bytes32",
                    "name": "_feedId",
                    "type": "bytes32"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "constructor"
        },
        {
            "inputs": [],
            "name": "feedId",
            "outputs": [
                {
                    "internalType": "bytes32",
                    "name": "",
                    "type": "bytes32"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "id",
                    "type": "bytes32"
                }
            ],
            "name": "getEmaPrice",
            "outputs": [
                {
                    "components": [
                        {
                            "internalType": "int64",
                            "name": "price",
                            "type": "int64"
                        },
                        {
                            "internalType": "uint64",
                            "name": "conf",
                            "type": "uint64"
                        },
                        {
                            "internalType": "int32",
                            "name": "expo",
                            "type": "int32"
                        },
                        {
                            "internalType": "uint256",
                            "name": "publishTime",
                            "type": "uint256"
                        }
                    ],
                    "internalType": "struct PythStructs.Price",
                    "name": "price",
                    "type": "tuple"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "id",
                    "type": "bytes32"
                },
                {
                    "internalType": "uint256",
                    "name": "age",
                    "type": "uint256"
                }
            ],
            "name": "getEmaPriceNoOlderThan",
            "outputs": [
                {
                    "components": [
                        {
                            "internalType": "int64",
                            "name": "price",
                            "type": "int64"
                        },
                        {
                            "internalType": "uint64",
                            "name": "conf",
                            "type": "uint64"
                        },
                        {
                            "internalType": "int32",
                            "name": "expo",
                            "type": "int32"
                        },
                        {
                            "internalType": "uint256",
                            "name": "publishTime",
                            "type": "uint256"
                        }
                    ],
                    "internalType": "struct PythStructs.Price",
                    "name": "price",
                    "type": "tuple"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "id",
                    "type": "bytes32"
                }
            ],
            "name": "getEmaPriceUnsafe",
            "outputs": [
                {
                    "components": [
                        {
                            "internalType": "int64",
                            "name": "price",
                            "type": "int64"
                        },
                        {
                            "internalType": "uint64",
                            "name": "conf",
                            "type": "uint64"
                        },
                        {
                            "internalType": "int32",
                            "name": "expo",
                            "type": "int32"
                        },
                        {
                            "internalType": "uint256",
                            "name": "publishTime",
                            "type": "uint256"
                        }
                    ],
                    "internalType": "struct PythStructs.Price",
                    "name": "price",
                    "type": "tuple"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "id",
                    "type": "bytes32"
                }
            ],
            "name": "getPrice",
            "outputs": [
                {
                    "components": [
                        {
                            "internalType": "int64",
                            "name": "price",
                            "type": "int64"
                        },
                        {
                            "internalType": "uint64",
                            "name": "conf",
                            "type": "uint64"
                        },
                        {
                            "internalType": "int32",
                            "name": "expo",
                            "type": "int32"
                        },
                        {
                            "internalType": "uint256",
                            "name": "publishTime",
                            "type": "uint256"
                        }
                    ],
                    "internalType": "struct PythStructs.Price",
                    "name": "price",
                    "type": "tuple"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "id",
                    "type": "bytes32"
                },
                {
                    "internalType": "uint256",
                    "name": "age",
                    "type": "uint256"
                }
            ],
            "name": "getPriceNoOlderThan",
            "outputs": [
                {
                    "components": [
                        {
                            "internalType": "int64",
                            "name": "price",
                            "type": "int64"
                        },
                        {
                            "internalType": "uint64",
                            "name": "conf",
                            "type": "uint64"
                        },
                        {
                            "internalType": "int32",
                            "name": "expo",
                            "type": "int32"
                        },
                        {
                            "internalType": "uint256",
                            "name": "publishTime",
                            "type": "uint256"
                        }
                    ],
                    "internalType": "struct PythStructs.Price",
                    "name": "price",
                    "type": "tuple"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "id",
                    "type": "bytes32"
                }
            ],
            "name": "getPriceUnsafe",
            "outputs": [
                {
                    "components": [
                        {
                            "internalType": "int64",
                            "name": "price",
                            "type": "int64"
                        },
                        {
                            "internalType": "uint64",
                            "name": "conf",
                            "type": "uint64"
                        },
                        {
                            "internalType": "int32",
                            "name": "expo",
                            "type": "int32"
                        },
                        {
                            "internalType": "uint256",
                            "name": "publishTime",
                            "type": "uint256"
                        }
                    ],
                    "internalType": "struct PythStructs.Price",
                    "name": "price",
                    "type": "tuple"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "getValidTimePeriod",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "validTimePeriod",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "mtrgFeed",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "wstMTRG",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        }
    ],
    "SumerProxy": [
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "logic",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "admin_",
                    "type": "address"
                },
                {
                    "internalType": "bytes",
                    "name": "data",
                    "type": "bytes"
                }
            ],
            "stateMutability": "payable",
            "type": "constructor"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "previousAdmin",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "newAdmin",
                    "type": "address"
                }
            ],
            "name": "AdminChanged",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "beacon",
                    "type": "address"
                }
            ],
            "name": "BeaconUpgraded",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "implementation",
                    "type": "address"
                }
            ],
            "name": "Upgraded",
            "type": "event"
        },
        {
            "stateMutability": "payable",
            "type": "fallback"
        },
        {
            "inputs": [],
            "name": "admin",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "admin_",
                    "type": "address"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "newAdmin",
                    "type": "address"
                }
            ],
            "name": "changeAdmin",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "implementation",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "implementation_",
                    "type": "address"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "newImplementation",
                    "type": "address"
                }
            ],
            "name": "upgradeTo",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "newImplementation",
                    "type": "address"
                },
                {
                    "internalType": "bytes",
                    "name": "data",
                    "type": "bytes"
                }
            ],
            "name": "upgradeToAndCall",
            "outputs": [],
            "stateMutability": "payable",
            "type": "function"
        },
        {
            "stateMutability": "payable",
            "type": "receive"
        }
    ],
    "SumerProxyAdmin": [
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "previousOwner",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "newOwner",
                    "type": "address"
                }
            ],
            "name": "OwnershipTransferred",
            "type": "event"
        },
        {
            "inputs": [
                {
                    "internalType": "contract TransparentUpgradeableProxy",
                    "name": "proxy",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "newAdmin",
                    "type": "address"
                }
            ],
            "name": "changeProxyAdmin",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "contract TransparentUpgradeableProxy",
                    "name": "proxy",
                    "type": "address"
                }
            ],
            "name": "getProxyAdmin",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "contract TransparentUpgradeableProxy",
                    "name": "proxy",
                    "type": "address"
                }
            ],
            "name": "getProxyImplementation",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "owner",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "renounceOwnership",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "newOwner",
                    "type": "address"
                }
            ],
            "name": "transferOwnership",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "contract TransparentUpgradeableProxy",
                    "name": "proxy",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "implementation",
                    "type": "address"
                }
            ],
            "name": "upgrade",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "contract TransparentUpgradeableProxy",
                    "name": "proxy",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "implementation",
                    "type": "address"
                },
                {
                    "internalType": "bytes",
                    "name": "data",
                    "type": "bytes"
                }
            ],
            "name": "upgradeAndCall",
            "outputs": [],
            "stateMutability": "payable",
            "type": "function"
        }
    ],
    "CommunalFarm": [
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_stakingToken",
                    "type": "address"
                },
                {
                    "internalType": "string[]",
                    "name": "_rewardSymbols",
                    "type": "string[]"
                },
                {
                    "internalType": "address[]",
                    "name": "_rewardTokens",
                    "type": "address[]"
                },
                {
                    "internalType": "address[]",
                    "name": "_rewardManagers",
                    "type": "address[]"
                },
                {
                    "internalType": "uint256[]",
                    "name": "_rewardRates",
                    "type": "uint256[]"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "constructor"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "multiplier",
                    "type": "uint256"
                }
            ],
            "name": "LockedStakeMaxMultiplierUpdated",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "secs",
                    "type": "uint256"
                }
            ],
            "name": "LockedStakeMinTime",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "secs",
                    "type": "uint256"
                }
            ],
            "name": "LockedStakeTimeForMaxMultiplier",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "previousOwner",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "newOwner",
                    "type": "address"
                }
            ],
            "name": "OwnershipTransferStarted",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "previousOwner",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "newOwner",
                    "type": "address"
                }
            ],
            "name": "OwnershipTransferred",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "destination_address",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "token",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                }
            ],
            "name": "Recovered",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "user",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "reward",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "token_address",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "destination_address",
                    "type": "address"
                }
            ],
            "name": "RewardPaid",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "newDuration",
                    "type": "uint256"
                }
            ],
            "name": "RewardsDurationUpdated",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "token",
                    "type": "address"
                }
            ],
            "name": "RewardsPeriodRenewed",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "user",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "secs",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "bytes32",
                    "name": "kek_id",
                    "type": "bytes32"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "source_address",
                    "type": "address"
                }
            ],
            "name": "StakeLocked",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "user",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "bytes32",
                    "name": "kek_id",
                    "type": "bytes32"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "destination_address",
                    "type": "address"
                }
            ],
            "name": "WithdrawLocked",
            "type": "event"
        },
        {
            "inputs": [],
            "name": "acceptOwnership",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "calcCurCombinedWeight",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "old_combined_weight",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "new_combined_weight",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "reward_token_address",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "new_manager_address",
                    "type": "address"
                }
            ],
            "name": "changeTokenManager",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "combinedWeightOf",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "earned",
            "outputs": [
                {
                    "internalType": "uint256[]",
                    "name": "new_earned",
                    "type": "uint256[]"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "getAllRewardRates",
            "outputs": [
                {
                    "internalType": "uint256[]",
                    "name": "",
                    "type": "uint256[]"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "getAllRewardTokens",
            "outputs": [
                {
                    "internalType": "address[]",
                    "name": "",
                    "type": "address[]"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "getReward",
            "outputs": [
                {
                    "internalType": "uint256[]",
                    "name": "",
                    "type": "uint256[]"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "getRewardForDuration",
            "outputs": [
                {
                    "internalType": "uint256[]",
                    "name": "rewards_per_duration_arr",
                    "type": "uint256[]"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "getRewardSymbols",
            "outputs": [
                {
                    "internalType": "string[]",
                    "name": "",
                    "type": "string[]"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "greylist",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_address",
                    "type": "address"
                }
            ],
            "name": "greylistAddress",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "caller_addr",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "reward_token_addr",
                    "type": "address"
                }
            ],
            "name": "isTokenManagerFor",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "lastUpdateTime",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "secs",
                    "type": "uint256"
                }
            ],
            "name": "lockMultiplier",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "lock_max_multiplier",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "lock_time_for_max_multiplier",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "lock_time_min",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "lockedLiquidityOf",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "lockedStakesOf",
            "outputs": [
                {
                    "components": [
                        {
                            "internalType": "bytes32",
                            "name": "kek_id",
                            "type": "bytes32"
                        },
                        {
                            "internalType": "uint256",
                            "name": "start_timestamp",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "liquidity",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "ending_timestamp",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "lock_multiplier",
                            "type": "uint256"
                        }
                    ],
                    "internalType": "struct CommunalFarm.LockedStake[]",
                    "name": "",
                    "type": "tuple[]"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "owner",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "pendingOwner",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "periodFinish",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "tokenAddress",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "tokenAmount",
                    "type": "uint256"
                }
            ],
            "name": "recoverERC20",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "renounceOwnership",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "rewardManagers",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "name": "rewardRates",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "name": "rewardSymbols",
            "outputs": [
                {
                    "internalType": "string",
                    "name": "",
                    "type": "string"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "rewardTokenAddrToIdx",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "name": "rewardTokens",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "rewardsCollectionPaused",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "rewardsDuration",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "rewardsPerToken",
            "outputs": [
                {
                    "internalType": "uint256[]",
                    "name": "newRewardsPerTokenStored",
                    "type": "uint256[]"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "_lock_time_for_max_multiplier",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "_lock_time_min",
                    "type": "uint256"
                }
            ],
            "name": "setLockedStakeTimeForMinAndMaxMultiplier",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "_lock_max_multiplier",
                    "type": "uint256"
                }
            ],
            "name": "setMultipliers",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "reward_token_address",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "new_rate",
                    "type": "uint256"
                },
                {
                    "internalType": "bool",
                    "name": "sync_too",
                    "type": "bool"
                }
            ],
            "name": "setRewardRate",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "_rewardsDuration",
                    "type": "uint256"
                }
            ],
            "name": "setRewardsDuration",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "liquidity",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "secs",
                    "type": "uint256"
                }
            ],
            "name": "stakeLocked",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "stakesUnlocked",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "stakingPaused",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "stakingToken",
            "outputs": [
                {
                    "internalType": "contract IERC20",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "sync",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "toggleRewardsCollection",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "toggleStaking",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "toggleWithdrawals",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "totalCombinedWeight",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "totalLiquidityLocked",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "newOwner",
                    "type": "address"
                }
            ],
            "name": "transferOwnership",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "unlockStakes",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "kek_id",
                    "type": "bytes32"
                }
            ],
            "name": "withdrawLocked",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "withdrawalsPaused",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        }
    ],
    "FraxGaugeController": [
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_token",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "_voting_escrow",
                    "type": "address"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "constructor"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "string",
                    "name": "name",
                    "type": "string"
                },
                {
                    "indexed": false,
                    "internalType": "int128",
                    "name": "type_id",
                    "type": "int128"
                }
            ],
            "name": "AddType",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "admin",
                    "type": "address"
                }
            ],
            "name": "ApplyOwnership",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "admin",
                    "type": "address"
                }
            ],
            "name": "CommitOwnership",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "addr",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "int128",
                    "name": "gauge_type",
                    "type": "int128"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "weight",
                    "type": "uint256"
                }
            ],
            "name": "NewGauge",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "gauge_address",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "time",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "weight",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "total_weight",
                    "type": "uint256"
                }
            ],
            "name": "NewGaugeWeight",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "int128",
                    "name": "type_id",
                    "type": "int128"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "time",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "weight",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "total_weight",
                    "type": "uint256"
                }
            ],
            "name": "NewTypeWeight",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "time",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "user",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "gauge_addr",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "weight",
                    "type": "uint256"
                }
            ],
            "name": "VoteForGauge",
            "type": "event"
        },
        {
            "inputs": [],
            "name": "MULTIPLIER",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "WEEK",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "WEIGHT_VOTE_DELAY",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "addr",
                    "type": "address"
                },
                {
                    "internalType": "int128",
                    "name": "gauge_type",
                    "type": "int128"
                },
                {
                    "internalType": "uint256",
                    "name": "weight",
                    "type": "uint256"
                }
            ],
            "name": "add_gauge",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "string",
                    "name": "_name",
                    "type": "string"
                },
                {
                    "internalType": "uint256",
                    "name": "weight",
                    "type": "uint256"
                }
            ],
            "name": "add_type",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "admin",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "apply_transfer_ownership",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "addr",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "weight",
                    "type": "uint256"
                }
            ],
            "name": "change_gauge_weight",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "new_rate",
                    "type": "uint256"
                }
            ],
            "name": "change_global_emission_rate",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "int128",
                    "name": "type_id",
                    "type": "int128"
                },
                {
                    "internalType": "uint256",
                    "name": "weight",
                    "type": "uint256"
                }
            ],
            "name": "change_type_weight",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "int128",
                    "name": "",
                    "type": "int128"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "name": "changes_sum",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "name": "changes_weight",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "checkpoint",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "addr",
                    "type": "address"
                }
            ],
            "name": "checkpoint_gauge",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "addr",
                    "type": "address"
                }
            ],
            "name": "commit_transfer_ownership",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "future_admin",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "addr",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "time",
                    "type": "uint256"
                }
            ],
            "name": "gauge_relative_weight",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "addr",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "time",
                    "type": "uint256"
                }
            ],
            "name": "gauge_relative_weight_write",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "int128",
                    "name": "",
                    "type": "int128"
                }
            ],
            "name": "gauge_type_names",
            "outputs": [
                {
                    "internalType": "string",
                    "name": "",
                    "type": "string"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_addr",
                    "type": "address"
                }
            ],
            "name": "gauge_types",
            "outputs": [
                {
                    "internalType": "int128",
                    "name": "",
                    "type": "int128"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "gauge_types_",
            "outputs": [
                {
                    "internalType": "int128",
                    "name": "",
                    "type": "int128"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "name": "gauges",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "addr",
                    "type": "address"
                }
            ],
            "name": "get_corrected_info",
            "outputs": [
                {
                    "components": [
                        {
                            "internalType": "uint256",
                            "name": "bias",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "slope",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "lock_end",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "fxs_amount",
                            "type": "uint256"
                        }
                    ],
                    "internalType": "struct CorrectedPoint",
                    "name": "",
                    "type": "tuple"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "addr",
                    "type": "address"
                }
            ],
            "name": "get_gauge_weight",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "get_total_weight",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "int128",
                    "name": "type_id",
                    "type": "int128"
                }
            ],
            "name": "get_type_weight",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "int128",
                    "name": "type_id",
                    "type": "int128"
                }
            ],
            "name": "get_weights_sum_per_type",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "global_emission_rate",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "last_user_vote",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "n_gauge_types",
            "outputs": [
                {
                    "internalType": "int128",
                    "name": "",
                    "type": "int128"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "n_gauges",
            "outputs": [
                {
                    "internalType": "int128",
                    "name": "",
                    "type": "int128"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "int128",
                    "name": "",
                    "type": "int128"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "name": "points_sum",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "bias",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "slope",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "name": "points_total",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "int128",
                    "name": "",
                    "type": "int128"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "name": "points_type_weight",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "name": "points_weight",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "bias",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "slope",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "name": "time_sum",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "time_total",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "name": "time_type_weight",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "time_weight",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "token",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_gauge_addr",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "_user_weight",
                    "type": "uint256"
                }
            ],
            "name": "vote_for_gauge_weights",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "vote_user_power",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "vote_user_slopes",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "slope",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "power",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "end",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "voting_escrow",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        }
    ],
    "VotingEscrow": [
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "addr",
                    "type": "address"
                }
            ],
            "name": "balanceOf",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "addr",
                    "type": "address"
                }
            ],
            "name": "locked",
            "outputs": [
                {
                    "components": [
                        {
                            "internalType": "int128",
                            "name": "amount",
                            "type": "int128"
                        },
                        {
                            "internalType": "uint256",
                            "name": "end",
                            "type": "uint256"
                        }
                    ],
                    "internalType": "struct LockedBalance",
                    "name": "",
                    "type": "tuple"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "addr",
                    "type": "address"
                }
            ],
            "name": "locked__end",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        }
    ],
    "FraxGaugeFXSRewardsDistributor": [
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_timelock_address",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "_curator_address",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "_reward_token_address",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "_gauge_controller_address",
                    "type": "address"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "constructor"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "bool",
                    "name": "distibutions_state",
                    "type": "bool"
                }
            ],
            "name": "DistributionsToggled",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "gauge_address",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "bool",
                    "name": "is_middleman",
                    "type": "bool"
                },
                {
                    "indexed": false,
                    "internalType": "bool",
                    "name": "is_active",
                    "type": "bool"
                }
            ],
            "name": "GaugeStateChanged",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "previousOwner",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "newOwner",
                    "type": "address"
                }
            ],
            "name": "OwnershipTransferred",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "token",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                }
            ],
            "name": "RecoveredERC20",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "gauge_address",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "reward_amount",
                    "type": "uint256"
                }
            ],
            "name": "RewardDistributed",
            "type": "event"
        },
        {
            "inputs": [],
            "name": "curator_address",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "gauge_address",
                    "type": "address"
                }
            ],
            "name": "currentReward",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "reward_amount",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "gauge_address",
                    "type": "address"
                }
            ],
            "name": "distributeReward",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "weeks_elapsed",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "reward_tally",
                    "type": "uint256"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "distributionsOn",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "gauge_controller",
            "outputs": [
                {
                    "internalType": "contract IFraxGaugeController",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "gauge_whitelist",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "is_middleman",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "last_time_gauge_paid",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "owner",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "tokenAddress",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "tokenAmount",
                    "type": "uint256"
                }
            ],
            "name": "recoverERC20",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "renounceOwnership",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "reward_token_address",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_new_curator_address",
                    "type": "address"
                }
            ],
            "name": "setCurator",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_gauge_controller_address",
                    "type": "address"
                }
            ],
            "name": "setGaugeController",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_gauge_address",
                    "type": "address"
                },
                {
                    "internalType": "bool",
                    "name": "_is_middleman",
                    "type": "bool"
                },
                {
                    "internalType": "bool",
                    "name": "_is_active",
                    "type": "bool"
                }
            ],
            "name": "setGaugeState",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_new_timelock",
                    "type": "address"
                }
            ],
            "name": "setTimelock",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "timelock_address",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "toggleDistributions",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "newOwner",
                    "type": "address"
                }
            ],
            "name": "transferOwnership",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        }
    ],
    "IFraxGaugeController": [
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                },
                {
                    "internalType": "int128",
                    "name": "",
                    "type": "int128"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "name": "add_gauge",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "string",
                    "name": "",
                    "type": "string"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "name": "add_type",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "admin",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "apply_transfer_ownership",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "name": "change_gauge_weight",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "name": "change_global_emission_rate",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "int128",
                    "name": "",
                    "type": "int128"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "name": "change_type_weight",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "checkpoint",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "checkpoint_gauge",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "commit_transfer_ownership",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "future_admin",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "gauge_relative_weight",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "name": "gauge_relative_weight",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "name": "gauge_relative_weight_write",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "gauge_relative_weight_write",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "int128",
                    "name": "",
                    "type": "int128"
                }
            ],
            "name": "gauge_type_names",
            "outputs": [
                {
                    "internalType": "string",
                    "name": "",
                    "type": "string"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "gauge_types",
            "outputs": [
                {
                    "internalType": "int128",
                    "name": "",
                    "type": "int128"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "name": "gauges",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "get_gauge_weight",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "get_total_weight",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "int128",
                    "name": "",
                    "type": "int128"
                }
            ],
            "name": "get_type_weight",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "int128",
                    "name": "",
                    "type": "int128"
                }
            ],
            "name": "get_weights_sum_per_type",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "global_emission_rate",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "last_user_vote",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "n_gauge_types",
            "outputs": [
                {
                    "internalType": "int128",
                    "name": "",
                    "type": "int128"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "n_gauges",
            "outputs": [
                {
                    "internalType": "int128",
                    "name": "",
                    "type": "int128"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "int128",
                    "name": "",
                    "type": "int128"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "name": "points_sum",
            "outputs": [
                {
                    "components": [
                        {
                            "internalType": "uint256",
                            "name": "bias",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "slope",
                            "type": "uint256"
                        }
                    ],
                    "internalType": "struct IFraxGaugeController.Point",
                    "name": "",
                    "type": "tuple"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "name": "points_total",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "int128",
                    "name": "",
                    "type": "int128"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "name": "points_type_weight",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "name": "points_weight",
            "outputs": [
                {
                    "components": [
                        {
                            "internalType": "uint256",
                            "name": "bias",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "slope",
                            "type": "uint256"
                        }
                    ],
                    "internalType": "struct IFraxGaugeController.Point",
                    "name": "",
                    "type": "tuple"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "name": "time_sum",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "time_total",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "name": "time_type_weight",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "time_weight",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "token",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "name": "vote_for_gauge_weights",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "vote_user_power",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "vote_user_slopes",
            "outputs": [
                {
                    "components": [
                        {
                            "internalType": "uint256",
                            "name": "slope",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "power",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "end",
                            "type": "uint256"
                        }
                    ],
                    "internalType": "struct IFraxGaugeController.VotedSlope",
                    "name": "",
                    "type": "tuple"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "voting_escrow",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        }
    ],
    "IFraxGaugeFXSRewardsDistributor": [
        {
            "inputs": [],
            "name": "acceptOwnership",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "curator_address",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "gauge_address",
                    "type": "address"
                }
            ],
            "name": "currentReward",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "reward_amount",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "gauge_address",
                    "type": "address"
                }
            ],
            "name": "distributeReward",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "weeks_elapsed",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "reward_tally",
                    "type": "uint256"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "distributionsOn",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "gauge_whitelist",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "is_middleman",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "last_time_gauge_paid",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_owner",
                    "type": "address"
                }
            ],
            "name": "nominateNewOwner",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "nominatedOwner",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "owner",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "tokenAddress",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "tokenAmount",
                    "type": "uint256"
                }
            ],
            "name": "recoverERC20",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_new_curator_address",
                    "type": "address"
                }
            ],
            "name": "setCurator",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_gauge_controller_address",
                    "type": "address"
                }
            ],
            "name": "setGaugeController",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_gauge_address",
                    "type": "address"
                },
                {
                    "internalType": "bool",
                    "name": "_is_middleman",
                    "type": "bool"
                },
                {
                    "internalType": "bool",
                    "name": "_is_active",
                    "type": "bool"
                }
            ],
            "name": "setGaugeState",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_new_timelock",
                    "type": "address"
                }
            ],
            "name": "setTimelock",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "timelock_address",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "toggleDistributions",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        }
    ],
    "StakingRewardsMultiGauge": [
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_stakingToken",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "_rewards_distributor_address",
                    "type": "address"
                },
                {
                    "internalType": "string[]",
                    "name": "_rewardSymbols",
                    "type": "string[]"
                },
                {
                    "internalType": "address[]",
                    "name": "_rewardTokens",
                    "type": "address[]"
                },
                {
                    "internalType": "address[]",
                    "name": "_rewardManagers",
                    "type": "address[]"
                },
                {
                    "internalType": "uint256[]",
                    "name": "_rewardRatesManual",
                    "type": "uint256[]"
                },
                {
                    "internalType": "address[]",
                    "name": "_gaugeControllers",
                    "type": "address[]"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "constructor"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "token",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "rewardRates",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "rewardsDuration",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "num_periods_elapsed",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "balance",
                    "type": "uint256"
                }
            ],
            "name": "NoEnoughReward",
            "type": "error"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "multiplier",
                    "type": "uint256"
                }
            ],
            "name": "LockedStakeMaxMultiplierUpdated",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "secs",
                    "type": "uint256"
                }
            ],
            "name": "LockedStakeMinTime",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "secs",
                    "type": "uint256"
                }
            ],
            "name": "LockedStakeTimeForMaxMultiplier",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "multiplier",
                    "type": "uint256"
                }
            ],
            "name": "MaxVeSumerMultiplier",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "previousOwner",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "newOwner",
                    "type": "address"
                }
            ],
            "name": "OwnershipTransferStarted",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "previousOwner",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "newOwner",
                    "type": "address"
                }
            ],
            "name": "OwnershipTransferred",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "destination_address",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "token",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                }
            ],
            "name": "Recovered",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "user",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "reward",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "token_address",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "destination_address",
                    "type": "address"
                }
            ],
            "name": "RewardPaid",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "newDuration",
                    "type": "uint256"
                }
            ],
            "name": "RewardsDurationUpdated",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "token",
                    "type": "address"
                }
            ],
            "name": "RewardsPeriodRenewed",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "user",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "secs",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "bytes32",
                    "name": "kek_id",
                    "type": "bytes32"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "source_address",
                    "type": "address"
                }
            ],
            "name": "StakeLocked",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "user",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "bytes32",
                    "name": "kek_id",
                    "type": "bytes32"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "destination_address",
                    "type": "address"
                }
            ],
            "name": "WithdrawLocked",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "scale_factor",
                    "type": "uint256"
                }
            ],
            "name": "veSumerPerUsdForMaxBoostUpdated",
            "type": "event"
        },
        {
            "inputs": [],
            "name": "MULTIPLIER_PRECISION",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "acceptOwnership",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "migrator_address",
                    "type": "address"
                }
            ],
            "name": "addMigrator",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "calcCurCombinedWeight",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "old_combined_weight",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "new_veSumer_multiplier",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "new_combined_weight",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "reward_token_address",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "new_manager_address",
                    "type": "address"
                }
            ],
            "name": "changeTokenManager",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "combinedWeightOf",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "earned",
            "outputs": [
                {
                    "internalType": "uint256[]",
                    "name": "new_earned",
                    "type": "uint256[]"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "name": "gaugeControllers",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "getAllRewardTokens",
            "outputs": [
                {
                    "internalType": "address[]",
                    "name": "",
                    "type": "address[]"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "getReward",
            "outputs": [
                {
                    "internalType": "uint256[]",
                    "name": "",
                    "type": "uint256[]"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "getRewardForDuration",
            "outputs": [
                {
                    "internalType": "uint256[]",
                    "name": "rewards_per_duration_arr",
                    "type": "uint256[]"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "getRewardSymbols",
            "outputs": [
                {
                    "internalType": "string[]",
                    "name": "",
                    "type": "string[]"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "greylist",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_address",
                    "type": "address"
                }
            ],
            "name": "greylistAddress",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "caller_addr",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "reward_token_addr",
                    "type": "address"
                }
            ],
            "name": "isTokenManagerFor",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "lastUpdateTime",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "secs",
                    "type": "uint256"
                }
            ],
            "name": "lockMultiplier",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "lock_max_multiplier",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "lock_time_for_max_multiplier",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "lock_time_min",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "lockedLiquidityOf",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "lockedStakesOf",
            "outputs": [
                {
                    "components": [
                        {
                            "internalType": "bytes32",
                            "name": "kek_id",
                            "type": "bytes32"
                        },
                        {
                            "internalType": "uint256",
                            "name": "start_timestamp",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "liquidity",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "ending_timestamp",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "lock_multiplier",
                            "type": "uint256"
                        }
                    ],
                    "internalType": "struct StakingRewardsMultiGauge.LockedStake[]",
                    "name": "",
                    "type": "tuple[]"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "migrationsOn",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "staker_address",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "secs",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "start_timestamp",
                    "type": "uint256"
                }
            ],
            "name": "migrator_stakeLocked_for",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "staker_address",
                    "type": "address"
                },
                {
                    "internalType": "bytes32",
                    "name": "kek_id",
                    "type": "bytes32"
                }
            ],
            "name": "migrator_withdraw_locked",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "minVeSumerForMaxBoost",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "owner",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "pendingOwner",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "periodFinish",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "tokenAddress",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "tokenAmount",
                    "type": "uint256"
                }
            ],
            "name": "recoverERC20",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "migrator_address",
                    "type": "address"
                }
            ],
            "name": "removeMigrator",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "renounceOwnership",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "rewardManagers",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "token_idx",
                    "type": "uint256"
                }
            ],
            "name": "rewardRates",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "rwd_rate",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "name": "rewardRatesManual",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "name": "rewardSymbols",
            "outputs": [
                {
                    "internalType": "string",
                    "name": "",
                    "type": "string"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "rewardTokenAddrToIdx",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "name": "rewardTokens",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "rewardsCollectionPaused",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "rewardsDuration",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "rewardsPerToken",
            "outputs": [
                {
                    "internalType": "uint256[]",
                    "name": "newRewardsPerTokenStored",
                    "type": "uint256[]"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "rewards_distributor",
            "outputs": [
                {
                    "internalType": "contract IFraxGaugeFXSRewardsDistributor",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "reward_token_address",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "_rewards_distributor_address",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "_gauge_controller_address",
                    "type": "address"
                },
                {
                    "internalType": "bool",
                    "name": "sync_too",
                    "type": "bool"
                }
            ],
            "name": "setGaugeController",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "_lock_time_for_max_multiplier",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "_lock_time_min",
                    "type": "uint256"
                }
            ],
            "name": "setLockedStakeTimeForMinAndMaxMultiplier",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "_lock_max_multiplier",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "_veSumer_max_multiplier",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "_veSumer_per_usd_for_max_boost",
                    "type": "uint256"
                }
            ],
            "name": "setMultipliers",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "reward_token_address",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "new_rate",
                    "type": "uint256"
                },
                {
                    "internalType": "bool",
                    "name": "sync_too",
                    "type": "bool"
                }
            ],
            "name": "setRewardRate",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "_rewardsDuration",
                    "type": "uint256"
                }
            ],
            "name": "setRewardsDuration",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "liquidity",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "secs",
                    "type": "uint256"
                }
            ],
            "name": "stakeLocked",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "migrator_address",
                    "type": "address"
                }
            ],
            "name": "stakerAllowMigrator",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "migrator_address",
                    "type": "address"
                }
            ],
            "name": "stakerDisallowMigrator",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "staker_allowed_migrators",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "stakesUnlocked",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "stakingPaused",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "stakingToken",
            "outputs": [
                {
                    "internalType": "contract IUniswapV2Pair",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "sync",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bool",
                    "name": "force_update",
                    "type": "bool"
                }
            ],
            "name": "sync_gauge_weights",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "toggleMigrations",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "toggleRewardsCollection",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "toggleStaking",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "toggleWithdrawals",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "totalCombinedWeight",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "totalLiquidityLocked",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "newOwner",
                    "type": "address"
                }
            ],
            "name": "transferOwnership",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "unlockStakes",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "usdPerLPToken",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "usd_address",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "userStakedUsd",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "valid_migrators",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "veSumerMultiplier",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "veSumer_max_multiplier",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "veSumer_per_usd_for_max_boost",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "kek_id",
                    "type": "bytes32"
                }
            ],
            "name": "withdrawLocked",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "withdrawalsPaused",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        }
    ],
    "TransferHelper": [],
    "SmartWalletChecker": [
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "addr",
                    "type": "address"
                }
            ],
            "name": "check",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        }
    ],
    "VeSumer": [
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "sumer",
                    "type": "address"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "constructor"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "admin",
                    "type": "address"
                }
            ],
            "name": "AcceptOwnership",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "bool",
                    "name": "appIncreaseAmountForsEnabled",
                    "type": "bool"
                }
            ],
            "name": "AppIncreaseAmountForsToggled",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "provider",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "payer_addr",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "value",
                    "type": "uint256"
                },
                {
                    "indexed": true,
                    "internalType": "uint256",
                    "name": "locktime",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "int128",
                    "name": "_type",
                    "type": "int128"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "ts",
                    "type": "uint256"
                }
            ],
            "name": "Deposit",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "proxy_address",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "bool",
                    "name": "enabled",
                    "type": "bool"
                }
            ],
            "name": "HistoricalProxyToggled",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "proxy_address",
                    "type": "address"
                }
            ],
            "name": "LendingProxySet",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "admin",
                    "type": "address"
                }
            ],
            "name": "NominateOwnership",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "previousOwner",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "newOwner",
                    "type": "address"
                }
            ],
            "name": "OwnershipTransferStarted",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "previousOwner",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "newOwner",
                    "type": "address"
                }
            ],
            "name": "OwnershipTransferred",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "staker_addr",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "proxy_addr",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "add_amt",
                    "type": "uint256"
                }
            ],
            "name": "ProxyAdd",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "bool",
                    "name": "proxyAddsEnabled",
                    "type": "bool"
                }
            ],
            "name": "ProxyAddsToggled",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "bool",
                    "name": "proxySlashesEnabled",
                    "type": "bool"
                }
            ],
            "name": "ProxySlashesToggled",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "bool",
                    "name": "appTransferFromsEnabled",
                    "type": "bool"
                }
            ],
            "name": "ProxyTransferFromsToggled",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "bool",
                    "name": "appTransferTosEnabled",
                    "type": "bool"
                }
            ],
            "name": "ProxyTransferTosToggled",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "smart_wallet_checker",
                    "type": "address"
                }
            ],
            "name": "SmartWalletCheckerApplied",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "future_smart_wallet_checker",
                    "type": "address"
                }
            ],
            "name": "SmartWalletCheckerComitted",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "proxy_address",
                    "type": "address"
                }
            ],
            "name": "StakerProxySet",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "prevSupply",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "supply",
                    "type": "uint256"
                }
            ],
            "name": "Supply",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "app_addr",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "staker_addr",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "transfer_amt",
                    "type": "uint256"
                }
            ],
            "name": "TransferFromApp",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "provider",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "to_addr",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "value",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "ts",
                    "type": "uint256"
                }
            ],
            "name": "Withdraw",
            "type": "event"
        },
        {
            "inputs": [],
            "name": "CHECKPOINT_ONLY",
            "outputs": [
                {
                    "internalType": "int128",
                    "name": "",
                    "type": "int128"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "CREATE_LOCK_TYPE",
            "outputs": [
                {
                    "internalType": "int128",
                    "name": "",
                    "type": "int128"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "DEPOSIT_FOR_TYPE",
            "outputs": [
                {
                    "internalType": "int128",
                    "name": "",
                    "type": "int128"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "INCREASE_LOCK_AMOUNT",
            "outputs": [
                {
                    "internalType": "int128",
                    "name": "",
                    "type": "int128"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "INCREASE_UNLOCK_TIME",
            "outputs": [
                {
                    "internalType": "int128",
                    "name": "",
                    "type": "int128"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "MAXTIME",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "MAXTIME_I128",
            "outputs": [
                {
                    "internalType": "int128",
                    "name": "",
                    "type": "int128"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "MULTIPLIER",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "PROXY_ADD",
            "outputs": [
                {
                    "internalType": "int128",
                    "name": "",
                    "type": "int128"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "PROXY_SLASH",
            "outputs": [
                {
                    "internalType": "int128",
                    "name": "",
                    "type": "int128"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "TRANSFER_FROM_APP",
            "outputs": [
                {
                    "internalType": "int128",
                    "name": "",
                    "type": "int128"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "USER_WITHDRAW",
            "outputs": [
                {
                    "internalType": "int128",
                    "name": "",
                    "type": "int128"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "VOTE_WEIGHT_MULTIPLIER_I128",
            "outputs": [
                {
                    "internalType": "int128",
                    "name": "",
                    "type": "int128"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "WEEK",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "ZERO_ADDRESS",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "acceptOwnership",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "admin",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "appIncreaseAmountForsEnabled",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "appTransferFromsEnabled",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "appTransferTosEnabled",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "apply_smart_wallet_checker",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "addr",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "_t",
                    "type": "uint256"
                }
            ],
            "name": "balanceOf",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "addr",
                    "type": "address"
                }
            ],
            "name": "balanceOf",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "addr",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "_block",
                    "type": "uint256"
                }
            ],
            "name": "balanceOfAt",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "checkpoint",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_staker_addr",
                    "type": "address"
                }
            ],
            "name": "checkpoint_user",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "addr",
                    "type": "address"
                }
            ],
            "name": "commit_smart_wallet_checker",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "_value",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "_unlock_time",
                    "type": "uint256"
                }
            ],
            "name": "create_lock",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "curr_period_start",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "current_proxy",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "decimals",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_addr",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "_value",
                    "type": "uint256"
                }
            ],
            "name": "deposit_for",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "emergencyUnlockActive",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "epoch",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "future_admin",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "future_smart_wallet_checker",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "get_last_point",
            "outputs": [
                {
                    "components": [
                        {
                            "internalType": "int128",
                            "name": "bias",
                            "type": "int128"
                        },
                        {
                            "internalType": "int128",
                            "name": "slope",
                            "type": "int128"
                        },
                        {
                            "internalType": "uint256",
                            "name": "ts",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "blk",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "sumer_amt",
                            "type": "uint256"
                        }
                    ],
                    "internalType": "struct Point",
                    "name": "",
                    "type": "tuple"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "addr",
                    "type": "address"
                }
            ],
            "name": "get_last_user_bias",
            "outputs": [
                {
                    "internalType": "int128",
                    "name": "",
                    "type": "int128"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "addr",
                    "type": "address"
                }
            ],
            "name": "get_last_user_point",
            "outputs": [
                {
                    "components": [
                        {
                            "internalType": "int128",
                            "name": "bias",
                            "type": "int128"
                        },
                        {
                            "internalType": "int128",
                            "name": "slope",
                            "type": "int128"
                        },
                        {
                            "internalType": "uint256",
                            "name": "ts",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "blk",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "sumer_amt",
                            "type": "uint256"
                        }
                    ],
                    "internalType": "struct Point",
                    "name": "",
                    "type": "tuple"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "addr",
                    "type": "address"
                }
            ],
            "name": "get_last_user_slope",
            "outputs": [
                {
                    "internalType": "int128",
                    "name": "",
                    "type": "int128"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "historical_proxies",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "_value",
                    "type": "uint256"
                }
            ],
            "name": "increase_amount",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_staker_addr",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "_value",
                    "type": "uint256"
                }
            ],
            "name": "increase_amount_for",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "_unlock_time",
                    "type": "uint256"
                }
            ],
            "name": "increase_unlock_time",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "locked",
            "outputs": [
                {
                    "internalType": "int128",
                    "name": "amount",
                    "type": "int128"
                },
                {
                    "internalType": "uint256",
                    "name": "end",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_addr",
                    "type": "address"
                }
            ],
            "name": "locked__amount",
            "outputs": [
                {
                    "internalType": "int128",
                    "name": "",
                    "type": "int128"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_addr",
                    "type": "address"
                }
            ],
            "name": "locked__end",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "name",
            "outputs": [
                {
                    "internalType": "string",
                    "name": "",
                    "type": "string"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "next_period_start",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "owner",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "pendingOwner",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "name": "point_history",
            "outputs": [
                {
                    "internalType": "int128",
                    "name": "bias",
                    "type": "int128"
                },
                {
                    "internalType": "int128",
                    "name": "slope",
                    "type": "int128"
                },
                {
                    "internalType": "uint256",
                    "name": "ts",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "blk",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "sumer_amt",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "proxyAddsEnabled",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "proxySlashesEnabled",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_staker_addr",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "_add_amt",
                    "type": "uint256"
                }
            ],
            "name": "proxy_add",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_staker_addr",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "_slash_amt",
                    "type": "uint256"
                }
            ],
            "name": "proxy_slash",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "token_addr",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                }
            ],
            "name": "recoverERC20",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "renounceOwnership",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "name": "slope_changes",
            "outputs": [
                {
                    "internalType": "int128",
                    "name": "",
                    "type": "int128"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "smart_wallet_checker",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "staker_whitelisted_proxy",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "supply",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "symbol",
            "outputs": [
                {
                    "internalType": "string",
                    "name": "",
                    "type": "string"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "token",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "totalSupply",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "t",
                    "type": "uint256"
                }
            ],
            "name": "totalSupply",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "_block",
                    "type": "uint256"
                }
            ],
            "name": "totalSupplyAt",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "newOwner",
                    "type": "address"
                }
            ],
            "name": "transferOwnership",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_staker_addr",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "_app_addr",
                    "type": "address"
                },
                {
                    "internalType": "int128",
                    "name": "_transfer_amt",
                    "type": "int128"
                }
            ],
            "name": "transfer_from_app",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "user_point_epoch",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "name": "user_point_history",
            "outputs": [
                {
                    "internalType": "int128",
                    "name": "bias",
                    "type": "int128"
                },
                {
                    "internalType": "int128",
                    "name": "slope",
                    "type": "int128"
                },
                {
                    "internalType": "uint256",
                    "name": "ts",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "blk",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "sumer_amt",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_addr",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "_idx",
                    "type": "uint256"
                }
            ],
            "name": "user_point_history__ts",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "user_proxy_balance",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "version",
            "outputs": [
                {
                    "internalType": "string",
                    "name": "",
                    "type": "string"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "withdraw",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        }
    ],
    "ComptrollerV1": [
        {
            "inputs": [],
            "stateMutability": "nonpayable",
            "type": "constructor"
        },
        {
            "inputs": [],
            "name": "AddReservesMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "AddReservesOverflow",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "BorrowAndDepositBackFailed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "BorrowCapReached",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "BorrowCashNotAvailable",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "BorrowMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "BorrowPaused",
            "type": "error"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "usdThreshold",
                    "type": "uint256"
                }
            ],
            "name": "BorrowValueMustBeLargerThanThreshold",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "CantExitMarketWithNonZeroBorrowBalance",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "CantSweepUnderlying",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ComptrollerMismatch",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "EitherAssetOrDebtMustBeZero",
            "type": "error"
        },
        {
            "inputs": [
                {
                    "internalType": "uint8",
                    "name": "groupId",
                    "type": "uint8"
                },
                {
                    "internalType": "uint256",
                    "name": "cDepositVal",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "suDepositVal",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "cBorrowVal",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "suBorrowVal",
                    "type": "uint256"
                }
            ],
            "name": "EitherAssetOrDebtMustBeZeroInGroup",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ExpiredSignature",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "GroupIdMismatch",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InsufficientCollateral",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InsufficientShortfall",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidAddress",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidAmount",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidCloseFactor",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidComptroller",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidDiscountRate",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidExchangeRate",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidGroupId",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidInput",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidInterestRateModel",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidMinSuBorrowValue",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidReduceAmount",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidReserveFactor",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidSignatureForRedeemFaceValue",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidSignatureLength",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidSuToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateBorrow_LiquidatorIsBorrower",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateBorrow_RepayAmountIsMax",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateBorrow_RepayAmountIsZero",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateBorrow_SeizeTooMuch",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateCollateralMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketAlreadyListed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketCanOnlyInitializeOnce",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketNotListed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MinDelayNotReached",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MintMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MintPaused",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NoRedemptionProvider",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotCToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotEnoughForSeize",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotLiquidatableYet",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotSuToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OneOfRedeemTokensAndRedeemAmountMustBeZero",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyAdmin",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyAdminOrCapper",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyAdminOrPauser",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyCToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyListedCToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyPendingAdmin",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyRedemptionManager",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "PriceError",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ProtectedMint_OnlyAllowAssetsInTheSameGroup",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ProtocolIsPaused",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RedeemMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RedeemTransferOutNotPossible",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RedemptionSeizeTooMuch",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RedemptionSignerNotInitialized",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ReduceReservesCashNotAvailable",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ReduceReservesMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ReduceReservesOverflow",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RepayBorrowMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SeizePaused",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "Seize_LiquidatorIsBorrower",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SenderMustBeCToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SetInterestRateModelMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SetReservesFactorMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SupplyCapReached",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TokenInOrAmountInMustBeZero",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TokenTransferInFailed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TokenTransferOutFailed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TooMuchRepay",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TransferNotAllowed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TransferPaused",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "UnderlyingBalanceError",
            "type": "error"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "string",
                    "name": "action",
                    "type": "string"
                },
                {
                    "indexed": false,
                    "internalType": "bool",
                    "name": "pauseState",
                    "type": "bool"
                }
            ],
            "name": "ActionPaused",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "uint8",
                    "name": "version",
                    "type": "uint8"
                }
            ],
            "name": "Initialized",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "MarketEntered",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "MarketExited",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                }
            ],
            "name": "MarketListed",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "oldAddress",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "newAddress",
                    "type": "address"
                }
            ],
            "name": "NewAccountLiquidity",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "uint8",
                    "name": "groupId",
                    "type": "uint8"
                },
                {
                    "indexed": true,
                    "internalType": "string",
                    "name": "groupName",
                    "type": "string"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "intraCRateMantissa",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "intraMintRateMantissa",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "intraSuRateMantissa",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "interCRateMantissa",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "interSuRateMantissa",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint8",
                    "name": "assetsGroupNum",
                    "type": "uint8"
                }
            ],
            "name": "NewAssetGroup",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "newBorrowCap",
                    "type": "uint256"
                }
            ],
            "name": "NewBorrowCap",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "oldBorrowCapGuardian",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "newBorrowCapGuardian",
                    "type": "address"
                }
            ],
            "name": "NewBorrowCapGuardian",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "oldCloseFactorMantissa",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "newCloseFactorMantissa",
                    "type": "uint256"
                }
            ],
            "name": "NewCloseFactor",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "oldAddress",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "newAddress",
                    "type": "address"
                }
            ],
            "name": "NewCompLogic",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "oldHeteroIncentive",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "newHeteroIncentive",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "oldHomoIncentive",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "newHomoIncentive",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "oldSutokenIncentive",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "newSutokenIncentive",
                    "type": "uint256"
                }
            ],
            "name": "NewLiquidationIncentive",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "oldValue",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "newValue",
                    "type": "uint256"
                }
            ],
            "name": "NewMinCloseValue",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "oldValue",
                    "type": "uint256"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "newValue",
                    "type": "uint256"
                }
            ],
            "name": "NewMinSuBorrowValue",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "uint48",
                    "name": "oldValue",
                    "type": "uint48"
                },
                {
                    "indexed": false,
                    "internalType": "uint48",
                    "name": "newValue",
                    "type": "uint48"
                }
            ],
            "name": "NewMinWaitBeforeLiquidatable",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "oldPauseGuardian",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "newPauseGuardian",
                    "type": "address"
                }
            ],
            "name": "NewPauseGuardian",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "oldPriceOracle",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "newPriceOracle",
                    "type": "address"
                }
            ],
            "name": "NewPriceOracle",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "oldAddress",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "newAddress",
                    "type": "address"
                }
            ],
            "name": "NewRedemptionManager",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "uint8",
                    "name": "groupId",
                    "type": "uint8"
                },
                {
                    "indexed": false,
                    "internalType": "uint8",
                    "name": "equalAssetsGroupNum",
                    "type": "uint8"
                }
            ],
            "name": "RemoveAssetGroup",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "indexed": true,
                    "internalType": "bytes32",
                    "name": "previousAdminRole",
                    "type": "bytes32"
                },
                {
                    "indexed": true,
                    "internalType": "bytes32",
                    "name": "newAdminRole",
                    "type": "bytes32"
                }
            ],
            "name": "RoleAdminChanged",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "sender",
                    "type": "address"
                }
            ],
            "name": "RoleGranted",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "sender",
                    "type": "address"
                }
            ],
            "name": "RoleRevoked",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                }
            ],
            "name": "SetMaxSupply",
            "type": "event"
        },
        {
            "inputs": [],
            "name": "CAPPER_ROLE",
            "outputs": [
                {
                    "internalType": "bytes32",
                    "name": "",
                    "type": "bytes32"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "COMP_LOGIC",
            "outputs": [
                {
                    "internalType": "bytes32",
                    "name": "",
                    "type": "bytes32"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "DEFAULT_ADMIN_ROLE",
            "outputs": [
                {
                    "internalType": "bytes32",
                    "name": "",
                    "type": "bytes32"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "PAUSER_ROLE",
            "outputs": [
                {
                    "internalType": "bytes32",
                    "name": "",
                    "type": "bytes32"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "_borrowGuardianPaused",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "_getBorrowCapGuardian",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "_getPauseGuardian",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "_mintGuardianPaused",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "newBorrowCapGuardian",
                    "type": "address"
                }
            ],
            "name": "_setBorrowCapGuardian",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "contract ICToken",
                    "name": "cToken",
                    "type": "address"
                },
                {
                    "internalType": "bool",
                    "name": "state",
                    "type": "bool"
                }
            ],
            "name": "_setBorrowPaused",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "newCloseFactorMantissa",
                    "type": "uint256"
                }
            ],
            "name": "_setCloseFactor",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "newHeteroLiquidationIncentiveMantissa",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "newHomoLiquidationIncentiveMantissa",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "newSutokenLiquidationIncentiveMantissa",
                    "type": "uint256"
                }
            ],
            "name": "_setLiquidationIncentive",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "contract ICToken[]",
                    "name": "cTokens",
                    "type": "address[]"
                },
                {
                    "internalType": "uint256[]",
                    "name": "newBorrowCaps",
                    "type": "uint256[]"
                }
            ],
            "name": "_setMarketBorrowCaps",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "contract ICToken[]",
                    "name": "cTokens",
                    "type": "address[]"
                },
                {
                    "internalType": "uint256[]",
                    "name": "newMaxSupplys",
                    "type": "uint256[]"
                }
            ],
            "name": "_setMaxSupply",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "contract ICToken",
                    "name": "cToken",
                    "type": "address"
                },
                {
                    "internalType": "bool",
                    "name": "state",
                    "type": "bool"
                }
            ],
            "name": "_setMintPaused",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "newPauseGuardian",
                    "type": "address"
                }
            ],
            "name": "_setPauseGuardian",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "contract IPriceOracle",
                    "name": "newOracle",
                    "type": "address"
                }
            ],
            "name": "_setPriceOracle",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bool",
                    "name": "state",
                    "type": "bool"
                }
            ],
            "name": "_setProtocolPaused",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bool",
                    "name": "state",
                    "type": "bool"
                }
            ],
            "name": "_setSeizePaused",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bool",
                    "name": "state",
                    "type": "bool"
                }
            ],
            "name": "_setTransferPaused",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                },
                {
                    "internalType": "uint8",
                    "name": "groupId",
                    "type": "uint8"
                },
                {
                    "internalType": "uint256",
                    "name": "borrowCap",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "supplyCap",
                    "type": "uint256"
                }
            ],
            "name": "_supportMarket",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "name": "accountAssets",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "accountLiquidity",
            "outputs": [
                {
                    "internalType": "contract IAccountLiquidity",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "name": "allMarkets",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint8",
                    "name": "",
                    "type": "uint8"
                }
            ],
            "name": "assetGroupIdToIndex",
            "outputs": [
                {
                    "internalType": "uint8",
                    "name": "",
                    "type": "uint8"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "borrower",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "borrowAmount",
                    "type": "uint256"
                }
            ],
            "name": "borrowAllowed",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "borrowCapGuardian",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "borrowCaps",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "borrowGuardianPaused",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "borrower",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "borrowAmount",
                    "type": "uint256"
                }
            ],
            "name": "borrowVerify",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                }
            ],
            "name": "checkMembership",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "cleanAssetGroup",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "closeFactorMantissa",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "compLogic",
            "outputs": [
                {
                    "internalType": "contract ICompLogic",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address[]",
                    "name": "cTokens",
                    "type": "address[]"
                }
            ],
            "name": "enterMarkets",
            "outputs": [
                {
                    "internalType": "uint256[]",
                    "name": "",
                    "type": "uint256[]"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address[]",
                    "name": "accounts",
                    "type": "address[]"
                }
            ],
            "name": "enterMarketsForAll",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cTokenAddress",
                    "type": "address"
                }
            ],
            "name": "exitMarket",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "getAccountLiquidity",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "cTokenTarget",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "intraSafeLimitMantissa",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "interSafeLimitMantissa",
                    "type": "uint256"
                }
            ],
            "name": "getAccountSafeLimit",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "getAllAssetGroup",
            "outputs": [
                {
                    "components": [
                        {
                            "internalType": "uint8",
                            "name": "groupId",
                            "type": "uint8"
                        },
                        {
                            "internalType": "string",
                            "name": "groupName",
                            "type": "string"
                        },
                        {
                            "internalType": "uint256",
                            "name": "intraCRateMantissa",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "intraMintRateMantissa",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "intraSuRateMantissa",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "interCRateMantissa",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "interSuRateMantissa",
                            "type": "uint256"
                        },
                        {
                            "internalType": "bool",
                            "name": "exist",
                            "type": "bool"
                        }
                    ],
                    "internalType": "struct IComptroller.AssetGroup[]",
                    "name": "",
                    "type": "tuple[]"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "getAllMarkets",
            "outputs": [
                {
                    "internalType": "address[]",
                    "name": "",
                    "type": "address[]"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint8",
                    "name": "groupId",
                    "type": "uint8"
                }
            ],
            "name": "getAssetGroup",
            "outputs": [
                {
                    "components": [
                        {
                            "internalType": "uint8",
                            "name": "groupId",
                            "type": "uint8"
                        },
                        {
                            "internalType": "string",
                            "name": "groupName",
                            "type": "string"
                        },
                        {
                            "internalType": "uint256",
                            "name": "intraCRateMantissa",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "intraMintRateMantissa",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "intraSuRateMantissa",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "interCRateMantissa",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "interSuRateMantissa",
                            "type": "uint256"
                        },
                        {
                            "internalType": "bool",
                            "name": "exist",
                            "type": "bool"
                        }
                    ],
                    "internalType": "struct IComptroller.AssetGroup",
                    "name": "",
                    "type": "tuple"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint8",
                    "name": "groupIndex",
                    "type": "uint8"
                }
            ],
            "name": "getAssetGroupByIndex",
            "outputs": [
                {
                    "components": [
                        {
                            "internalType": "uint8",
                            "name": "groupId",
                            "type": "uint8"
                        },
                        {
                            "internalType": "string",
                            "name": "groupName",
                            "type": "string"
                        },
                        {
                            "internalType": "uint256",
                            "name": "intraCRateMantissa",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "intraMintRateMantissa",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "intraSuRateMantissa",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "interCRateMantissa",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "interSuRateMantissa",
                            "type": "uint256"
                        },
                        {
                            "internalType": "bool",
                            "name": "exist",
                            "type": "bool"
                        }
                    ],
                    "internalType": "struct IComptroller.AssetGroup",
                    "name": "",
                    "type": "tuple"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "getAssetGroupNum",
            "outputs": [
                {
                    "internalType": "uint8",
                    "name": "",
                    "type": "uint8"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "getAssetsIn",
            "outputs": [
                {
                    "internalType": "address[]",
                    "name": "",
                    "type": "address[]"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "collateralToken",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "liabilityToken",
                    "type": "address"
                }
            ],
            "name": "getCollateralRate",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "getCompAddress",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "cTokenModify",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "redeemTokens",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "borrowAmount",
                    "type": "uint256"
                }
            ],
            "name": "getHypotheticalAccountLiquidity",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                }
            ],
            "name": "getRoleAdmin",
            "outputs": [
                {
                    "internalType": "bytes32",
                    "name": "",
                    "type": "bytes32"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "internalType": "uint256",
                    "name": "index",
                    "type": "uint256"
                }
            ],
            "name": "getRoleMember",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                }
            ],
            "name": "getRoleMemberCount",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                }
            ],
            "name": "getUnderlyingPriceNormalized",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "governanceToken",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "grantRole",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "hasRole",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "heteroLiquidationIncentiveMantissa",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "homoLiquidationIncentiveMantissa",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_admin",
                    "type": "address"
                },
                {
                    "internalType": "contract IPriceOracle",
                    "name": "_oracle",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "_gov",
                    "type": "address"
                },
                {
                    "internalType": "contract ICompLogic",
                    "name": "_compLogic",
                    "type": "address"
                },
                {
                    "internalType": "contract IAccountLiquidity",
                    "name": "_accountLiquidity",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "_closeFactorMantissa",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "_heteroLiquidationIncentiveMantissa",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "_homoLiquidationIncentiveMantissa",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "_sutokenLiquidationIncentiveMantissa",
                    "type": "uint256"
                }
            ],
            "name": "initialize",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "isComptroller",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "asset",
                    "type": "address"
                }
            ],
            "name": "isListed",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "lastBorrowedAt",
            "outputs": [
                {
                    "internalType": "uint48",
                    "name": "",
                    "type": "uint48"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cTokenBorrowed",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "cTokenCollateral",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "liquidator",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "borrower",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "repayAmount",
                    "type": "uint256"
                }
            ],
            "name": "liquidateBorrowAllowed",
            "outputs": [],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "liquidationIncentiveMantissa",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "asset",
                    "type": "address"
                }
            ],
            "name": "marketGroupId",
            "outputs": [
                {
                    "internalType": "uint8",
                    "name": "",
                    "type": "uint8"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "markets",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "isListed",
                    "type": "bool"
                },
                {
                    "internalType": "uint8",
                    "name": "assetGroupId",
                    "type": "uint8"
                },
                {
                    "internalType": "bool",
                    "name": "isComped",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "maxSupply",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "minCloseValue",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "minSuBorrowValue",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "minWaitBeforeLiquidatable",
            "outputs": [
                {
                    "internalType": "uint48",
                    "name": "",
                    "type": "uint48"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "minter",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "mintAmount",
                    "type": "uint256"
                }
            ],
            "name": "mintAllowed",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "mintGuardianPaused",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "oracle",
            "outputs": [
                {
                    "internalType": "contract IPriceOracle",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "pauseGuardian",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "redeemer",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "redeemTokens",
                    "type": "uint256"
                }
            ],
            "name": "redeemAllowed",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "redemptionManager",
            "outputs": [
                {
                    "internalType": "contract IRedemptionManager",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint8",
                    "name": "groupId",
                    "type": "uint8"
                }
            ],
            "name": "removeAssetGroup",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "renounceRole",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "payer",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "borrower",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "repayAmount",
                    "type": "uint256"
                }
            ],
            "name": "repayBorrowAllowed",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "revokeRole",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cTokenCollateral",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "cTokenBorrowed",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "liquidator",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "borrower",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "seizeTokens",
                    "type": "uint256"
                }
            ],
            "name": "seizeAllowed",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "seizeGuardianPaused",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "contract IAccountLiquidity",
                    "name": "_accountLiquidity",
                    "type": "address"
                }
            ],
            "name": "setAccountLiquidity",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint8",
                    "name": "groupId",
                    "type": "uint8"
                },
                {
                    "internalType": "string",
                    "name": "groupName",
                    "type": "string"
                },
                {
                    "internalType": "uint256",
                    "name": "intraCRateMantissa",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "intraMintRateMantissa",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "intraSuRateMantissa",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "interCRateMantissa",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "interSuRateMantissa",
                    "type": "uint256"
                }
            ],
            "name": "setAssetGroup",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "contract ICompLogic",
                    "name": "_compLogic",
                    "type": "address"
                }
            ],
            "name": "setCompLogic",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "supplySpeed",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "borrowSpeed",
                    "type": "uint256"
                }
            ],
            "name": "setCompSpeed",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_governanceToken",
                    "type": "address"
                }
            ],
            "name": "setGovTokenAddress",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "_minCloseValue",
                    "type": "uint256"
                }
            ],
            "name": "setMinCloseValue",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "_minSuBorrowValue",
                    "type": "uint256"
                }
            ],
            "name": "setMinSuBorrowValue",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint48",
                    "name": "_minWaitBeforeLiquidatable",
                    "type": "uint48"
                }
            ],
            "name": "setMinWaitBeforeLiquidatable",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "contract IRedemptionManager",
                    "name": "_redemptionManager",
                    "type": "address"
                }
            ],
            "name": "setRedemptionManager",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_timelock",
                    "type": "address"
                }
            ],
            "name": "setTimelock",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "suTokenRateMantissa",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes4",
                    "name": "interfaceId",
                    "type": "bytes4"
                }
            ],
            "name": "supportsInterface",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "sutokenLiquidationIncentiveMantissa",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "timelock",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "src",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "dst",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "transferTokens",
                    "type": "uint256"
                }
            ],
            "name": "transferAllowed",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "transferGuardianPaused",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        }
    ],
    "ComptrollerV2": [
        {
            "inputs": [],
            "stateMutability": "nonpayable",
            "type": "constructor"
        },
        {
            "inputs": [],
            "name": "AddReservesMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "AddReservesOverflow",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "BorrowAndDepositBackFailed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "BorrowCapReached",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "BorrowCashNotAvailable",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "BorrowMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "BorrowPaused",
            "type": "error"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "usdThreshold",
                    "type": "uint256"
                }
            ],
            "name": "BorrowValueMustBeLargerThanThreshold",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "CantExitMarketWithNonZeroBorrowBalance",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "CantSweepUnderlying",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ComptrollerMismatch",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "EitherAssetOrDebtMustBeZero",
            "type": "error"
        },
        {
            "inputs": [
                {
                    "internalType": "uint8",
                    "name": "groupId",
                    "type": "uint8"
                },
                {
                    "internalType": "uint256",
                    "name": "cDepositVal",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "suDepositVal",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "cBorrowVal",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "suBorrowVal",
                    "type": "uint256"
                }
            ],
            "name": "EitherAssetOrDebtMustBeZeroInGroup",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ExpiredSignature",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InsufficientCollateral",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InsufficientShortfall",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidAddress",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidAmount",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidBlockNumber",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidCloseFactor",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidComptroller",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidDiscountRate",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidExchangeRate",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidGroupId",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidInput",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidInterestRateModel",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidMinSuBorrowValue",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidReduceAmount",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidReserveFactor",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidSignatureForRedeemFaceValue",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidSignatureLength",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidSuToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidTimestamp",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateBorrow_LiquidatorIsBorrower",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateBorrow_RepayAmountIsMax",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateBorrow_RepayAmountIsZero",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateBorrow_SeizeTooMuch",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateCollateralMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketAlreadyListed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketCanOnlyInitializeOnce",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketNotListed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MinDelayNotReached",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MintMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MintPaused",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NoRedemptionProvider",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotCToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotEnoughForSeize",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotLiquidatableYet",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotSuToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyAdmin",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyAdminOrPauser",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyCToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyListedCToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyPendingAdmin",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyRedemptionManager",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "PriceError",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ProtectedMint_OnlyAllowAssetsInTheSameGroup",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RedeemMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RedeemTransferOutNotPossible",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RedemptionSeizeTooMuch",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RedemptionSignerNotInitialized",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ReduceReservesCashNotAvailable",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ReduceReservesMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RepayBorrowMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SeizePaused",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "Seize_LiquidatorIsBorrower",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SenderMustBeCToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SetInterestRateModelMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SetReservesFactorMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SupplyCapReached",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TokenInOrAmountInMustBeZero",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TokenTransferInFailed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TokenTransferOutFailed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TooMuchRepay",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TransferNotAllowed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TransferPaused",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "UnderlyingBalanceError",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ZeroAddressNotAllowed",
            "type": "error"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "uint8",
                    "name": "version",
                    "type": "uint8"
                }
            ],
            "name": "Initialized",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "MarketEntered",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "MarketExited",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                }
            ],
            "name": "MarketListed",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "uint8",
                    "name": "groupId",
                    "type": "uint8"
                },
                {
                    "indexed": false,
                    "internalType": "uint16",
                    "name": "intraCRatePercent",
                    "type": "uint16"
                },
                {
                    "indexed": false,
                    "internalType": "uint16",
                    "name": "intraMintRatePercent",
                    "type": "uint16"
                },
                {
                    "indexed": false,
                    "internalType": "uint16",
                    "name": "intraSuRatePercent",
                    "type": "uint16"
                },
                {
                    "indexed": false,
                    "internalType": "uint16",
                    "name": "interCRatePercent",
                    "type": "uint16"
                },
                {
                    "indexed": false,
                    "internalType": "uint16",
                    "name": "interSuRatePercent",
                    "type": "uint16"
                }
            ],
            "name": "NewAssetGroup",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint120",
                    "name": "borrowCap",
                    "type": "uint120"
                },
                {
                    "indexed": false,
                    "internalType": "uint120",
                    "name": "supplyCap",
                    "type": "uint120"
                }
            ],
            "name": "NewCap",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "compLogic",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "redemptionManager",
                    "type": "address"
                }
            ],
            "name": "NewDependencies",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "uint16",
                    "name": "closeFactorPercent",
                    "type": "uint16"
                },
                {
                    "indexed": false,
                    "internalType": "uint32",
                    "name": "minCloseValue",
                    "type": "uint32"
                },
                {
                    "indexed": false,
                    "internalType": "uint32",
                    "name": "minSuBorrowValue",
                    "type": "uint32"
                },
                {
                    "indexed": false,
                    "internalType": "uint32",
                    "name": "minWaitBeforeLiquidatable",
                    "type": "uint32"
                },
                {
                    "indexed": false,
                    "internalType": "uint8",
                    "name": "largestGroupId",
                    "type": "uint8"
                }
            ],
            "name": "NewGlobalConfig",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "uint16",
                    "name": "heteroPercent",
                    "type": "uint16"
                },
                {
                    "indexed": false,
                    "internalType": "uint64",
                    "name": "homoPercent",
                    "type": "uint64"
                },
                {
                    "indexed": false,
                    "internalType": "uint64",
                    "name": "sutokenPercent",
                    "type": "uint64"
                }
            ],
            "name": "NewLiquidationIncentive",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "ctoken",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "bool",
                    "name": "mintPaused",
                    "type": "bool"
                },
                {
                    "indexed": false,
                    "internalType": "bool",
                    "name": "borrowPaused",
                    "type": "bool"
                },
                {
                    "indexed": false,
                    "internalType": "bool",
                    "name": "transferPaused",
                    "type": "bool"
                },
                {
                    "indexed": false,
                    "internalType": "bool",
                    "name": "seizePaused",
                    "type": "bool"
                }
            ],
            "name": "NewPause",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "oldPauseGuardian",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "newPauseGuardian",
                    "type": "address"
                }
            ],
            "name": "NewPauseGuardian",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "priceOracle",
                    "type": "address"
                }
            ],
            "name": "NewPriceOracle",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": false,
                    "internalType": "address",
                    "name": "timelock",
                    "type": "address"
                }
            ],
            "name": "NewTimelock",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "uint8",
                    "name": "groupId",
                    "type": "uint8"
                }
            ],
            "name": "RemoveAssetGroup",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "indexed": true,
                    "internalType": "bytes32",
                    "name": "previousAdminRole",
                    "type": "bytes32"
                },
                {
                    "indexed": true,
                    "internalType": "bytes32",
                    "name": "newAdminRole",
                    "type": "bytes32"
                }
            ],
            "name": "RoleAdminChanged",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "sender",
                    "type": "address"
                }
            ],
            "name": "RoleGranted",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "sender",
                    "type": "address"
                }
            ],
            "name": "RoleRevoked",
            "type": "event"
        },
        {
            "inputs": [],
            "name": "DEFAULT_ADMIN_ROLE",
            "outputs": [
                {
                    "internalType": "bytes32",
                    "name": "",
                    "type": "bytes32"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "PAUSER_ROLE",
            "outputs": [
                {
                    "internalType": "bytes32",
                    "name": "",
                    "type": "bytes32"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                },
                {
                    "internalType": "bool",
                    "name": "mintPaused",
                    "type": "bool"
                },
                {
                    "internalType": "bool",
                    "name": "borrowPaused",
                    "type": "bool"
                },
                {
                    "internalType": "bool",
                    "name": "transferPaused",
                    "type": "bool"
                },
                {
                    "internalType": "bool",
                    "name": "seizePaused",
                    "type": "bool"
                }
            ],
            "name": "_pause",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address[]",
                    "name": "cTokens",
                    "type": "address[]"
                },
                {
                    "internalType": "uint120[]",
                    "name": "borrowCaps",
                    "type": "uint120[]"
                },
                {
                    "internalType": "uint120[]",
                    "name": "supplyCaps",
                    "type": "uint120[]"
                }
            ],
            "name": "_setCaps",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "components": [
                        {
                            "internalType": "uint16",
                            "name": "closeFactorPercent",
                            "type": "uint16"
                        },
                        {
                            "internalType": "uint32",
                            "name": "minCloseValue",
                            "type": "uint32"
                        },
                        {
                            "internalType": "uint32",
                            "name": "minSuBorrowValue",
                            "type": "uint32"
                        },
                        {
                            "internalType": "uint32",
                            "name": "minWaitBeforeLiquidatable",
                            "type": "uint32"
                        },
                        {
                            "internalType": "uint8",
                            "name": "largestGroupId",
                            "type": "uint8"
                        }
                    ],
                    "internalType": "struct GlobalConfig",
                    "name": "globalConfig_",
                    "type": "tuple"
                }
            ],
            "name": "_setGlobalConfig",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_governanceToken",
                    "type": "address"
                }
            ],
            "name": "_setGovTokenAddress",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "components": [
                        {
                            "internalType": "uint16",
                            "name": "heteroPercent",
                            "type": "uint16"
                        },
                        {
                            "internalType": "uint16",
                            "name": "homoPercent",
                            "type": "uint16"
                        },
                        {
                            "internalType": "uint16",
                            "name": "sutokenPercent",
                            "type": "uint16"
                        }
                    ],
                    "internalType": "struct LiquidationIncentive",
                    "name": "liquidationIncentive_",
                    "type": "tuple"
                }
            ],
            "name": "_setLiquidationIncentive",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "newPauseGuardian",
                    "type": "address"
                }
            ],
            "name": "_setPauseGuardian",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_oracle",
                    "type": "address"
                }
            ],
            "name": "_setPriceOracle",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_timelock",
                    "type": "address"
                }
            ],
            "name": "_setTimelock",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                },
                {
                    "internalType": "uint8",
                    "name": "groupId",
                    "type": "uint8"
                },
                {
                    "internalType": "uint120",
                    "name": "borrowCap",
                    "type": "uint120"
                },
                {
                    "internalType": "uint120",
                    "name": "supplyCap",
                    "type": "uint120"
                }
            ],
            "name": "_supportMarket",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "name": "accountAssets",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "name": "allMarkets",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint8",
                    "name": "",
                    "type": "uint8"
                }
            ],
            "name": "assetGroup",
            "outputs": [
                {
                    "internalType": "uint8",
                    "name": "groupId",
                    "type": "uint8"
                },
                {
                    "internalType": "uint16",
                    "name": "intraCRatePercent",
                    "type": "uint16"
                },
                {
                    "internalType": "uint16",
                    "name": "intraMintRatePercent",
                    "type": "uint16"
                },
                {
                    "internalType": "uint16",
                    "name": "intraSuRatePercent",
                    "type": "uint16"
                },
                {
                    "internalType": "uint16",
                    "name": "interCRatePercent",
                    "type": "uint16"
                },
                {
                    "internalType": "uint16",
                    "name": "interSuRatePercent",
                    "type": "uint16"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "borrower",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "borrowAmount",
                    "type": "uint256"
                }
            ],
            "name": "borrowAllowed",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "borrower",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "borrowAmount",
                    "type": "uint256"
                }
            ],
            "name": "borrowVerify",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "compLogic",
            "outputs": [
                {
                    "internalType": "contract ICompLogic",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address[]",
                    "name": "cTokens",
                    "type": "address[]"
                }
            ],
            "name": "enterMarkets",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cTokenAddress",
                    "type": "address"
                }
            ],
            "name": "exitMarket",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "cTokenModify",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "intraSafeLimitMantissa",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "interSafeLimitMantissa",
                    "type": "uint256"
                }
            ],
            "name": "getAccountSafeLimit",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "getAllMarkets",
            "outputs": [
                {
                    "internalType": "address[]",
                    "name": "",
                    "type": "address[]"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "getAssetsIn",
            "outputs": [
                {
                    "internalType": "address[]",
                    "name": "",
                    "type": "address[]"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "cTokenModify",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "redeemTokens",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "borrowAmount",
                    "type": "uint256"
                }
            ],
            "name": "getHypotheticalAccountLiquidity",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                }
            ],
            "name": "getRoleAdmin",
            "outputs": [
                {
                    "internalType": "bytes32",
                    "name": "",
                    "type": "bytes32"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                }
            ],
            "name": "getUnderlyingPriceNormalized",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "globalConfig",
            "outputs": [
                {
                    "internalType": "uint16",
                    "name": "closeFactorPercent",
                    "type": "uint16"
                },
                {
                    "internalType": "uint32",
                    "name": "minCloseValue",
                    "type": "uint32"
                },
                {
                    "internalType": "uint32",
                    "name": "minSuBorrowValue",
                    "type": "uint32"
                },
                {
                    "internalType": "uint32",
                    "name": "minWaitBeforeLiquidatable",
                    "type": "uint32"
                },
                {
                    "internalType": "uint8",
                    "name": "largestGroupId",
                    "type": "uint8"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "governanceToken",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "grantRole",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "hasRole",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_admin",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "_gov",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "_compLogic",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "_redemptionManager",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "_timelock",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "_oracle",
                    "type": "address"
                }
            ],
            "name": "initialize",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "isComptroller",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "asset",
                    "type": "address"
                }
            ],
            "name": "isListed",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "lastBorrowedAt",
            "outputs": [
                {
                    "internalType": "uint48",
                    "name": "",
                    "type": "uint48"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cTokenBorrowed",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "cTokenCollateral",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "liquidator",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "borrower",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "repayAmount",
                    "type": "uint256"
                }
            ],
            "name": "liquidateBorrowAllowed",
            "outputs": [],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "liquidationIncentive",
            "outputs": [
                {
                    "internalType": "uint16",
                    "name": "heteroPercent",
                    "type": "uint16"
                },
                {
                    "internalType": "uint16",
                    "name": "homoPercent",
                    "type": "uint16"
                },
                {
                    "internalType": "uint16",
                    "name": "sutokenPercent",
                    "type": "uint16"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "marketConfig",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "mintPaused",
                    "type": "bool"
                },
                {
                    "internalType": "bool",
                    "name": "borrowPaused",
                    "type": "bool"
                },
                {
                    "internalType": "bool",
                    "name": "transferPaused",
                    "type": "bool"
                },
                {
                    "internalType": "bool",
                    "name": "seizePaused",
                    "type": "bool"
                },
                {
                    "internalType": "uint120",
                    "name": "borrowCap",
                    "type": "uint120"
                },
                {
                    "internalType": "uint120",
                    "name": "supplyCap",
                    "type": "uint120"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "markets",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "isListed",
                    "type": "bool"
                },
                {
                    "internalType": "uint8",
                    "name": "assetGroupId",
                    "type": "uint8"
                },
                {
                    "internalType": "bool",
                    "name": "isComped",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "minter",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "mintAmount",
                    "type": "uint256"
                }
            ],
            "name": "mintAllowed",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "oracle",
            "outputs": [
                {
                    "internalType": "contract IPriceOracle",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "pauseGuardian",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "redeemer",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "redeemTokens",
                    "type": "uint256"
                }
            ],
            "name": "redeemAllowed",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "redemptionManager",
            "outputs": [
                {
                    "internalType": "contract IRedemptionManager",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint8",
                    "name": "groupId",
                    "type": "uint8"
                }
            ],
            "name": "removeAssetGroup",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "renounceRole",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "payer",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "borrower",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "repayAmount",
                    "type": "uint256"
                }
            ],
            "name": "repayBorrowAllowed",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "revokeRole",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cTokenCollateral",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "cTokenBorrowed",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "liquidator",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "borrower",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "seizeTokens",
                    "type": "uint256"
                }
            ],
            "name": "seizeAllowed",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint8",
                    "name": "groupId",
                    "type": "uint8"
                },
                {
                    "internalType": "uint16",
                    "name": "intraCRatePercent",
                    "type": "uint16"
                },
                {
                    "internalType": "uint16",
                    "name": "intraMintRatePercent",
                    "type": "uint16"
                },
                {
                    "internalType": "uint16",
                    "name": "intraSuRatePercent",
                    "type": "uint16"
                },
                {
                    "internalType": "uint16",
                    "name": "interCRatePercent",
                    "type": "uint16"
                },
                {
                    "internalType": "uint16",
                    "name": "interSuRatePercent",
                    "type": "uint16"
                }
            ],
            "name": "setAssetGroup",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes4",
                    "name": "interfaceId",
                    "type": "bytes4"
                }
            ],
            "name": "supportsInterface",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "timelock",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "cToken",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "src",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "dst",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "transferTokens",
                    "type": "uint256"
                }
            ],
            "name": "transferAllowed",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "version",
            "outputs": [
                {
                    "internalType": "enum Version",
                    "name": "",
                    "type": "uint8"
                }
            ],
            "stateMutability": "pure",
            "type": "function"
        }
    ],
    "CompoundLensV2": [
        {
            "inputs": [],
            "name": "AddReservesMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "AddReservesOverflow",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "BorrowAndDepositBackFailed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "BorrowCapReached",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "BorrowCashNotAvailable",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "BorrowMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "BorrowPaused",
            "type": "error"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "usdThreshold",
                    "type": "uint256"
                }
            ],
            "name": "BorrowValueMustBeLargerThanThreshold",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "CantExitMarketWithNonZeroBorrowBalance",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "CantSweepUnderlying",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ComptrollerMismatch",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "EitherAssetOrDebtMustBeZero",
            "type": "error"
        },
        {
            "inputs": [
                {
                    "internalType": "uint8",
                    "name": "groupId",
                    "type": "uint8"
                },
                {
                    "internalType": "uint256",
                    "name": "cDepositVal",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "suDepositVal",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "cBorrowVal",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "suBorrowVal",
                    "type": "uint256"
                }
            ],
            "name": "EitherAssetOrDebtMustBeZeroInGroup",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ExpiredSignature",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InsufficientCollateral",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InsufficientShortfall",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidAddress",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidAmount",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidBlockNumber",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidCloseFactor",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidComptroller",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidDiscountRate",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidExchangeRate",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidGroupId",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidInput",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidInterestRateModel",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidMinSuBorrowValue",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidReduceAmount",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidReserveFactor",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidSignatureForRedeemFaceValue",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidSignatureLength",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidSuToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "InvalidTimestamp",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateBorrow_LiquidatorIsBorrower",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateBorrow_RepayAmountIsMax",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateBorrow_RepayAmountIsZero",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateBorrow_SeizeTooMuch",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateCollateralMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "LiquidateMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketAlreadyListed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketCanOnlyInitializeOnce",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MarketNotListed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MinDelayNotReached",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MintMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "MintPaused",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NoRedemptionProvider",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotCToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotEnoughForSeize",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotLiquidatableYet",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "NotSuToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyAdmin",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyAdminOrPauser",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyCToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyListedCToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyPendingAdmin",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "OnlyRedemptionManager",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "PriceError",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ProtectedMint_OnlyAllowAssetsInTheSameGroup",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RedeemMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RedeemTransferOutNotPossible",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RedemptionSeizeTooMuch",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RedemptionSignerNotInitialized",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ReduceReservesCashNotAvailable",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ReduceReservesMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "RepayBorrowMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SeizePaused",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "Seize_LiquidatorIsBorrower",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SenderMustBeCToken",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SetInterestRateModelMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SetReservesFactorMarketNotFresh",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "SupplyCapReached",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TokenInOrAmountInMustBeZero",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TokenTransferInFailed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TokenTransferOutFailed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TooMuchRepay",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TransferNotAllowed",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "TransferPaused",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "UnderlyingBalanceError",
            "type": "error"
        },
        {
            "inputs": [],
            "name": "ZeroAddressNotAllowed",
            "type": "error"
        },
        {
            "inputs": [
                {
                    "internalType": "contract ICToken",
                    "name": "cToken",
                    "type": "address"
                },
                {
                    "internalType": "address payable",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "cTokenBalances",
            "outputs": [
                {
                    "components": [
                        {
                            "internalType": "address",
                            "name": "cToken",
                            "type": "address"
                        },
                        {
                            "internalType": "bool",
                            "name": "isCToken",
                            "type": "bool"
                        },
                        {
                            "internalType": "bool",
                            "name": "isCEther",
                            "type": "bool"
                        },
                        {
                            "internalType": "uint256",
                            "name": "balanceOf",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "borrowBalanceCurrent",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "balanceOfUnderlying",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "tokenBalance",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "tokenAllowance",
                            "type": "uint256"
                        }
                    ],
                    "internalType": "struct CompoundLens.CTokenBalances",
                    "name": "",
                    "type": "tuple"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "contract ICToken[]",
                    "name": "cTokens",
                    "type": "address[]"
                },
                {
                    "internalType": "address payable",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "cTokenBalancesAll",
            "outputs": [
                {
                    "components": [
                        {
                            "internalType": "address",
                            "name": "cToken",
                            "type": "address"
                        },
                        {
                            "internalType": "bool",
                            "name": "isCToken",
                            "type": "bool"
                        },
                        {
                            "internalType": "bool",
                            "name": "isCEther",
                            "type": "bool"
                        },
                        {
                            "internalType": "uint256",
                            "name": "balanceOf",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "borrowBalanceCurrent",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "balanceOfUnderlying",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "tokenBalance",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "tokenAllowance",
                            "type": "uint256"
                        }
                    ],
                    "internalType": "struct CompoundLens.CTokenBalances[]",
                    "name": "",
                    "type": "tuple[]"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "contract ICToken",
                    "name": "cToken",
                    "type": "address"
                }
            ],
            "name": "cTokenMetadata",
            "outputs": [
                {
                    "components": [
                        {
                            "internalType": "address",
                            "name": "cToken",
                            "type": "address"
                        },
                        {
                            "internalType": "uint256",
                            "name": "exchangeRateCurrent",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "supplyRatePerBlock",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "borrowRatePerBlock",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "reserveFactorMantissa",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "totalBorrows",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "totalReserves",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "totalSupply",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "totalCash",
                            "type": "uint256"
                        },
                        {
                            "internalType": "bool",
                            "name": "isListed",
                            "type": "bool"
                        },
                        {
                            "internalType": "address",
                            "name": "underlyingAssetAddress",
                            "type": "address"
                        },
                        {
                            "internalType": "uint256",
                            "name": "cTokenDecimals",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "underlyingDecimals",
                            "type": "uint256"
                        },
                        {
                            "internalType": "bool",
                            "name": "isCToken",
                            "type": "bool"
                        },
                        {
                            "internalType": "bool",
                            "name": "isCEther",
                            "type": "bool"
                        },
                        {
                            "internalType": "uint256",
                            "name": "borrowCap",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "depositCap",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "heteroLiquidationIncentive",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "homoLiquidationIncentive",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "sutokenLiquidationIncentive",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint8",
                            "name": "groupId",
                            "type": "uint8"
                        },
                        {
                            "internalType": "uint256",
                            "name": "intraRate",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "mintRate",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "interRate",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "discountRate",
                            "type": "uint256"
                        }
                    ],
                    "internalType": "struct CompoundLens.CTokenMetadata",
                    "name": "",
                    "type": "tuple"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "contract ICToken[]",
                    "name": "cTokens",
                    "type": "address[]"
                }
            ],
            "name": "cTokenMetadataAll",
            "outputs": [
                {
                    "components": [
                        {
                            "internalType": "address",
                            "name": "cToken",
                            "type": "address"
                        },
                        {
                            "internalType": "uint256",
                            "name": "exchangeRateCurrent",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "supplyRatePerBlock",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "borrowRatePerBlock",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "reserveFactorMantissa",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "totalBorrows",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "totalReserves",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "totalSupply",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "totalCash",
                            "type": "uint256"
                        },
                        {
                            "internalType": "bool",
                            "name": "isListed",
                            "type": "bool"
                        },
                        {
                            "internalType": "address",
                            "name": "underlyingAssetAddress",
                            "type": "address"
                        },
                        {
                            "internalType": "uint256",
                            "name": "cTokenDecimals",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "underlyingDecimals",
                            "type": "uint256"
                        },
                        {
                            "internalType": "bool",
                            "name": "isCToken",
                            "type": "bool"
                        },
                        {
                            "internalType": "bool",
                            "name": "isCEther",
                            "type": "bool"
                        },
                        {
                            "internalType": "uint256",
                            "name": "borrowCap",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "depositCap",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "heteroLiquidationIncentive",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "homoLiquidationIncentive",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "sutokenLiquidationIncentive",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint8",
                            "name": "groupId",
                            "type": "uint8"
                        },
                        {
                            "internalType": "uint256",
                            "name": "intraRate",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "mintRate",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "interRate",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "discountRate",
                            "type": "uint256"
                        }
                    ],
                    "internalType": "struct CompoundLens.CTokenMetadata[]",
                    "name": "",
                    "type": "tuple[]"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "contract ICToken",
                    "name": "cToken",
                    "type": "address"
                }
            ],
            "name": "cTokenUnderlyingPrice",
            "outputs": [
                {
                    "components": [
                        {
                            "internalType": "address",
                            "name": "cToken",
                            "type": "address"
                        },
                        {
                            "internalType": "uint256",
                            "name": "underlyingPrice",
                            "type": "uint256"
                        }
                    ],
                    "internalType": "struct CompoundLens.CTokenUnderlyingPrice",
                    "name": "",
                    "type": "tuple"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "contract ICToken[]",
                    "name": "cTokens",
                    "type": "address[]"
                }
            ],
            "name": "cTokenUnderlyingPriceAll",
            "outputs": [
                {
                    "components": [
                        {
                            "internalType": "address",
                            "name": "cToken",
                            "type": "address"
                        },
                        {
                            "internalType": "uint256",
                            "name": "underlyingPrice",
                            "type": "uint256"
                        }
                    ],
                    "internalType": "struct CompoundLens.CTokenUnderlyingPrice[]",
                    "name": "",
                    "type": "tuple[]"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "cTokenCollateral",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "suToken",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "suBorrowAmount",
                    "type": "uint256"
                }
            ],
            "name": "calcBorrowAmountForProtectedMint",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "contract IComptroller",
                    "name": "comptroller",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "getAccountLimits",
            "outputs": [
                {
                    "components": [
                        {
                            "internalType": "address[]",
                            "name": "markets",
                            "type": "address[]"
                        },
                        {
                            "internalType": "uint256",
                            "name": "liquidity",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "shortfall",
                            "type": "uint256"
                        }
                    ],
                    "internalType": "struct CompoundLens.AccountLimits",
                    "name": "",
                    "type": "tuple"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "contract IComptroller",
                    "name": "comptroller",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "collateralToken",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "liabilityToken",
                    "type": "address"
                }
            ],
            "name": "getCollateralRate",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "contract ICToken",
                    "name": "comp",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "getCompBalanceMetadata",
            "outputs": [
                {
                    "components": [
                        {
                            "internalType": "uint256",
                            "name": "balance",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "votes",
                            "type": "uint256"
                        },
                        {
                            "internalType": "address",
                            "name": "delegate",
                            "type": "address"
                        }
                    ],
                    "internalType": "struct CompoundLens.CompBalanceMetadata",
                    "name": "",
                    "type": "tuple"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "contract ICToken",
                    "name": "comp",
                    "type": "address"
                },
                {
                    "internalType": "contract IComptroller",
                    "name": "comptroller",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "getCompBalanceMetadataExt",
            "outputs": [
                {
                    "components": [
                        {
                            "internalType": "uint256",
                            "name": "balance",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "votes",
                            "type": "uint256"
                        },
                        {
                            "internalType": "address",
                            "name": "delegate",
                            "type": "address"
                        },
                        {
                            "internalType": "uint256",
                            "name": "allocated",
                            "type": "uint256"
                        }
                    ],
                    "internalType": "struct CompoundLens.CompBalanceMetadataExt",
                    "name": "",
                    "type": "tuple"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "contract ICToken",
                    "name": "comp",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                },
                {
                    "internalType": "uint32[]",
                    "name": "blockNumbers",
                    "type": "uint32[]"
                }
            ],
            "name": "getCompVotes",
            "outputs": [
                {
                    "components": [
                        {
                            "internalType": "uint256",
                            "name": "blockNumber",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "votes",
                            "type": "uint256"
                        }
                    ],
                    "internalType": "struct CompoundLens.CompVotes[]",
                    "name": "",
                    "type": "tuple[]"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "contract IGovernorBravo",
                    "name": "governor",
                    "type": "address"
                },
                {
                    "internalType": "uint256[]",
                    "name": "proposalIds",
                    "type": "uint256[]"
                }
            ],
            "name": "getGovBravoProposals",
            "outputs": [
                {
                    "components": [
                        {
                            "internalType": "uint256",
                            "name": "proposalId",
                            "type": "uint256"
                        },
                        {
                            "internalType": "address",
                            "name": "proposer",
                            "type": "address"
                        },
                        {
                            "internalType": "uint256",
                            "name": "eta",
                            "type": "uint256"
                        },
                        {
                            "internalType": "address[]",
                            "name": "targets",
                            "type": "address[]"
                        },
                        {
                            "internalType": "uint256[]",
                            "name": "values",
                            "type": "uint256[]"
                        },
                        {
                            "internalType": "string[]",
                            "name": "signatures",
                            "type": "string[]"
                        },
                        {
                            "internalType": "bytes[]",
                            "name": "calldatas",
                            "type": "bytes[]"
                        },
                        {
                            "internalType": "uint256",
                            "name": "startBlock",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "endBlock",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "forVotes",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "againstVotes",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "abstainVotes",
                            "type": "uint256"
                        },
                        {
                            "internalType": "bool",
                            "name": "canceled",
                            "type": "bool"
                        },
                        {
                            "internalType": "bool",
                            "name": "executed",
                            "type": "bool"
                        }
                    ],
                    "internalType": "struct CompoundLens.GovBravoProposal[]",
                    "name": "",
                    "type": "tuple[]"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "contract IGovernorBravo",
                    "name": "governor",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "voter",
                    "type": "address"
                },
                {
                    "internalType": "uint256[]",
                    "name": "proposalIds",
                    "type": "uint256[]"
                }
            ],
            "name": "getGovBravoReceipts",
            "outputs": [
                {
                    "components": [
                        {
                            "internalType": "uint256",
                            "name": "proposalId",
                            "type": "uint256"
                        },
                        {
                            "internalType": "bool",
                            "name": "hasVoted",
                            "type": "bool"
                        },
                        {
                            "internalType": "uint8",
                            "name": "support",
                            "type": "uint8"
                        },
                        {
                            "internalType": "uint96",
                            "name": "votes",
                            "type": "uint96"
                        }
                    ],
                    "internalType": "struct CompoundLens.GovBravoReceipt[]",
                    "name": "",
                    "type": "tuple[]"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "contract IGovernorAlpha",
                    "name": "governor",
                    "type": "address"
                },
                {
                    "internalType": "uint256[]",
                    "name": "proposalIds",
                    "type": "uint256[]"
                }
            ],
            "name": "getGovProposals",
            "outputs": [
                {
                    "components": [
                        {
                            "internalType": "uint256",
                            "name": "proposalId",
                            "type": "uint256"
                        },
                        {
                            "internalType": "address",
                            "name": "proposer",
                            "type": "address"
                        },
                        {
                            "internalType": "uint256",
                            "name": "eta",
                            "type": "uint256"
                        },
                        {
                            "internalType": "address[]",
                            "name": "targets",
                            "type": "address[]"
                        },
                        {
                            "internalType": "uint256[]",
                            "name": "values",
                            "type": "uint256[]"
                        },
                        {
                            "internalType": "string[]",
                            "name": "signatures",
                            "type": "string[]"
                        },
                        {
                            "internalType": "bytes[]",
                            "name": "calldatas",
                            "type": "bytes[]"
                        },
                        {
                            "internalType": "uint256",
                            "name": "startBlock",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "endBlock",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "forVotes",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "againstVotes",
                            "type": "uint256"
                        },
                        {
                            "internalType": "bool",
                            "name": "canceled",
                            "type": "bool"
                        },
                        {
                            "internalType": "bool",
                            "name": "executed",
                            "type": "bool"
                        }
                    ],
                    "internalType": "struct CompoundLens.GovProposal[]",
                    "name": "",
                    "type": "tuple[]"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "contract IGovernorAlpha",
                    "name": "governor",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "voter",
                    "type": "address"
                },
                {
                    "internalType": "uint256[]",
                    "name": "proposalIds",
                    "type": "uint256[]"
                }
            ],
            "name": "getGovReceipts",
            "outputs": [
                {
                    "components": [
                        {
                            "internalType": "uint256",
                            "name": "proposalId",
                            "type": "uint256"
                        },
                        {
                            "internalType": "bool",
                            "name": "hasVoted",
                            "type": "bool"
                        },
                        {
                            "internalType": "bool",
                            "name": "support",
                            "type": "bool"
                        },
                        {
                            "internalType": "uint96",
                            "name": "votes",
                            "type": "uint96"
                        }
                    ],
                    "internalType": "struct CompoundLens.GovReceipt[]",
                    "name": "",
                    "type": "tuple[]"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "percentScale",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        }
    ]
};
//# sourceMappingURL=abi.js.map